/* eslint-disable */
/* eslint-disable prettier/prettier */
import * as React from 'react';
import Icon from '@ant-design/icons';

/*MOBILE APP*/
export const MenuSvg = () => {
  return (
    <svg x="0px" y="0px" viewBox="0 0 50 50" width="22px" height="22px">
      <g>
        <rect y="3" width="50" height="2" fill="#333333" />
        <rect y="17" width="50" height="2" fill="#333333" />
        <rect y="31" width="50" height="2" fill="#333333" />
        <rect y="45" width="50" height="2" fill="#333333" />
      </g>
    </svg>
  );
};

export const CancelSvg = () => {
  return (
    <svg x="0px" y="0px" viewBox="0 0 31.112 31.112" width="22px" height="22px">
      <polygon
        points="31.112,1.414 29.698,0 15.556,14.142 1.414,0 0,1.414 14.142,15.556 0,29.698 1.414,31.112 15.556,16.97   29.698,31.112 31.112,29.698 16.97,15.556 "
        fill="#333333"
      />
    </svg>
  );
};
/**/

const RidePlanSvg = () => {
  return (
    <svg
      version="1.1"
      width="25px"
      height="25px"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 1024 1024"
      style={{ enableBackground: 'new 0 0 1024 1024' }}
      xmlSpace="preserve"
    >
      <g>
        <path
          className="st0"
          d="M584.98,403.97c0-9.73,3.09-18.75,8.34-26.13C588.07,385.22,584.98,394.24,584.98,403.97
		c0,9.73,3.09,18.75,8.34,26.13C588.07,422.72,584.98,413.7,584.98,403.97z"
        />
        <path
          className="st0"
          d="M436.05,561.59c2.09-0.51,4.16-1.19,6.2-2.04l176.05-73.1l-176.05,73.1
		C440.21,560.41,438.14,561.08,436.05,561.59z"
        />
        <path
          className="st0"
          d="M671.08,423.04c2.71-5.8,4.23-12.26,4.23-19.07c0-6.81-1.52-13.27-4.23-19.07c2.71,5.8,4.23,12.26,4.23,19.07
		C675.31,410.78,673.79,417.24,671.08,423.04z"
        />
        <polygon
          className="st0"
          points="470.56,453.45 357.65,509.9 357.65,509.9 470.56,453.45 	"
        />
        <path
          className="st0"
          d="M662.43,290.7c5.44,7.41,10.38,15.24,14.73,23.36C672.81,305.94,667.87,298.11,662.43,290.7z"
        />
        <polygon
          className="st0"
          points="493.15,363.13 498.09,362.51 493.15,363.13 493.15,442.16 509.49,433.99 493.15,442.16 	"
        />
        <path
          className="st0"
          d="M394.93,59.59v0.1H253.09c-0.04,0.04-0.08,0.08-0.12,0.12h-66.7v882.62l141.01-117.59
		c7.11-5.93,17.44-5.93,24.54,0L512,958.41l160.17-133.57c7.11-5.93,17.44-5.93,24.54,0l141.02,117.59V59.81h-440.7
		C396.31,59.81,395.63,59.67,394.93,59.59z M411.6,744.75c-15.48,0-28.08-12.59-28.08-28.07s12.58-28.07,28.06-28.07h0.02
		c15.47,0,28.06,12.59,28.06,28.07S427.08,744.75,411.6,744.75z M640.93,744.75h-147.3c-18.45,0-33.46-12.59-33.46-28.07
		s15.01-28.07,33.46-28.07h147.3c18.45,0,33.46,12.59,33.46,28.07S659.38,744.75,640.93,744.75z M584.36,207.31
		c36.41,9.99,70.73,35.13,96.64,70.79c25.09,34.53,39.48,75.98,39.48,113.72l0,54.07c0,13.25-7.79,25.35-19.86,30.84
		c-0.11,0.05-0.23,0.1-0.34,0.15L450.91,580.42c-33.28,13.8-71.82-1.9-85.54-36.45c-1.3-3.28-2.63-6.91-3.96-10.7l-9.99,5
		c-1.59,0.8-3.32,1.19-5.05,1.19c-2.06,0-4.12-0.57-5.94-1.69c-3.33-2.06-5.35-5.69-5.35-9.6V370.1c0-0.22,0.06-1.2,0.08-1.36
		C348.74,256.87,464.64,174.46,584.36,207.31z"
        />
        <path
          className="st0"
          d="M109.63,155.61c0,10.57,8.6,19.16,19.16,19.16h19.16v-38.32h-19.16C118.23,136.45,109.63,145.04,109.63,155.61
		z"
        />
        <path
          className="st0"
          d="M895.21,136.45h-19.16v38.32h19.16c10.56,0,19.16-8.59,19.16-19.16C914.37,145.04,905.77,136.45,895.21,136.45
		z"
        />
        <path
          className="st1"
          d="M952.56,151.68c-2.04-30.52-28.79-53.55-59.38-53.55h-17.13V40.65c0-10.58-8.58-19.16-19.16-19.16H398.12
		c-1.08,0-2.14,0.13-3.19,0.3v-0.3H243.75h-76.64c-10.58,0-19.16,8.58-19.16,19.16v57.48h-17.13c-30.59,0-57.34,23.03-59.38,53.55
		c-2.24,33.47,24.35,61.41,57.35,61.41h19.16l0,769.7c0,5.3,1.88,10.58,5.71,14.25c7.41,7.11,18.41,7.13,25.72,1.03L339.55,864.5
		l160.17,133.57c7.11,5.93,17.44,5.93,24.55,0L684.45,864.5l160.18,133.57c3.51,2.93,7.87,4.45,12.27,4.45
		c4.72,0,9.46-1.73,13.29-5.33c3.93-3.69,5.87-9.05,5.87-14.44V213.09h19.16C928.21,213.09,954.8,185.15,952.56,151.68z
		M147.95,174.77h-19.16c-10.56,0-19.16-8.59-19.16-19.16c0-10.57,8.6-19.16,19.16-19.16h19.16V174.77z M837.73,942.43
		L696.71,824.84c-7.1-5.93-17.43-5.93-24.54,0L512,958.41L351.82,824.84c-7.1-5.93-17.43-5.93-24.54,0L186.27,942.43V59.81h66.7
		c0.04-0.04,0.08-0.08,0.12-0.12h141.84v-0.1c0.7,0.08,1.38,0.22,2.1,0.22h440.7V942.43z M895.21,174.77h-19.16v-38.32h19.16
		c10.56,0,19.16,8.59,19.16,19.16C914.37,166.18,905.77,174.77,895.21,174.77z"
        />
        <path
          className="st2"
          d="M640.93,706.43h-147.3c-8.34,0-15.65,4.79-15.65,10.25s7.31,10.25,15.65,10.25h147.3
		c8.34,0,15.65-4.79,15.65-10.25S649.26,706.43,640.93,706.43z"
        />
        <path
          className="st1"
          d="M640.93,688.61h-147.3c-18.45,0-33.46,12.59-33.46,28.07s15.01,28.07,33.46,28.07h147.3
		c18.45,0,33.46-12.59,33.46-28.07S659.38,688.61,640.93,688.61z M640.93,726.93h-147.3c-8.34,0-15.65-4.79-15.65-10.25
		s7.31-10.25,15.65-10.25h147.3c8.34,0,15.65,4.79,15.65,10.25S649.26,726.93,640.93,726.93z"
        />
        <path
          className="st2"
          d="M411.6,706.43h-0.02c-5.65,0-10.24,4.6-10.24,10.25s4.6,10.25,10.26,10.25c5.65,0,10.25-4.6,10.25-10.25
		S417.26,706.43,411.6,706.43z"
        />
        <path
          className="st1"
          d="M411.6,688.61h-0.02c-15.47,0-28.06,12.59-28.06,28.07s12.6,28.07,28.08,28.07
		c15.47,0,28.06-12.59,28.06-28.07S427.08,688.61,411.6,688.61z M411.6,726.93c-5.66,0-10.26-4.6-10.26-10.25s4.6-10.25,10.24-10.25
		h0.02c5.65,0,10.25,4.6,10.25,10.25S417.26,726.93,411.6,726.93z"
        />
        <path
          className="st1"
          d="M335.15,368.74c-0.02,0.16-0.08,1.15-0.08,1.36v158.07c0,3.91,2.03,7.55,5.35,9.6
		c1.81,1.12,3.87,1.69,5.94,1.69c1.73,0,3.46-0.39,5.05-1.19l9.99-5c1.33,3.79,2.65,7.42,3.96,10.7
		c13.73,34.54,52.26,50.25,85.54,36.45l249.37-103.55c0.12-0.05,0.23-0.1,0.34-0.15c12.06-5.48,19.86-17.59,19.86-30.84l0-54.07
		c0-37.74-14.39-79.18-39.48-113.72c-25.91-35.66-60.22-60.8-96.64-70.79C464.64,174.46,348.74,256.87,335.15,368.74z M357.65,509.9
		L357.65,509.9L357.65,509.9l0-129.84l112.91-14.11v87.5h0v0L357.65,509.9z M432.14,252.79c23.99-16.05,52.1-26.43,81.92-29.31
		c2.98-0.29,5.98-0.5,9-0.64c9.04-0.41,18.22-0.13,27.46,0.9c9.24,1.02,18.55,2.79,27.87,5.34c20.24,5.55,39.51,16.65,56.42,31.43
		c6.77,5.91,13.16,12.41,19.09,19.39c2.96,3.49,5.81,7.09,8.54,10.8c5.44,7.41,10.38,15.24,14.73,23.36
		c6,11.21,10.77,22.99,14.28,35c4.12,14.09,6.46,28.5,6.46,42.76v0l0,54.07c0,3.27-1.43,6.34-3.8,8.45c-0.79,0.7-1.69,1.3-2.67,1.77
		l-73.1,30.36l-176.05,73.1c-2.04,0.85-4.11,1.52-6.2,2.04c-2.09,0.51-4.18,0.86-6.28,1.05c-18.16,1.64-36.13-8.64-43.43-27.01
		c-0.73-1.84-1.49-3.85-2.25-5.96c-0.77-2.11-1.54-4.32-2.32-6.58l137.81-68.91c1.44-0.72,2.82-1.53,4.12-2.43
		c7.81-5.37,12.96-13.71,14.27-23.09c0.22-1.56,0.33-3.16,0.33-4.77V373.1c0-8.92-3.43-16.95-8.97-22.95
		c-2.38-2.57-5.14-4.77-8.19-6.51c-2.03-1.16-4.19-2.11-6.45-2.83c-1.28-0.41-2.59-0.72-3.92-0.97c-3.38-0.64-6.92-0.8-10.54-0.35
		L375.6,355.07l-15.58,1.95h0c1.88-8.67,4.45-17.08,7.65-25.17c2.13-5.4,4.55-10.66,7.22-15.76c5.35-10.21,11.74-19.81,19.02-28.69
		C404.83,274.08,417.75,262.42,432.14,252.79z M493.15,442.16v-79.03l4.95-0.62l4.95-0.62c0.83-0.1,1.66-0.12,2.46-0.04
		c2.41,0.22,4.63,1.22,6.39,2.75c0.58,0.51,1.12,1.08,1.59,1.71c1.41,1.87,2.26,4.21,2.26,6.79v50.79c0,3.23-1.35,6.21-3.64,8.31
		c-0.77,0.7-1.64,1.3-2.6,1.78L493.15,442.16z"
        />
        <path
          className="st1"
          d="M593.32,430.1c3.15,4.43,7.08,8.27,11.59,11.31c7.21,4.87,15.9,7.72,25.23,7.72c1.56,0,3.09-0.08,4.61-0.23
		c6.07-0.62,11.78-2.44,16.9-5.23c2.56-1.39,4.97-3.02,7.2-4.87c2.23-1.84,4.28-3.89,6.13-6.13c2.42-2.93,4.47-6.17,6.1-9.64
		c2.71-5.8,4.23-12.26,4.23-19.07c0-6.81-1.51-13.27-4.23-19.07c-1.63-3.48-3.68-6.72-6.1-9.64c-1.84-2.23-3.89-4.28-6.13-6.13
		c-2.23-1.84-4.64-3.47-7.2-4.87c-5.12-2.78-10.83-4.61-16.9-5.23c-1.52-0.15-3.05-0.23-4.61-0.23c-9.34,0-18.02,2.85-25.23,7.72
		c-4.51,3.05-8.44,6.88-11.59,11.31c-5.25,7.38-8.34,16.4-8.34,26.13S588.07,422.72,593.32,430.1z M630.14,381.39
		c3.11,0,6.08,0.63,8.78,1.78c8.1,3.43,13.8,11.47,13.8,20.8c0,9.34-5.7,17.37-13.8,20.8c-2.7,1.14-5.67,1.78-8.78,1.78
		s-6.08-0.63-8.78-1.78c-5.4-2.29-9.73-6.62-12.02-12.02c-1.14-2.7-1.78-5.67-1.78-8.78C607.56,391.52,617.69,381.39,630.14,381.39z
		"
        />
        <path
          className="st0"
          d="M621.36,424.78c2.7,1.14,5.67,1.78,8.78,1.78s6.08-0.63,8.78-1.78c8.1-3.43,13.8-11.47,13.8-20.8
		c0-9.34-5.7-17.37-13.8-20.8c-2.7-1.14-5.67-1.78-8.78-1.78c-12.45,0-22.58,10.13-22.58,22.58c0,3.11,0.63,6.08,1.78,8.78
		C611.63,418.15,615.96,422.49,621.36,424.78z"
        />
        <path
          className="st3"
          d="M367.68,331.84c-3.2,8.1-5.77,16.51-7.65,25.17h0l15.58-1.95l124.63-15.58c3.62-0.45,7.16-0.3,10.54,0.35
		c1.33,0.25,2.64,0.57,3.92,0.97c2.26,0.72,4.42,1.67,6.45,2.83c3.05,1.74,5.82,3.94,8.19,6.51c5.54,6,8.97,14.03,8.97,22.95v50.79
		c0,1.61-0.11,3.21-0.33,4.77c-1.31,9.39-6.46,17.72-14.27,23.09c-1.3,0.9-2.68,1.71-4.12,2.43l-137.81,68.91
		c0.78,2.26,1.56,4.48,2.32,6.58c0.76,2.11,1.52,4.11,2.25,5.96c7.3,18.37,25.26,28.65,43.43,27.01c2.1-0.19,4.19-0.54,6.28-1.05
		c2.09-0.51,4.16-1.19,6.2-2.04l176.05-73.1l73.1-30.36c0.99-0.46,1.88-1.06,2.67-1.77c2.38-2.11,3.8-5.17,3.8-8.45l0-54.07v0
		c0-14.26-2.34-28.67-6.46-42.76c-3.51-12.01-8.28-23.79-14.28-35c-4.35-8.12-9.28-15.94-14.73-23.36
		c-2.72-3.71-5.57-7.31-8.54-10.8c-5.93-6.97-12.32-13.48-19.09-19.39c-16.92-14.78-36.18-25.88-56.42-31.43
		c-9.31-2.56-18.63-4.32-27.87-5.34c-9.24-1.02-18.42-1.31-27.46-0.9c-3.01,0.14-6.01,0.35-9,0.64
		c-29.82,2.88-57.93,13.26-81.92,29.31c-14.4,9.63-27.31,21.29-38.23,34.6c-7.28,8.87-13.67,18.47-19.02,28.69
		C372.22,321.18,369.81,326.44,367.68,331.84z M593.32,377.84c3.15-4.43,7.08-8.27,11.59-11.31c7.21-4.87,15.9-7.72,25.23-7.72
		c1.56,0,3.09,0.08,4.61,0.23c6.07,0.62,11.78,2.44,16.9,5.23c2.56,1.39,4.97,3.02,7.2,4.87c2.23,1.84,4.28,3.89,6.13,6.13
		c2.42,2.93,4.47,6.17,6.1,9.64c2.71,5.8,4.23,12.26,4.23,19.07c0,6.81-1.52,13.27-4.23,19.07c-1.63,3.48-3.68,6.72-6.1,9.64
		c-1.84,2.23-3.89,4.28-6.13,6.13c-2.23,1.84-4.64,3.47-7.2,4.87c-5.12,2.78-10.83,4.61-16.9,5.23c-1.52,0.15-3.05,0.23-4.61,0.23
		c-9.34,0-18.02-2.85-25.23-7.72c-4.51-3.05-8.44-6.88-11.59-11.31c-5.25-7.38-8.34-16.4-8.34-26.13S588.07,385.22,593.32,377.84z"
        />
        <polygon
          className="st4"
          points="470.56,453.45 470.56,365.95 357.65,380.07 357.65,509.9 357.65,509.9 470.56,453.45 	"
        />
        <path
          className="st5"
          d="M515.73,423.89V373.1c0-2.58-0.85-4.92-2.26-6.79c-0.47-0.62-1-1.2-1.59-1.71c-1.75-1.53-3.98-2.53-6.39-2.75
		c-0.8-0.07-1.63-0.06-2.46,0.04l-4.95,0.62l-4.95,0.62v79.03l16.34-8.17c0.96-0.48,1.83-1.08,2.6-1.78
		C514.38,430.1,515.73,427.12,515.73,423.89z"
        />
      </g>
    </svg>
  );
};
export const RidePlanIcon = () => <Icon component={RidePlanSvg} />;

const PlacesSvg = ({ width = '22px', height = '22px' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17.26 22"
      width={width}
      height={height}
    >
      <g id="Layer_2" data-name="Layer 2">
        <g id="Footer_v2_extended_CREATE" data-name="Footer v2 extended CREATE">
          <g id="Web">
            <g id="Web_v2" data-name="Web v2">
              <path
                className="cls-1"
                style={{ fill: '#e6e7e7' }}
                d="M4.29,7.5a4.76,4.76,0,0,1-.51-2.15A4.86,4.86,0,0,1,8.63.5h.23a4.89,4.89,0,0,1,4.62,4.61A5,5,0,0,1,13,7.5L8.63,15.9Zm4.34-4a1.89,1.89,0,1,0,1.89,1.89A1.89,1.89,0,0,0,8.63,3.46Z"
              />
              <path
                className="cls-2"
                style={{ fill: '#333' }}
                d="M8.63,1h.21A4.4,4.4,0,0,1,13,5.14a4.32,4.32,0,0,1-.45,2.13l-3.9,7.54L4.73,7.27a4.27,4.27,0,0,1-.45-1.92A4.35,4.35,0,0,1,8.63,1m0,6.73A2.39,2.39,0,1,0,6.25,5.35,2.38,2.38,0,0,0,8.63,7.73M8.63,0a5.36,5.36,0,0,0-4.8,7.72l3.92,7.55L8.63,17l.89-1.72,2.14-4.13,1.76-3.41A5.36,5.36,0,0,0,14,5.1,5.39,5.39,0,0,0,8.88,0Zm0,6.73A1.39,1.39,0,1,1,10,5.35,1.38,1.38,0,0,1,8.63,6.73Z"
              />
              <path
                className="cls-1"
                style={{ fill: '#e6e7e7' }}
                d="M8.63,21.5C4,21.5.5,20,.5,18c0-1.49,1.92-2.74,5-3.28l.34,0,1,1.64-.75.1c-2.41.33-3.2,1-3.2,1.16,0,.38,2,1.32,5.74,1.32s5.74-.94,5.74-1.32c0-.18-.75-.8-3-1.13l-.7-.11.87-1.65.36.06c3,.55,4.9,1.8,4.9,3.26C16.76,20,13.27,21.5,8.63,21.5Z"
              />
              <path
                className="cls-2"
                style={{ fill: '#333' }}
                d="M5.61,15.18l.41.7c-2.14.29-3.63.92-3.63,1.65,0,1,2.79,1.82,6.24,1.82s6.24-.82,6.24-1.82c0-.71-1.41-1.33-3.47-1.63l.37-.7c2.65.47,4.49,1.53,4.49,2.76,0,1.68-3.41,3-7.63,3S1,19.64,1,18c0-1.24,1.9-2.32,4.61-2.78m.5-1.1-.67.11C2,14.78,0,16.19,0,18c0,2.65,4.34,4,8.63,4s8.63-1.39,8.63-4c0-1.75-2-3.15-5.31-3.75l-.73-.13-.34.65-.37.71-.65,1.25,1.4.2a7.79,7.79,0,0,1,2.37.64,12.2,12.2,0,0,1-5,.82,12.24,12.24,0,0,1-5-.82,8.06,8.06,0,0,1,2.53-.66l1.49-.2-.77-1.3-.41-.7-.36-.59Z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const PlacesIcon = (props) => (
  <Icon {...props} component={() => <PlacesSvg {...props} />} />
);
export const PlacesSearchIcon = (props) => (
  <Icon {...props} component={() => <PlacesSvg {...props} />} />
);

const ToursSvg = ({ width = '22px', height = '22px' }) => {
  return (
    <svg
      id="Icons"
      viewBox="0 0 21.24467 21.24056"
      width={width}
      height={height}
    >
      <g id="Tour">
        <g>
          <path
            className="cls-1"
            style={{ fill: '#e6e7e7' }}
            d="M309.02158,73.95264h-4.49606a0.51944,0.51944,0,0,0-.54609.48661v3.86247a0.44409,0.44409,0,0,0,.09423.271,0.58624,0.58624,0,0,0,.1408.12843l2.55909,2.26713,2.5329-2.24785c0.02656-.0271.05967-0.05457,0.09241-0.08186,0.024-.02.048-0.03966,0.07313-0.0644a0.44485,0.44485,0,0,0,.09568-0.27286v-3.8621A0.51944,0.51944,0,0,0,309.02158,73.95264Z"
            transform="translate(-303.23189 -65.62188)"
          />
          <path
            className="cls-2"
            style={{
              fill: 'none',
              stroke: '#333',
              strokeMiterlimit: 10,
              strokeWidth: 0.75,
            }}
            d="M309.02158,73.58009h-4.49606a0.8915,0.8915,0,0,0-.91864.85915v3.86247a0.81765,0.81765,0,0,0,.1699.49661l0.02474,0.028a0.77785,0.77785,0,0,0,.19137.17281l2.78066,2.46723,2.78793-2.47469c0.02619-.02565.05093-0.046,0.07531-0.0664a1.32814,1.32814,0,0,0,.10587-0.09568l0.02729-.03147a0.81429,0.81429,0,0,0,.17027-0.49679v-3.8621A0.8915,0.8915,0,0,0,309.02158,73.58009Zm0.54609,4.72126a0.44485,0.44485,0,0,1-.09568.27286c-0.0251.02474-.04912,0.04439-0.07313,0.0644-0.03274.02729-.06585,0.05475-0.09241,0.08186l-2.5329,2.24785-2.55909-2.26713a0.58624,0.58624,0,0,1-.1408-0.12843,0.44409,0.44409,0,0,1-.09423-0.271V74.43925a0.51944,0.51944,0,0,1,.54609-0.48661h4.49606a0.51944,0.51944,0,0,1,.54609.48661v3.8621Z"
            transform="translate(-303.23189 -65.62188)"
          />
        </g>
        <g>
          <path
            className="cls-1"
            style={{ fill: '#e6e7e7' }}
            d="M323.18292,66.36943h-4.49606a0.51944,0.51944,0,0,0-.54609.48661v3.86247a0.44409,0.44409,0,0,0,.09423.271,0.58623,0.58623,0,0,0,.1408.12843l2.55909,2.26713,2.5329-2.24785c0.02656-.0271.05967-0.05457,0.09241-0.08186,0.024-.02.048-0.03966,0.07313-0.0644a0.44485,0.44485,0,0,0,.09568-0.27286V66.856A0.51944,0.51944,0,0,0,323.18292,66.36943Z"
            transform="translate(-303.23189 -65.62188)"
          />
          <path
            className="cls-2"
            style={{
              fill: 'none',
              stroke: '#333',
              strokeMiterlimit: 10,
              strokeWidth: 0.75,
            }}
            d="M323.18292,65.99688h-4.49606a0.8915,0.8915,0,0,0-.91864.85915v3.86247a0.81765,0.81765,0,0,0,.1699.49661l0.02474,0.028a0.77785,0.77785,0,0,0,.19137.17281l2.78066,2.46723,2.78793-2.47469c0.02619-.02565.05093-0.046,0.07531-0.0664a1.32812,1.32812,0,0,0,.10587-0.09568l0.02729-.03147a0.81429,0.81429,0,0,0,.17027-0.49679V66.856A0.8915,0.8915,0,0,0,323.18292,65.99688Zm0.54609,4.72126a0.44485,0.44485,0,0,1-.09568.27286c-0.0251.02474-.04912,0.04439-0.07313,0.0644-0.03274.02729-.06585,0.05475-0.09241,0.08186l-2.5329,2.24785L318.3758,71.118a0.58623,0.58623,0,0,1-.1408-0.12843,0.44409,0.44409,0,0,1-.09423-0.271V66.856a0.51944,0.51944,0,0,1,.54609-0.48661h4.49606a0.51944,0.51944,0,0,1,.54609.48661v3.8621Z"
            transform="translate(-303.23189 -65.62188)"
          />
        </g>
        <path
          className="cls-3"
          style={{ fill: '#333' }}
          d="M320.9099,79.32033a2.77,2.77,0,1,1,2.77-2.77A2.76978,2.76978,0,0,1,320.9099,79.32033Zm0-4.3a1.53,1.53,0,1,0,1.53,1.53A1.53,1.53,0,0,0,320.9099,75.02033Z"
          transform="translate(-303.23189 -65.62188)"
        />
        <path
          className="cls-1"
          style={{ fill: '#e6e7e7' }}
          d="M320.9199,75.05033a1.53,1.53,0,1,0,1.53,1.53A1.53,1.53,0,0,0,320.9199,75.05033Z"
          transform="translate(-303.23189 -65.62188)"
        />
        <path
          className="cls-3"
          style={{ fill: '#333' }}
          d="M306.74235,86.86244a2.77,2.77,0,1,1,2.77-2.77A2.76978,2.76978,0,0,1,306.74235,86.86244Zm0-4.3a1.53,1.53,0,1,0,1.53,1.53A1.53,1.53,0,0,0,306.74235,82.56244Z"
          transform="translate(-303.23189 -65.62188)"
        />
        <path
          className="cls-1"
          style={{ fill: '#e6e7e7' }}
          d="M306.75235,82.59244a1.53,1.53,0,1,0,1.53,1.53A1.53,1.53,0,0,0,306.75235,82.59244Z"
          transform="translate(-303.23189 -65.62188)"
        />
        <path
          id="_Path_"
          data-name="&lt;Path&gt;"
          className="cls-4"
          style={{ fill: 'none', stroke: '#333', strokeMiterlimit: 10 }}
          d="M309.17519,84.26824c5.57065-.16986,6.72034-0.47561,6.92867-1.89776,0.26931-1.83846-2.27031-2.56179-1.871-4.03632,0.21693-.801,1.54609-1.08314,4.259-1.54738"
          transform="translate(-303.23189 -65.62188)"
        />
      </g>
    </svg>
  );
};

export const ToursIcon = ({ height = '22px', width = '22px' }) => (
  <Icon component={() => <ToursSvg height={height} width={width} />} />
);
export const ToursIconSearch = (props) => (
  <Icon {...props} component={() => <ToursSvg {...props} />} />
);

const HomeSvg = ({ width = '22px', height = '22px' }) => {
  return (
    <svg
      viewBox="64 64 896 896"
      focusable="false"
      data-icon="home"
      width={width}
      height={height}
      fill="#646162"
      aria-hidden="true"
    >
      <path d="M946.5 505L560.1 118.8l-25.9-25.9a31.5 31.5 0 00-44.4 0L77.5 505a63.9 63.9 0 00-18.8 46c.4 35.2 29.7 63.3 64.9 63.3h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8a63.6 63.6 0 0018.7-45.3c0-17-6.7-33.1-18.8-45.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z"></path>
    </svg>
  );
};

export const HomeOutlined = () => (
  <Icon component={() => <HomeSvg height="22px" width="22px" />} />
);

/**/
const DreamTourSvg = ({ height = '15px', width = '15px' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21.02 19.78"
      width={width}
      height={height}
    >
      <g id="Layer_2" data-name="Layer 2">
        <g id="MC">
          <path
            className="cls-1"
            style={{ fill: '#333' }}
            d="M.88,19.73c3.2-1.29,6.43-2.6,9.74-3.58a15.25,15.25,0,0,1,2.31-.56,9,9,0,0,0,1.94-.12,1.65,1.65,0,0,0,1-1.28,1.94,1.94,0,0,1,.65-1.27c.23-.19.51-.34.76-.52.69-.49,2.2-1.51,1.4-2.5-.5-.62-2.84-.64-2.65-1.56.11-.54,1.25-.59,1.71-.76a1.39,1.39,0,0,0,1-1c.17-1.18-1.44-2.21-2.11-3s-1.09-1.5-.05-2.11,2.4.19,3.29.94c.6.52,1.49-.36.88-.88C19.53.46,17.91-.51,16.23.3a2.24,2.24,0,0,0-1.14,3.25c.29.49,2.59,2.57,2.46,2.83a14.33,14.33,0,0,1-1.76.51,1.69,1.69,0,0,0-1,1.55c0,1.28,1.31,1.75,2.33,2a5.11,5.11,0,0,0,.66.22l-.09-.24a2.23,2.23,0,0,1-.26.27c-.11.08-.22.2-.32.29a17.85,17.85,0,0,0-1.71,1.25,2.28,2.28,0,0,0-.5.85c-.15.41-.07,1-.57,1.21a3.93,3.93,0,0,1-1.08,0,10,10,0,0,0-2,.37A88.16,88.16,0,0,0,.55,18.53c-.74.3-.42,1.51.33,1.2Z"
          />
          <path
            className="cls-2"
            style={{
              fill: '#e5e5e5',
              stroke: '#333',
              strokeMiterlimit: 10,
              strokeWidth: '0.5px',
            }}
            d="M13.83,12.36a1.88,1.88,0,0,0-2.39-1.17,1.66,1.66,0,0,0-.33.15L10.8,11h0a1.06,1.06,0,0,0,.24-.19.9.9,0,0,0,.15-.25,1.13,1.13,0,0,0,.09-.25,1.08,1.08,0,0,0-.06-.54,1.32,1.32,0,0,0-.15-.28,2.14,2.14,0,0,0-1-.65,4.56,4.56,0,0,0-1.2-.33s-1.93-.26-2,.32a.41.41,0,0,0,.19.39l.05.05,1,0v.28l-.39.13-.25.05a.84.84,0,0,0-.32.1,1.43,1.43,0,0,0-.49.49h0a1.58,1.58,0,0,0-.3.61.84.84,0,0,0,0,.24.57.57,0,0,1,0,.12,1.19,1.19,0,0,1-.37.6,1.34,1.34,0,0,1-.48.3,2,2,0,0,1-.67.07,4.22,4.22,0,0,1-.93-.11h0L.28,13.33l0,.16a.85.85,0,0,0,.16.36,1.11,1.11,0,0,0,.38.26l.32.13.05,0,1.36-.34,1.56.78-.3.14a2,2,0,0,0-1.9-.41A1.88,1.88,0,0,0,3.16,18a2,2,0,0,0,1.2-2.26l.46-.2a1.07,1.07,0,0,0,.25.43,1,1,0,0,0,.36.27,1.08,1.08,0,0,0,.6.09h0l2.93-1,0-.05a4.9,4.9,0,0,0,.54-1,2.45,2.45,0,0,0,.17-.78,1.13,1.13,0,0,0,0-.32,1.18,1.18,0,0,1,0-.25,1.78,1.78,0,0,1,.14-.81,3.08,3.08,0,0,1,.24-.42l0,0,.37.4a1.85,1.85,0,0,0-.15,1.53,1.88,1.88,0,0,0,3.56-1.21ZM2.93,17.31a1.16,1.16,0,0,1-1.46-.72,1.14,1.14,0,0,1,.72-1.46,1.15,1.15,0,0,1,.91.07.15.15,0,0,1,.06.2.15.15,0,0,1-.19,0,.87.87,0,0,0-.69,0,.87.87,0,1,0,1.13.69.15.15,0,0,1,.12-.16.15.15,0,0,1,.17.12A1.15,1.15,0,0,1,2.93,17.31ZM12.55,14l-.15.06a1.14,1.14,0,0,1-.73,0,1.1,1.1,0,0,1-.66-.57,1.14,1.14,0,0,1-.06-.92.15.15,0,0,1,.19-.08.14.14,0,0,1,.08.18.87.87,0,0,0,0,.69.86.86,0,0,0,1.16.38.86.86,0,0,0-.63-1.6.14.14,0,0,1-.18-.1.15.15,0,0,1,.1-.18A1.15,1.15,0,0,1,12.55,14Z"
          />
        </g>
      </g>
    </svg>
  );
};

export const DreamTour = () => (
  <Icon component={() => <DreamTourSvg height="22px" width="22px" />} />
);

const MyToursSvg = ({ width = '22px', height = '22px' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18.5 10.34"
      width={width}
      height={height}
    >
      <g id="Layer_2" data-name="Layer 2">
        <g id="Icons">
          <path
            id="MC"
            className="cls-1"
            style={{
              fill: '#e5e5e5',
              stroke: '#333',
              strokeMiterlimit: 10,
              strokeWidth: '0.5px',
            }}
            d="M18.25,7.66a2.48,2.48,0,0,0-2.92-2.39l-.25-.51h0a1.12,1.12,0,0,0,.38-.13,1.7,1.7,0,0,0,.29-.23A2.22,2.22,0,0,0,16,4.12a1.24,1.24,0,0,0,.15-.68,1.35,1.35,0,0,0-.06-.4,2.84,2.84,0,0,0-.91-1.21A6.23,6.23,0,0,0,13.8.92S11.53-.2,11.14.46a.56.56,0,0,0,.07.56l0,.08,1.18.36-.13.34a4.87,4.87,0,0,1-.54,0l-.33,0a1.22,1.22,0,0,0-.43,0,1.79,1.79,0,0,0-.81.39l0,0a2,2,0,0,0-.64.61A1.05,1.05,0,0,0,9.41,3a.93.93,0,0,1-.07.15,1.44,1.44,0,0,1-.71.57,1.81,1.81,0,0,1-.72.17,2.6,2.6,0,0,1-.86-.2A6,6,0,0,1,6,3.21l-.06,0H1.12l0,.2a1,1,0,0,0,0,.51,1.48,1.48,0,0,0,.36.47c.1.1.22.2.34.3l.06,0,1.81.16,1.6,1.6-.43.06A2.54,2.54,0,0,0,2.7,5.2a2.43,2.43,0,1,0,0,4.86A2.56,2.56,0,0,0,5.14,7.8l.65,0a1.38,1.38,0,0,0,.12.63,1.59,1.59,0,0,0,.34.49,1.43,1.43,0,0,0,.7.35H7l4,0,.07,0a5.5,5.5,0,0,0,1.11-1,3,3,0,0,0,.54-.88,1.39,1.39,0,0,0,.09-.41.91.91,0,0,1,.06-.32,2.33,2.33,0,0,1,.51-.93,5.61,5.61,0,0,1,.47-.41l.05,0,.28.65a2.39,2.39,0,0,0-.83,1.81,2.45,2.45,0,0,0,4.9,0ZM2.7,9.14A1.49,1.49,0,1,1,3.8,6.63a.18.18,0,0,1,0,.26.19.19,0,0,1-.26,0,1.12,1.12,0,1,0,.28,1A.18.18,0,0,1,4,7.71a.18.18,0,0,1,.15.21A1.49,1.49,0,0,1,2.7,9.14ZM16,9.13h-.21a1.48,1.48,0,0,1-.9-.3,1.48,1.48,0,0,1-.26-2.12.19.19,0,0,1,.26,0,.18.18,0,0,1,0,.26,1.11,1.11,0,0,0-.24.86,1.13,1.13,0,0,0,.44.74,1.07,1.07,0,0,0,.83.21,1.11,1.11,0,0,0-.1-2.22.2.2,0,0,1-.18-.2.19.19,0,0,1,.2-.17,1.49,1.49,0,0,1,.13,3Z"
          />
        </g>
      </g>
    </svg>
  );
};

export const MyToursIcon = () => (
  <Icon component={() => <MyToursSvg height="22px" width="22px" />} />
);

const FriendToursSvg = ({ width = '22px', height = '22px' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17.6 14"
      width={width}
      height={height}
    >
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <g id="Friends">
            <path
              className="cls-1"
              style={{ fill: '#e5e5e5' }}
              d="M15.4,6.93a.54.54,0,0,0-.06-.43A.36.36,0,0,0,15,6.31c-1.93.35-6.27.09-9.57-.19a3.6,3.6,0,0,0-3.7,2.82l-1,4.42H1.79l.72-3.44a.3.3,0,0,1,.33-.25.33.33,0,0,1,.3.28l.34,3.41h4.6L8.5,8.79a.32.32,0,0,1,.35-.29,11.48,11.48,0,0,0,6.34-1.29A.5.5,0,0,0,15.4,6.93Z"
            />
            <path
              className="cls-2"
              style={{ fill: '#333' }}
              d="M15.49,7.77A1.1,1.1,0,0,0,16,7.1a1.21,1.21,0,0,0-.12-.93,1,1,0,0,0-1-.49,46.76,46.76,0,0,1-9.41-.2A4.3,4.3,0,0,0,1.07,8.79L0,13.61a.32.32,0,0,0,.06.27A.3.3,0,0,0,.32,14H2a.34.34,0,0,0,.32-.25l.35-1.69.17,1.65a.31.31,0,0,0,.31.29H8.37a.32.32,0,0,0,.32-.29l.42-4.55A12.08,12.08,0,0,0,15.49,7.77ZM8.85,8.5a.32.32,0,0,0-.35.29l-.42,4.57H3.48L3.14,10a.33.33,0,0,0-.3-.28.3.3,0,0,0-.33.25l-.72,3.44H.71l1-4.42a3.6,3.6,0,0,1,3.7-2.82c3.3.28,7.64.54,9.57.19a.36.36,0,0,1,.38.19.54.54,0,0,1,.06.43.5.5,0,0,1-.21.28A11.48,11.48,0,0,1,8.85,8.5Z"
            />
            <path
              className="cls-1"
              style={{ fill: '#e5e5e5' }}
              d="M10.17,10.3l-.3,3.06h3.92v-2.2a.32.32,0,0,1,.26-.32.31.31,0,0,1,.35.19l1,2.33h1.49L15.68,8.91A13.32,13.32,0,0,1,10.17,10.3Z"
            />
            <path
              className="cls-2"
              style={{ fill: '#333' }}
              d="M17.59,13.6,16.18,8.34A.3.3,0,0,0,16,8.13a.28.28,0,0,0-.28,0A12.8,12.8,0,0,1,9.88,9.67a.32.32,0,0,0-.32.28l-.36,3.7a.38.38,0,0,0,.09.25.33.33,0,0,0,.23.1h4.59a.32.32,0,0,0,.32-.32v-.94l.45,1.06a.31.31,0,0,0,.29.2h2.12a.33.33,0,0,0,.25-.12A.32.32,0,0,0,17.59,13.6Zm-2.21-.24L14.4,11a.31.31,0,0,0-.35-.19.32.32,0,0,0-.26.32v2.2H9.87l.3-3.06a13.32,13.32,0,0,0,5.51-1.39l1.19,4.45Z"
            />
            <path
              className="cls-1"
              style={{ fill: '#e5e5e5' }}
              d="M3,4l.37.67,4.2-.46.13,0a.53.53,0,0,0,.11-.09.33.33,0,0,0,.07-.27l0-.17-.05-.12-1.95.08a.6.6,0,0,1-.3-.07.58.58,0,0,1-.22-.22L5,2.64a.57.57,0,0,1,0-.46A.48.48,0,0,1,5,2L5,2l.13-.1,0,0,.06,0,1.6-.63h0A2.39,2.39,0,0,0,5.26.53H5.15A2.56,2.56,0,0,0,3.94.83a2.46,2.46,0,0,0-.55.41h0A2.54,2.54,0,0,0,3,4Zm.45-1.42a.8.8,0,0,1,.88.07.93.93,0,0,1,.13.15.71.71,0,0,1,.07.09h0a.84.84,0,0,1,.07.6A.81.81,0,0,1,4.21,4a.85.85,0,0,1-.38.09.83.83,0,0,1-.22,0s0,0,0,0A.61.61,0,0,1,3.38,4L3.31,3.9a1.12,1.12,0,0,1-.17-.2h0A.79.79,0,0,1,3.45,2.62Z"
            />
            <polygon points="7.39 1.01 7.39 1.01 7.39 1.01 7.39 1.01" />
            <path
              className="cls-2"
              style={{ fill: '#333' }}
              d="M3,5.05a.37.37,0,0,0,.33.2h0l4.31-.48A.91.91,0,0,0,8,4.67a1.13,1.13,0,0,0,.27-.22.91.91,0,0,0,.18-.66c0-.06,0-.14,0-.22L7.4,1V1h0l-.1.05L7.39,1l0,0A2.93,2.93,0,0,0,5.29,0H4.91L4.8,0l-.28,0h-.1a2.29,2.29,0,0,0-.37.12,1.55,1.55,0,0,0-.33.15h0l0,0h0L3.4.56,3.32.62,3,.86A3.1,3.1,0,0,0,2.54,4.3Zm.43-3.81A2.46,2.46,0,0,1,3.94.83,2.56,2.56,0,0,1,5.15.52h.11a2.39,2.39,0,0,1,1.6.68h0l-1.6.63-.06,0,0,0L5,2,5,2a.48.48,0,0,0-.09.16.57.57,0,0,0,0,.46l.39.71a.58.58,0,0,0,.22.22.6.6,0,0,0,.3.07l1.95-.08.05.12,0,.17a.33.33,0,0,1-.07.27.53.53,0,0,1-.11.09l-.13,0-4.2.46L3,4a2.54,2.54,0,0,1,.39-2.8ZM5.84,3.12l0,0-.39-.71s0,0,0,0l0,0-.06-.09.06.09,1.64-.65.53,1.37Z"
            />
            <path
              className="cls-3"
              style={{ fill: '#fff' }}
              d="M5.44,2.33l-.06-.09.06.09,0,0s0,0,0,0l.39.71,0,0,1.77-.07L7.08,1.68Z"
            />
            <path
              className="cls-3"
              style={{ fill: '#fff' }}
              d="M3.71,3.08a.27.27,0,0,0-.11.36.25.25,0,0,0,.16.12.23.23,0,0,0,.2,0,.27.27,0,0,0,.11-.36h0a.27.27,0,0,0-.13-.1l-.1,0A.27.27,0,0,0,3.71,3.08Z"
            />
            <path
              className="cls-2"
              style={{ fill: '#333' }}
              d="M3.14,3.69h0a1.12,1.12,0,0,0,.17.2L3.38,4A.61.61,0,0,0,3.56,4s0,0,0,0a.83.83,0,0,0,.22,0A.85.85,0,0,0,4.21,4a.81.81,0,0,0,.39-.48.84.84,0,0,0-.07-.6h0a.71.71,0,0,0-.07-.09.93.93,0,0,0-.13-.15.8.8,0,0,0-.88-.07.79.79,0,0,0-.31,1.07Zm.92-.52h0A.27.27,0,0,1,4,3.54a.23.23,0,0,1-.2,0,.25.25,0,0,1-.16-.12.26.26,0,0,1,.23-.39l.1,0A.27.27,0,0,1,4.06,3.17Z"
            />
            <path
              className="cls-1"
              style={{ fill: '#e5e5e5' }}
              d="M12.22.76a2.44,2.44,0,0,0-1.47.92l1.7.38.06,0h0a.47.47,0,0,1,.14.08l0,0a.56.56,0,0,1,.15.6l-.28.76a.51.51,0,0,1-.18.25.41.41,0,0,1-.19.08l-.09,0h0l-1.94.23,0,.14v.16a.37.37,0,0,0,.12.24.25.25,0,0,0,.12.08l.13,0,4.23-.2L15,3.88a2.53,2.53,0,0,0-.81-2.71,2.34,2.34,0,0,0-.61-.31A2.51,2.51,0,0,0,12.22.76ZM13.3,3.17a.77.77,0,0,1,0-.15h0a1,1,0,0,1,.15-.24,0,0,0,0,0,0,0,.81.81,0,0,1,.85-.21.84.84,0,0,1,.46.41.78.78,0,0,1,0,.6h0a.72.72,0,0,1-.14.24l-.05.05a1.18,1.18,0,0,1-.18.13l0,0h0a.82.82,0,0,1-.31.07.86.86,0,0,1-.27,0,.77.77,0,0,1-.52-.7A.41.41,0,0,1,13.3,3.17Z"
            />
            <path
              className="cls-2"
              style={{ fill: '#333' }}
              d="M13.8,4a.86.86,0,0,0,.27,0A.82.82,0,0,0,14.38,4h0l0,0a1.18,1.18,0,0,0,.18-.13l.05-.05a.72.72,0,0,0,.14-.24h0a.78.78,0,0,0,0-.6.84.84,0,0,0-.46-.41.81.81,0,0,0-.85.21,0,0,0,0,1,0,0,1,1,0,0,0-.15.24h0a.77.77,0,0,0,0,.15.41.41,0,0,0,0,.16A.77.77,0,0,0,13.8,4Zm.52-.65a.26.26,0,0,1-.14.15.27.27,0,0,1-.2,0,.29.29,0,0,1-.15-.14s0,0,0,0a.29.29,0,0,1,0-.16A.26.26,0,0,1,14.07,3l.09,0a.26.26,0,0,1,.15.14s0,0,0,0A.25.25,0,0,1,14.32,3.38Z"
            />
            <path
              className="cls-2"
              style={{ fill: '#333' }}
              d="M9.91,5.09a.75.75,0,0,0,.3.18.71.71,0,0,0,.29.05h0l4.34-.2a.38.38,0,0,0,.33-.25l.29-.81a3.08,3.08,0,0,0-1-3.32,3.37,3.37,0,0,0-.32-.19L14.06.5,13.82.39h-.07l0,0L13.39.26h0L13,.2h-.5a2.52,2.52,0,0,0-.37,0,2.88,2.88,0,0,0-1.9,1.28l0,0,.09.06h0l-.09-.05L9.63,4.19v.29A.86.86,0,0,0,9.91,5.09Zm4.28-3.92A2.53,2.53,0,0,1,15,3.88l-.25.72-4.23.2-.13,0a.25.25,0,0,1-.12-.08.37.37,0,0,1-.12-.24V4.3l0-.14,1.94-.23h0l.09,0a.41.41,0,0,0,.19-.08.51.51,0,0,0,.18-.25l.28-.76a.56.56,0,0,0-.15-.6l0,0a.47.47,0,0,0-.14-.08h0l-.06,0-1.7-.38A2.44,2.44,0,0,1,12.22.76a2.51,2.51,0,0,1,1.36.1A2.34,2.34,0,0,1,14.19,1.17Zm-1.87,1.4,0-.1h0v.15l-.28.77s0,0,0,0l-1.75.21.3-1.43Z"
            />
            <path
              className="cls-3"
              style={{ fill: '#fff' }}
              d="M12.05,3.41s0,0,0,0l.28-.77V2.47h0l0,.1h0L10.6,2.19l-.3,1.43Z"
            />
            <polygon points="12.33 2.57 12.32 2.57 12.32 2.57 12.33 2.57" />
            <path
              className="cls-3"
              style={{ fill: '#fff' }}
              d="M14.16,3l-.09,0a.26.26,0,0,0-.25.18.29.29,0,0,0,0,.16s0,0,0,0a.29.29,0,0,0,.15.14.27.27,0,0,0,.2,0,.26.26,0,0,0,.14-.15.25.25,0,0,0,0-.17s0,0,0,0A.26.26,0,0,0,14.16,3Z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const FriendToursIcon = ({ height = '22px', width = '22px' }) => (
  <Icon component={() => <FriendToursSvg height={height} width={width} />} />
);
/**/

const BikerClubSvg = ({ height = '22px', width = '22px', thin = 31 }) => {
  return (
    <svg viewBox="0 0 17.99 17.95" width={width} height={height}>
      <g id="Layer_5" data-name="Layer 5">
        <g>
          <path
            className="cls-1"
            style={{ fill: '#e6e7e7' }}
            d="M318.157,193.68674a8.47866,8.47866,0,0,0-4.37-1.22,8.39371,8.39371,0,0,0-2.27.31,8.49064,8.49064,0,0,0-5.63,7.62v2.67l12.74,5.24a1.36489,1.36489,0,0,0,.56.11,1.38793,1.38793,0,0,0,.57-0.12,1.4645,1.4645,0,0,0,.8-0.82c0.06-.16.13-0.35,0.2-0.54l0.09-.71-5.83-2.89a1.45065,1.45065,0,0,1-.81-1.3v-2.6a1.4381,1.4381,0,0,1,.5-1.09,1.55369,1.55369,0,0,1,.41-0.25c0.02-.01.05-0.02,0.07-0.03a1.33006,1.33006,0,0,1,.45-0.08c0.01,0,.03-0.01.04-0.01a1.08684,1.08684,0,0,1,.18.01l5.99,0.75,0.01-.08A8.01705,8.01705,0,0,0,318.157,193.68674Zm-8.47,8.12a2.19,2.19,0,1,1,2.2-2.19A2.19153,2.19153,0,0,1,309.687,201.80674Z"
            transform="translate(-304.88699 -191.47673)"
          />
          <path
            className="cls-2"
            style={{ fill: '#333' }}
            d="M322.867,198.58674v-0.04a9.001,9.001,0,0,0-4.19-5.71,9.26039,9.26039,0,0,0-1.04-.53,3.05435,3.05435,0,0,0-.32-0.13c-0.27-.11-0.54-0.2-0.81-0.29-0.11-.03-0.21-0.07-0.32-0.1a8.55575,8.55575,0,0,0-1.12-.23h-0.04a8.023,8.023,0,0,0-1.1-.07c-0.04,0-.09-0.01-0.13-0.01-0.07,0-.14.01-0.21,0.01q-0.42.015-.84,0.06c-0.11.01-.23,0.02-0.34,0.04a8.972,8.972,0,0,0-1.15.22,9.44,9.44,0,0,0-6.37,8.59v2.77a0.85869,0.85869,0,0,0,.51.78l12.85,5.29a2.495,2.495,0,0,0,1.91,0,2.48553,2.48553,0,0,0,1.35-1.37h0c0.08-.19.16-0.42,0.24-0.65v-0.03c0-.01.01-0.02,0.01-0.03l1.12-8.49A0.28141,0.28141,0,0,1,322.867,198.58674Zm-1.89,6.59-5.5-2.73a0.45179,0.45179,0,0,1-.26-0.41v-2.6a0.48587,0.48587,0,0,1,.15-0.34,0.46526,0.46526,0,0,1,.31-0.12h0.06l5.95,0.74Zm0.87-6.44-5.98-.74a1.08685,1.08685,0,0,0-.18-0.01c-0.01,0-.03.01-0.04,0.01a1.42344,1.42344,0,0,0-.45.08c-0.02.01-.05,0.02-0.07,0.03a1.32924,1.32924,0,0,0-.41.25,1.4381,1.4381,0,0,0-.5,1.09v2.6a1.45065,1.45065,0,0,0,.81,1.3l5.83,2.89-0.09.71c-0.07.2-.14,0.38-0.2,0.54a1.46509,1.46509,0,0,1-.8.82,1.42266,1.42266,0,0,1-.57.12,1.55066,1.55066,0,0,1-.56-0.11l-12.75-5.25v-2.67a8.46875,8.46875,0,0,1,5.63-7.62,8.8068,8.8068,0,0,1,2.27-.31,8.47866,8.47866,0,0,1,4.37,1.22,7.98138,7.98138,0,0,1,3.7,4.97Z"
            transform="translate(-304.88699 -191.47673)"
          />
          <path
            className="cls-3"
            style={{ fill: '#fff' }}
            d="M315.687,198.98674a0.45974,0.45974,0,0,0-.46.46v2.6a0.46287,0.46287,0,0,0,.26.41l5.5,2.73,0.72-5.45-5.95-.74A0.19522,0.19522,0,0,0,315.687,198.98674Z"
            transform="translate(-304.88699 -191.47673)"
          />
          <path
            className="cls-3"
            style={{ fill: '#fff' }}
            d="M309.687,198.41674a1.19,1.19,0,1,0,1.2,1.19A1.20147,1.20147,0,0,0,309.687,198.41674Z"
            transform="translate(-304.88699 -191.47673)"
          />
          <path
            className="cls-2"
            style={{ fill: '#333' }}
            d="M309.687,197.41674a2.19,2.19,0,1,0,2.2,2.19A2.19153,2.19153,0,0,0,309.687,197.41674Zm0,3.39a1.19,1.19,0,1,1,1.2-1.19A1.20147,1.20147,0,0,1,309.687,200.80674Z"
            transform="translate(-304.88699 -191.47673)"
          />
        </g>
      </g>
    </svg>
  );
};

export const BikerClubIcon = ({ height = '22px', width = '22px' }) => (
  <Icon component={() => <BikerClubSvg height={height} width={width} />} />
);
export const BikerClubIconSearch = (props) => (
  <Icon {...props} component={() => <BikerClubSvg {...props} />} />
);

const BikerBedSvg = ({ height = '22px', width = '22px' }) => {
  return (
    <svg viewBox="0 0 12 20.35042" width={width} height={height}>
      <g id="BikerBed_v1">
        <g>
          <path
            className="cls-1"
            style={{ fill: '#e6e7e7' }}
            d="M298.15527,250.07178a1.33493,1.33493,0,0,1-1.3335-1.3335V236.22119a5.5,5.5,0,0,1,11,0,1.33325,1.33325,0,1,1-2.6665,0,2.8335,2.8335,0,0,0-5.667,0v1.80615l7.70947,4.84082a1.32336,1.32336,0,0,1,.624,1.12891v4.74121a1.33493,1.33493,0,0,1-1.3335,1.3335h-8.333Z"
            transform="translate(-296.32181 -230.22136)"
          />
          <path
            className="cls-2"
            style={{ fill: '#333' }}
            d="M302.32181,231.22136a5.00545,5.00545,0,0,1,5,5,0.83333,0.83333,0,0,1-1.66666,0,3.33333,3.33333,0,1,0-6.66666,0v2.08215l7.94312,4.98775a0.83222,0.83222,0,0,1,.3902.70557v4.74162a0.83335,0.83335,0,0,1-.83331.83333h-8.33334a0.83338,0.83338,0,0,1-.83334-0.83333V236.22136a5.00547,5.00547,0,0,1,5-5m0-1a6.0068,6.0068,0,0,0-6,6v12.51709a1.83541,1.83541,0,0,0,1.83334,1.83333h8.33334a1.8354,1.8354,0,0,0,1.83331-1.83333v-4.74162a1.82218,1.82218,0,0,0-.85931-1.553l-7.474-4.69318v-1.52928a2.33333,2.33333,0,1,1,4.66666,0,1.83333,1.83333,0,0,0,3.66666,0,6.0068,6.0068,0,0,0-6-6h0Z"
            transform="translate(-296.32181 -230.22136)"
          />
        </g>
      </g>
    </svg>
  );
};

export const BikerBedIcon = ({ height = '22px', width = '22px' }) => (
  <Icon component={() => <BikerBedSvg height={height} width={width} />} />
);
export const BikerBedIconSearch = (props) => (
  <Icon {...props} component={() => <BikerBedSvg {...props} />} />
);

const MoreSvg = ({ height = 8, width = 20 }) => {
  return (
    <svg viewBox="0 0 20.39645 5.54" width={width} height={height}>
      <g id="More">
        <path
          className="cls-1"
          style={{ fill: '#e6e7e7' }}
          d="M358.389,118.37891a2.01888,2.01888,0,1,0,2.01888,2.01888A2.01886,2.01886,0,0,0,358.389,118.37891Z"
          transform="translate(-340.7741 -117.62779)"
        />
        <path
          className="cls-1"
          style={{ fill: '#e6e7e7' }}
          d="M350.97232,118.37891a2.01888,2.01888,0,1,0,2.01888,2.01888A2.01886,2.01886,0,0,0,350.97232,118.37891Z"
          transform="translate(-340.7741 -117.62779)"
        />
        <path
          className="cls-1"
          style={{ fill: '#e6e7e7' }}
          d="M343.55565,118.37891a2.01888,2.01888,0,1,0,2.01888,2.01888A2.01886,2.01886,0,0,0,343.55565,118.37891Z"
          transform="translate(-340.7741 -117.62779)"
        />
        <path
          className="cls-2"
          style={{ fill: '#333' }}
          d="M343.55565,123.16779a2.77,2.77,0,1,1,2.78156-2.77A2.77558,2.77558,0,0,1,343.55565,123.16779Zm0-4.3a1.53,1.53,0,1,0,1.53638,1.53A1.5332,1.5332,0,0,0,343.55565,118.86779Z"
          transform="translate(-340.7741 -117.62779)"
        />
        <path
          className="cls-2"
          style={{ fill: '#333' }}
          d="M358.389,123.16779a2.77,2.77,0,1,1,2.78156-2.77A2.77558,2.77558,0,0,1,358.389,123.16779Zm0-4.3a1.53,1.53,0,1,0,1.53638,1.53A1.5332,1.5332,0,0,0,358.389,118.86779Z"
          transform="translate(-340.7741 -117.62779)"
        />
        <path
          className="cls-2"
          style={{ fill: '#333' }}
          d="M350.97232,123.16779a2.77,2.77,0,1,1,2.78156-2.77A2.77558,2.77558,0,0,1,350.97232,123.16779Zm0-4.3a1.53,1.53,0,1,0,1.53638,1.53A1.5332,1.5332,0,0,0,350.97232,118.86779Z"
          transform="translate(-340.7741 -117.62779)"
        />
      </g>
    </svg>
  );
};

export const MoreIcon = () => (
  <Icon component={() => <MoreSvg height="10px" width="22px" />} />
);

const BookmarkSvg = () => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 431.972 431.972">
      <g>
        <path
          d="M393.146,14.279c-3.713-5.333-8.713-9.233-14.989-11.707c-3.997-1.711-8.186-2.568-12.565-2.568V0H66.378
		c-4.377,0-8.562,0.857-12.56,2.568c-6.28,2.472-11.278,6.377-14.989,11.707c-3.71,5.33-5.568,11.228-5.568,17.701v368.019
		c0,6.475,1.858,12.371,5.568,17.706c3.711,5.329,8.709,9.233,14.989,11.704c3.994,1.711,8.183,2.566,12.56,2.566
		c8.949,0,16.844-3.142,23.698-9.418l125.91-121.062l125.91,121.065c6.663,6.081,14.562,9.127,23.695,9.127
		c4.76,0,8.948-0.756,12.565-2.279c6.276-2.471,11.276-6.375,14.989-11.711c3.71-5.328,5.564-11.225,5.564-17.699V31.98
		C398.71,25.507,396.852,19.609,393.146,14.279z M362.166,391.139L241.397,275.224l-25.411-24.264l-25.409,24.264L69.809,391.139
		V36.549h292.357V391.139L362.166,391.139z"
        />
      </g>
    </svg>
  );
};

export const BookmarkIcon = () => <Icon component={BookmarkSvg} />;

const BookmarkShapeSvg = () => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 431.972 431.972">
      <g>
        <path
          d="M393.146,14.279c-3.713-5.333-8.713-9.233-14.989-11.707c-3.997-1.711-8.186-2.568-12.565-2.568V0H66.378   c-4.377,0-8.562,0.857-12.56,2.568c-6.28,2.472-11.278,6.377-14.989,11.707c-3.71,5.33-5.568,11.228-5.568,17.701v368.019   c0,6.475,1.858,12.371,5.568,17.706c3.711,5.329,8.709,9.233,14.989,11.704c3.994,1.711,8.183,2.566,12.56,2.566   c8.949,0,16.844-3.142,23.698-9.418l125.91-121.062l125.91,121.065c6.663,6.081,14.562,9.127,23.695,9.127   c4.76,0,8.948-0.756,12.565-2.279c6.276-2.471,11.276-6.375,14.989-11.711c3.71-5.328,5.564-11.225,5.564-17.699V31.98   C398.71,25.507,396.852,19.609,393.146,14.279z"
          fill="#aa2493"
        />
      </g>
    </svg>
  );
};
export const BookmarkShapeIcon = () => <Icon component={BookmarkShapeSvg} />;

const BookmarkMenuSvg = ({ height = '22px', width = '22px' }) => {
  return (
    <svg viewBox="0 0 16 20" height={height} width={width}>
      <g>
        <path
          className="cls-1"
          style={{ fill: '#e6e7e7' }}
          d="M318.22469,935.19049h-11.817a1.03524,1.03524,0,0,0-1.09149.93237v16.85986a0.2077,0.2077,0,0,0,.13074.16992,0.51257,0.51257,0,0,0,.17938.033,0.36771,0.36771,0,0,0,.19067-0.04993l0.0282-.02374,5.8562-4.56519,0.61481-.47931,0.61481,0.47931,5.8562,4.56519,0.03009,0.02344a0.397,0.397,0,0,0,.19171.05511,0.27737,0.27737,0,0,0,.10828-0.02924l0.03345-.0177,0.03473-.01508a0.2077,0.2077,0,0,0,.13074-0.16986V936.12286A1.03524,1.03524,0,0,0,318.22469,935.19049Z"
          transform="translate(-304.31618 -934.19049)"
        />
        <path
          className="cls-2"
          style={{ fill: '#333' }}
          d="M318.22469,934.19049h-11.817a2.0226,2.0226,0,0,0-2.09149,1.93237v16.85986a1.20381,1.20381,0,0,0,.73206,1.087,1.5449,1.5449,0,0,0,.32947.09119c0.03424,0.0058.06836,0.00684,0.1026,0.01025,0.04871,0.00488.09753,0.01453,0.146,0.01453,0.02081,0,.04016-0.00842.06085-0.00934a1.38585,1.38585,0,0,0,.26782-0.0412c0.04144-.01.08325-0.01508,0.1236-0.029a1.314,1.314,0,0,0,.35529-0.18134l0.02612-.02417,5.8562-4.56525,5.8562,4.56525,0.02612,0.02417a1.40372,1.40372,0,0,0,.81049.26569,1.26812,1.26812,0,0,0,.57513-0.145,1.20379,1.20379,0,0,0,.73206-1.08691V936.12286A2.0226,2.0226,0,0,0,318.22469,934.19049Zm1.09149,18.76813a0.2077,0.2077,0,0,1-.13074.16986l-0.03473.01508-0.03345.0177a0.27737,0.27737,0,0,1-.10828.02924,0.397,0.397,0,0,1-.19171-0.05511l-0.03009-.02344-5.8562-4.56519-0.61481-.47931-0.61481.47931-5.8562,4.56519-0.0282.02374a0.36771,0.36771,0,0,1-.19067.04993,0.51257,0.51257,0,0,1-.17938-0.033,0.2077,0.2077,0,0,1-.13074-0.16992V936.12286a1.03524,1.03524,0,0,1,1.09149-.93237h11.817a1.03524,1.03524,0,0,1,1.09149.93237v16.83575Z"
          transform="translate(-304.31618 -934.19049)"
        />
      </g>
    </svg>
  );
};
export const BookmarkMenuIcon = () => (
  <Icon component={() => <BookmarkMenuSvg />} />
);

const TrackSvg = ({ width = '22px', height = '22px' }) => {
  return (
    <svg viewBox="0 0 18.02488 17.86" width={width} height={height}>
      <g id="Track">
        <path
          className="cls-1"
          style={{ fill: '#333' }}
          d="M310.25194,118.00289a2.77,2.77,0,1,1,2.78155-2.77A2.77558,2.77558,0,0,1,310.25194,118.00289Zm0-4.3a1.525,1.525,0,1,0,1.53638,1.52A1.5332,1.5332,0,0,0,310.25194,113.70289Z"
          transform="translate(-304.729 -112.46289)"
        />
        <path
          className="cls-1"
          style={{ fill: '#333' }}
          d="M319.24932,121.04289a2.77,2.77,0,1,1,2.78156-2.77A2.77558,2.77558,0,0,1,319.24932,121.04289Zm0-4.3a1.53,1.53,0,1,0,1.53638,1.53A1.5332,1.5332,0,0,0,319.24932,116.74289Z"
          transform="translate(-304.729 -112.46289)"
        />
        <path
          className="cls-1"
          style={{ fill: '#333' }}
          d="M307.51055,127.40289a2.77,2.77,0,1,1,2.78156-2.77A2.77558,2.77558,0,0,1,307.51055,127.40289Zm0-4.3a1.53,1.53,0,1,0,1.53638,1.53A1.5332,1.5332,0,0,0,307.51055,123.10289Z"
          transform="translate(-304.729 -112.46289)"
        />
        <path
          className="cls-1"
          style={{ fill: '#333' }}
          d="M319.97232,130.32289a2.77,2.77,0,1,1,2.78156-2.77A2.77558,2.77558,0,0,1,319.97232,130.32289Zm0-4.3a1.53,1.53,0,1,0,1.53638,1.53A1.5332,1.5332,0,0,0,319.97232,126.02289Z"
          transform="translate(-304.729 -112.46289)"
        />
        <polygon
          className="cls-1"
          style={{ fill: '#333' }}
          points="7.334 4.215 7.7 3.019 12.608 4.511 12.242 5.706 7.334 4.215"
        />
        <polygon
          className="cls-1"
          style={{ fill: '#333' }}
          points="4.327 10.535 12.316 6.391 12.896 7.499 4.907 11.644 4.327 10.535"
        />
        <polygon
          className="cls-1"
          style={{ fill: '#333' }}
          points="4.956 13.495 5.224 12.275 13.053 14.085 12.786 15.305 4.956 13.495"
        />
      </g>
    </svg>
  );
};

export const TrackIcon = ({ height = '22px', width = '22px' }) => (
  <Icon component={() => <TrackSvg height={height} width={width} />} />
);

const WebTrackingTimeSvg = ({ width = '22px', height = '22px' }) => {
  return (
    <svg id="Icons" viewBox="0 0 16.119 18.345" width={width} height={height}>
      <g id="Time_-_for_riding_tours" data-name="Time - for riding tours">
        <circle
          cx="8.059"
          cy="10.286"
          r="7.559"
          style={{ fill: '#e5e5e5', stroke: '#272425', strokeMiterlimit: 10 }}
        />
        <line
          x1="8.059"
          y1="0.75"
          x2="8.059"
          y2="2.25"
          style={{ fill: 'none', stroke: '#272425', strokeMiterlimit: 10 }}
        />
        <line
          x1="6.548"
          y1="0.5"
          x2="9.571"
          y2="0.5"
          style={{
            fill: 'none',
            stroke: '#272425',
            strokeLinecap: 'round',
            strokeMiterlimit: 10,
          }}
        />
        <line
          x1="8.059"
          y1="4.994"
          x2="8.059"
          y2="10.286"
          style={{
            fill: 'none',
            stroke: '#272425',
            strokeLinecap: 'round',
            strokeMiterlimit: 10,
          }}
        />
        <line
          x1="11.965"
          y1="12.55"
          x2="8.059"
          y2="10.286"
          style={{
            fill: 'none',
            stroke: '#272425',
            strokeLinecap: 'round',
            strokeMiterlimit: 10,
          }}
        />
      </g>
    </svg>
  );
};

export const WebTrackingTimeIcon = ({ height = '22px', width = '22px' }) => (
  <Icon
    component={() => <WebTrackingTimeSvg height={height} width={width} />}
  />
);

const WebTrackingDistanceSvg = ({ width = '22px', height = '22px' }) => {
  return (
    <svg id="Icons" viewBox="0 0 20.762 15.021" width={width} height={height}>
      <path
        d="M318.528,1549.783a1.867,1.867,0,0,0-1.76,1.231h-7.73a1.846,1.846,0,1,0,0,1.231h7.73A1.866,1.866,0,1,0,318.528,1549.783Z"
        transform="translate(-302.533 -1538.455)"
        style={{ fill: '#363636' }}
      />
      <circle cx="4.745" cy="3.328" r="1.919" style={{ fill: '#fff' }} />
      <circle cx="15.995" cy="3.328" r="1.919" style={{ fill: '#fff' }} />
      <path
        d="M321.633,1539.363h-6.3a0.728,0.728,0,0,0-.765.682v5.413a0.622,0.622,0,0,0,.132.38,0.822,0.822,0,0,0,.2.18l3.587,3.177,3.55-3.15c0.037-.038.084-0.076,0.13-0.115s0.067-.056.1-0.09a0.623,0.623,0,0,0,.134-0.382v-5.413A0.728,0.728,0,0,0,321.633,1539.363Z"
        transform="translate(-302.533 -1538.455)"
        style={{ fill: '#e5e5e5' }}
      />
      <path
        d="M321.633,1538.841h-6.3a1.249,1.249,0,0,0-1.288,1.2v5.413a1.146,1.146,0,0,0,.238.7l0.035,0.039a1.09,1.09,0,0,0,.268.242l3.9,3.458,3.907-3.468c0.037-.036.071-0.065,0.106-0.093a1.861,1.861,0,0,0,.148-0.134l0.038-.044a1.141,1.141,0,0,0,.239-0.7v-5.413A1.249,1.249,0,0,0,321.633,1538.841Zm0.765,6.617a0.623,0.623,0,0,1-.134.382c-0.035.035-.069,0.062-0.1,0.09s-0.092.077-.13,0.115l-3.55,3.15-3.587-3.177a0.822,0.822,0,0,1-.2-0.18,0.622,0.622,0,0,1-.132-0.38v-5.413a0.728,0.728,0,0,1,.765-0.682h6.3a0.728,0.728,0,0,1,.765.682v5.413Z"
        transform="translate(-302.533 -1538.455)"
        style={{
          fill: '#363636',
          stroke: '#363636',
          strokeMiterlimit: 10,
          strokeWidth: 0.75,
        }}
      />
      <path
        d="M310.445,1539.36h-6.4a0.739,0.739,0,0,0-.777.692v5.5a0.632,0.632,0,0,0,.134.386,0.834,0.834,0,0,0,.2.183l3.641,3.225,3.6-3.2c0.038-.039.085-0.078,0.131-0.116s0.068-.056.1-0.092a0.633,0.633,0,0,0,.136-0.388v-5.495A0.739,0.739,0,0,0,310.445,1539.36Z"
        transform="translate(-302.533 -1538.455)"
        style={{ fill: '#e5e5e5' }}
      />
      <path
        d="M310.612,1538.83h-6.4a1.268,1.268,0,0,0-1.307,1.222v5.5a1.163,1.163,0,0,0,.242.707l0.035,0.04a1.107,1.107,0,0,0,.272.246l3.956,3.51,3.966-3.521c0.037-.036.072-0.065,0.107-0.094a1.89,1.89,0,0,0,.151-0.136l0.039-.045a1.158,1.158,0,0,0,.242-0.707v-5.495A1.268,1.268,0,0,0,310.612,1538.83Zm0.777,6.717a0.633,0.633,0,0,1-.136.388c-0.036.035-.07,0.063-0.1,0.092s-0.094.078-.131,0.116l-3.6,3.2-3.641-3.225a0.834,0.834,0,0,1-.2-0.183,0.632,0.632,0,0,1-.134-0.386v-5.5a0.739,0.739,0,0,1,.777-0.692h6.4a0.739,0.739,0,0,1,.777.692v5.495Z"
        transform="translate(-302.533 -1538.455)"
        style={{
          fill: '#363636',
          stroke: '#363636',
          strokeMiterlimit: 10,
          strokeWidth: 0.75,
        }}
      />
    </svg>
  );
};

export const WebTrackingDistanceIcon = ({
  height = '22px',
  width = '22px',
}) => (
  <Icon
    component={() => <WebTrackingDistanceSvg height={height} width={width} />}
  />
);

const WebTrackingToursSvg = ({ width = '30px', height = '30px' }) => {
  return (
    <svg id="Icons" viewBox="0 0 19.983 14.917" width={width} height={height}>
      <path
        d="M1022.875,2491.668a2.174,2.174,0,0,0-.41.089l-0.276-.43h0a1.269,1.269,0,0,0,.322-0.156,1.136,1.136,0,0,0,.226-0.239,1.22,1.22,0,0,0,.159-0.267,1.171,1.171,0,0,0,.065-0.627,1.483,1.483,0,0,0-.1-0.346,2.531,2.531,0,0,0-.929-0.98,5.477,5.477,0,0,0-1.282-.673c-0.021-.008-2.119-0.764-2.4-0.129a0.5,0.5,0,0,0,.123.491l0.05,0.064,1.078,0.2-0.076.317a3.863,3.863,0,0,1-.476.047c-0.13,0-.218,0-0.3,0a1.094,1.094,0,0,0-.389.036,1.659,1.659,0,0,0-.672.437l-0.016.014a1.89,1.89,0,0,0-.495.611,0.967,0.967,0,0,0-.088.262,0.565,0.565,0,0,1-.044.141,1.353,1.353,0,0,1-.568.585,1.65,1.65,0,0,1-.619.228,2.384,2.384,0,0,1-.775-0.087,5.476,5.476,0,0,1-1.021-.355l-0.055-.025-4.226.494-0.007.182a0.885,0.885,0,0,0,.1.448,1.182,1.182,0,0,0,.363.382,3.266,3.266,0,0,0,.334.233l0.054,0.033,1.618-.047,1.582,1.262-0.373.092a2.252,2.252,0,0,0-2.05-.936,2.178,2.178,0,0,0,.506,4.327,2.281,2.281,0,0,0,1.915-2.271l0.57-.108a1.341,1.341,0,0,0,.173.548,1.325,1.325,0,0,0,.351.4,1.308,1.308,0,0,0,.656.247l0.021,0,3.562-.384,0.052-.048a5.277,5.277,0,0,0,.872-1.047,2.768,2.768,0,0,0,.383-0.841,1.316,1.316,0,0,0,.033-0.374,1.265,1.265,0,0,1,.019-0.294,2.037,2.037,0,0,1,.358-0.88,3.429,3.429,0,0,1,.368-0.414l0.039-.037,0.316,0.543A2.178,2.178,0,1,0,1022.875,2491.668Z"
        transform="translate(-1009.184 -2483.25)"
        style={{
          fill: '#e5e5e5',
          stroke: '#363636',
          strokeMiterlimit: 10,
          strokeWidth: 0.400000005960465,
        }}
      />
      <path
        d="M1023.262,2495.16a1.337,1.337,0,0,1-1.445-.99,1.341,1.341,0,0,1,.164-1.051,0.166,0.166,0,0,1,.28.177,1,1,0,0,0,1.1,1.509,1,1,0,0,0-.326-1.974,0.166,0.166,0,1,1-.024-0.331,1.336,1.336,0,0,1,.434,2.625A1.355,1.355,0,0,1,1023.262,2495.16Z"
        transform="translate(-1009.184 -2483.25)"
        style={{
          fill: '#fff',
          stroke: '#363636',
          strokeMiterlimit: 10,
          strokeWidth: 0.300000011920929,
        }}
      />
      <path
        d="M1011.721,2496.519a1.336,1.336,0,1,1,.708-2.346,0.166,0.166,0,0,1-.214.253,0.994,0.994,0,0,0-.766-0.231,1,1,0,1,0,1.119,1.064,0.166,0.166,0,0,1,.331.022A1.335,1.335,0,0,1,1011.721,2496.519Z"
        transform="translate(-1009.184 -2483.25)"
        style={{
          fill: '#fff',
          stroke: '#363636',
          strokeMiterlimit: 10,
          strokeWidth: 0.300000011920929,
        }}
      />
      <path
        d="M1010.333,2497.917a21.877,21.877,0,0,1,6.917-1.25,45.636,45.636,0,0,0,6.5-.51,3.681,3.681,0,0,0,2.583-1.073,3.474,3.474,0,0,0,.5-2.917c-0.343-1.377-1.34-1.715-1.167-2.5,0.167-.76,1.229-0.535,1.75-1.417,0.682-1.156-.569-2.424.083-3.667a2.454,2.454,0,0,1,1.417-1.083"
        transform="translate(-1009.184 -2483.25)"
        style={{
          fill: 'none',
          stroke: '#363636',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeWidth: 0.5,
        }}
      />
    </svg>
  );
};

export const WebTrackingToursIcon = ({ height = '30px', width = '30px' }) => (
  <Icon
    component={() => <WebTrackingToursSvg height={height} width={width} />}
  />
);

const MemberSvg = ({ height = '22px', width = '22px' }) => {
  return (
    <svg viewBox="0 0 17.98 17.94" width={width} height={height}>
      <g>
        <g>
          <path
            className="cls-1"
            style={{ fill: ' #e6e7e7' }}
            d="M307.11189,328.62765a0.69071,0.69071,0,0,1-.66-0.71v-4.2a0.67257,0.67257,0,0,0-.43-0.63,1.1881,1.1881,0,0,1-.73-1.12v-2.98a1.15871,1.15871,0,0,1,1.11-1.19h2.75a2.54429,2.54429,0,0,0-.28,1.19v2.98a2.547,2.547,0,0,0,1.17,2.16v3.79a2.1608,2.1608,0,0,0,.12.71h-3.05Z"
            transform="translate(-304.79189 -311.19765)"
          />
          <path
            className="cls-2"
            style={{ fill: '#333' }}
            d="M308.44189,318.29765a3.10371,3.10371,0,0,0-.08.69v2.98a3.06717,3.06717,0,0,0,1.17,2.42v3.53a1.47683,1.47683,0,0,0,.01.21h-2.43a0.20189,0.20189,0,0,1-.16-0.21v-4.2a1.1939,1.1939,0,0,0-.75-1.1,0.6929,0.6929,0,0,1-.41-0.65v-2.98a0.65232,0.65232,0,0,1,.61-0.69h2.04m1.1-1h-3.14a1.65306,1.65306,0,0,0-1.61,1.69v2.98a1.68525,1.68525,0,0,0,1.05,1.58,0.17512,0.17512,0,0,1,.11.17v4.2a1.18511,1.18511,0,0,0,1.16,1.21h3.39a0.29056,0.29056,0,0,0,.24-0.14,0.29908,0.29908,0,0,0,0-.29,1.60684,1.60684,0,0,1-.2-0.77v-3.9a0.2944,0.2944,0,0,0-.14-0.25,2.04944,2.04944,0,0,1-1.02-1.79v-2.98a2.08615,2.08615,0,0,1,.39-1.22,0.42457,0.42457,0,0,0,.02-0.33,0.305,0.305,0,0,0-.25-0.16h0Z"
            transform="translate(-304.79189 -311.19765)"
          />
        </g>
        <g>
          <path
            className="cls-1"
            style={{ fill: ' #e6e7e7' }}
            d="M317.38189,328.63765a2.184,2.184,0,0,0,.13-0.72v-3.79a2.57047,2.57047,0,0,0,1.17-2.16v-2.98a2.70369,2.70369,0,0,0-.28-1.19l2.76,0.01a1.15231,1.15231,0,0,1,1.11,1.19v2.98a1.1967,1.1967,0,0,1-.74,1.12,0.68263,0.68263,0,0,0-.43.63v4.2a0.68267,0.68267,0,0,1-.65.71h-3.07Z"
            transform="translate(-304.79189 -311.19765)"
          />
          <path
            className="cls-2"
            style={{ fill: '#333' }}
            d="M319.10189,318.30765h2.05a0.65906,0.65906,0,0,1,.61.69v2.98a0.696,0.696,0,0,1-.42.65,1.1896,1.1896,0,0,0-.74,1.1v4.2a0.19533,0.19533,0,0,1-.15.21h-2.44a1.62015,1.62015,0,0,0,.01-0.22v-3.53a3.06718,3.06718,0,0,0,1.17-2.42v-2.98a5.05636,5.05636,0,0,0-.09-0.68m-1.1-1h0a0.28478,0.28478,0,0,0-.25.16,0.27228,0.27228,0,0,0,.03.3,2.13248,2.13248,0,0,1,.39,1.22v2.98a2.03756,2.03756,0,0,1-1.02,1.79,0.28511,0.28511,0,0,0-.14.25v3.9a1.655,1.655,0,0,1-.2.79,0.29908,0.29908,0,0,0,0,.29,0.27891,0.27891,0,0,0,.24.15h3.4a1.17691,1.17691,0,0,0,1.15-1.21v-4.2a0.18483,0.18483,0,0,1,.11-0.17,1.69406,1.69406,0,0,0,1.06-1.58v-2.98a1.65306,1.65306,0,0,0-1.61-1.69h-3.16Z"
            transform="translate(-304.79189 -311.19765)"
          />
        </g>
        <g>
          <path
            className="cls-1"
            style={{ fill: ' #e6e7e7' }}
            d="M312.80189,328.62765a0.69071,0.69071,0,0,1-.66-0.71v-4.2a0.67257,0.67257,0,0,0-.43-0.63,1.182,1.182,0,0,1-.74-1.12v-2.98a1.15871,1.15871,0,0,1,1.11-1.19h3.44a1.15231,1.15231,0,0,1,1.11,1.19v2.98a1.1881,1.1881,0,0,1-.73,1.12,0.67257,0.67257,0,0,0-.43.63v4.2a0.68413,0.68413,0,0,1-.66.71h-2.01Z"
            transform="translate(-304.79189 -311.19765)"
          />
          <path
            className="cls-2"
            style={{ fill: '#333' }}
            d="M315.53189,318.29765a0.65906,0.65906,0,0,1,.61.69v2.98a0.6929,0.6929,0,0,1-.41.65,1.17369,1.17369,0,0,0-.75,1.1v4.2a0.19372,0.19372,0,0,1-.16.21h-2.01a0.20189,0.20189,0,0,1-.16-0.21v-4.2a1.18827,1.18827,0,0,0-.76-1.1,0.686,0.686,0,0,1-.42-0.65v-2.98a0.65232,0.65232,0,0,1,.61-0.69h3.45m0-1h-3.44a1.65306,1.65306,0,0,0-1.61,1.69v2.98a1.684,1.684,0,0,0,1.06,1.58,0.17512,0.17512,0,0,1,.11.17v4.2a1.18511,1.18511,0,0,0,1.16,1.21h2.01a1.18511,1.18511,0,0,0,1.16-1.21v-4.2a0.18483,0.18483,0,0,1,.11-0.17,1.68525,1.68525,0,0,0,1.05-1.58v-2.98a1.66623,1.66623,0,0,0-1.61-1.69h0Z"
            transform="translate(-304.79189 -311.19765)"
          />
        </g>
        <g>
          <path
            className="cls-1"
            style={{ fill: ' #e6e7e7' }}
            d="M319.65189,315.97765a2.1442,2.1442,0,1,1,2.01-2.14A2.07932,2.07932,0,0,1,319.65189,315.97765Z"
            transform="translate(-304.79189 -311.19765)"
          />
          <path
            className="cls-2"
            style={{ fill: '#333' }}
            d="M319.65189,312.19765a1.6456,1.6456,0,1,1-1.51,1.64,1.57892,1.57892,0,0,1,1.51-1.64m0-1a2.64337,2.64337,0,1,0,2.51,2.64,2.57378,2.57378,0,0,0-2.51-2.64h0Z"
            transform="translate(-304.79189 -311.19765)"
          />
        </g>
        <g>
          <path
            className="cls-1"
            style={{ fill: ' #e6e7e7' }}
            d="M313.80189,315.97765a2.1442,2.1442,0,1,1,2.01-2.14A2.07932,2.07932,0,0,1,313.80189,315.97765Z"
            transform="translate(-304.79189 -311.19765)"
          />
          <path
            className="cls-2"
            style={{ fill: '#333' }}
            d="M313.80189,312.19765a1.6456,1.6456,0,1,1-1.51,1.64,1.57892,1.57892,0,0,1,1.51-1.64m0-1a2.64337,2.64337,0,1,0,2.51,2.64,2.57378,2.57378,0,0,0-2.51-2.64h0Z"
            transform="translate(-304.79189 -311.19765)"
          />
        </g>
        <g>
          <path
            className="cls-1"
            style={{ fill: ' #e6e7e7' }}
            d="M307.90189,315.97765a2.1442,2.1442,0,1,1,2.01-2.14A2.07932,2.07932,0,0,1,307.90189,315.97765Z"
            transform="translate(-304.79189 -311.19765)"
          />
          <path
            className="cls-2"
            style={{ fill: '#333' }}
            d="M307.90189,312.19765a1.6456,1.6456,0,1,1-1.51,1.64,1.57892,1.57892,0,0,1,1.51-1.64m0-1a2.64337,2.64337,0,1,0,2.51,2.64,2.57378,2.57378,0,0,0-2.51-2.64h0Z"
            transform="translate(-304.79189 -311.19765)"
          />
        </g>
      </g>
    </svg>
  );
};
export const MemberIcon = ({ width = '22px', height = '22px' }) => (
  <Icon component={() => <MemberSvg height={height} width={width} />} />
);
export const MemberSearchIcon = (props) => (
  <Icon {...props} component={() => <MemberSvg {...props} />} />
);

const TourNewsSvg = ({ width, height }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width={width}
      height={height}
      viewBox="0 0 30 29"
    >
      <image
        id="image0"
        width="30"
        height="29"
        x="0"
        y="0"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAdCAMAAACKeiw+AAAABGdBTUEAALGPC/xhBQAAACBjSFJN
AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAgVBMVEUAAAAoIyUnIyQvKys1
MjMrJiclJSUoJCTb3NxoZWUoJCQmIyWbmponIyStrKwmIyMoJCQnIiTb3NxoZWXMzMxnZGWJiIg2
MjPNzc2JiYmsrKy9vb2tra1YVVUnIyRZVVa9vb0pJSYoICgoJCU2MzMqJicnIyQmIyMnIyTo6en/
//8dv0fPAAAAKHRSTlMAYO/Z0OQwQPDAgKDJwNCfP3Dxv+O/w9DkxM/Y0MCwwdniIPHP4/BQCyt8
7gAAAAFiS0dEKlO+1J4AAAAHdElNRQfjCRsAAzDb+BIMAAAAlElEQVQoz83T2xKCIBCA4TWwhIjQ
0iwrO2jF+79gIjcLA141Tv/tN8PuMLMAyYJQU/pxW4JpRTIdivGR10JP8UZGeKuUmuCUUpJbLna4
cRxjWktueV/iKp9Dj8/F0vnOwz+tVjufevQ5O+GaeTeXZ1Ttc0Nxl9/MFhyuIs4tH86giPHt/gDI
n12ovu9eb3tH4cyRfQEIkWjYmbfEDAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOS0wOS0yN1QwNzow
Mzo0OC0wNzowMEn7zgIAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTktMDktMjdUMDc6MDM6NDgtMDc6
MDA4pna+AAAAAElFTkSuQmCC"
      />
    </svg>
  );
};

export const TourNewsIcon = () => (
  <Icon component={() => <TourNewsSvg height="22px" width="22px" />} />
);

const SettingsSvg = ({ width = '22px', height = '22px' }) => {
  return (
    <svg viewBox="0 0 17.96642 18.00001" width={width} height={height}>
      <g>
        <path
          className="cls-1"
          style={{ fill: '#e6e7e7' }}
          d="M321.78719,478.94054l-0.02-.03a0.64276,0.64276,0,0,0-.6-0.33l-2.57-.03a0.63932,0.63932,0,0,0-.06-0.16,0.50663,0.50663,0,0,0-.07-0.15c0-.01-0.01-0.01-0.01-0.02l1.87-1.84a0.676,0.676,0,0,0,0-.95l-2.08-2.14a0.676,0.676,0,0,0-.95,0l-1.87,1.82a0.79318,0.79318,0,0,1-.09-0.04c-0.07-.03-0.15-0.07-0.22-0.1v-2.62a0.67663,0.67663,0,0,0-.66-0.68l-2.97-.03h-0.01a0.66792,0.66792,0,0,0-.67.66l-0.03,2.61c-0.04.02-.08,0.03-0.09,0.04-0.09.03-.17,0.06-0.25,0.09l-1.82-1.86a0.6761,0.6761,0,0,0-.35-0.19,0.6837,0.6837,0,0,0-.58.15,0.23571,0.23571,0,0,0-.05.05l-2.1,2.06a0.676,0.676,0,0,0,0,.95l1.82,1.86a1.55716,1.55716,0,0,1-.06.15c-0.03.06-.05,0.12-0.08,0.18l-2.61-.02h0a0.668,0.668,0,0,0-.67.66l-0.03,2.94a0.59859,0.59859,0,0,0,.14.5,0.70372,0.70372,0,0,0,.5.24l2.61,0.04,0.03,0.09q0.045,0.135.09,0.24l-1.85,1.83a0.676,0.676,0,0,0,0,.95l2.08,2.13a0.676,0.676,0,0,0,.95,0l1.87-1.82a0.79308,0.79308,0,0,1,.09.04c0.07,0.03.14,0.07,0.22,0.1l-0.02,2.62a0.68344,0.68344,0,0,0,.66.68l2.96,0.03h0.03a0.62673,0.62673,0,0,0,.45-0.18,0.70207,0.70207,0,0,0,.22-0.49l0.03-2.61a0.46491,0.46491,0,0,0,.09-0.03c0.08-.03.17-0.06,0.24-0.09l1.82,1.86a0.62732,0.62732,0,0,0,.34.18,0.14862,0.14862,0,0,1,.06.01,0.65161,0.65161,0,0,0,.6-0.2l2.09-2.06a0.676,0.676,0,0,0,0-.95l-1.82-1.87a0.4179,0.4179,0,0,0,.04-0.1c0.01-.02.01-0.04,0.02-0.06,0.02-.05.05-0.1,0.07-0.15l2.62,0.02h0.01a0.67,0.67,0,0,0,.67-0.67l0.03-2.91A0.51519,0.51519,0,0,0,321.78719,478.94054Zm-8.81,3.79a2.0701,2.0701,0,1,1,2.09-2.07A2.09136,2.09136,0,0,1,312.97719,482.73054Z"
          transform="translate(-303.89868 -471.64054)"
        />
        <path
          className="cls-2"
          style={{ fill: '#333' }}
          d="M311.80719,472.65054l2.32,0.03v2.96l0.62,0.25a1.3018,1.3018,0,0,1,.17.08l0.12,0.05,0.62,0.27,0.48-.47,1.64-1.59,1.62,1.67-1.63,1.6-0.5.51,0.3,0.64a0.59377,0.59377,0,0,0,.04.08l0.01,0.03,0.01,0.03,0.01,0.02,0.16,0.73,0.8,0.01,2.27,0.02-0.03,2.36-2.29-.02-0.67-.01-0.26.62c-0.02.04-.03,0.08-0.05,0.12l-0.06.12-0.01.04v0.01l-0.28.62,0.48,0.49,1.6,1.64-1.66,1.63-1.6-1.64-0.48-.49-0.63.27a1.70754,1.70754,0,0,1-.18.07l-0.09.03-0.68.23-0.01.69-0.03,2.28-2.32-.03,0.02-2.29,0.01-.68-0.63-.25c-0.06-.02-0.11-0.05-0.16-0.07a0.80936,0.80936,0,0,0-.13-0.06l-0.62-.27-0.48.47-1.64,1.6-1.62-1.65,1.62-1.6,0.49-.48-0.27-.63a1.041,1.041,0,0,1-.06-0.16l-0.04-.11-0.23-.66-0.7-.01-2.27-.03,0.03-2.34,2.29,0.02,0.67,0.01,0.26-.62,0.06-.15,0.06-.19,0.26-.61-0.46-.48-1.6-1.64,1.65-1.62,1.6,1.63,0.48,0.49,0.63-.26c0.05-.02.11-0.04,0.18-0.07l0.11-.04,0.65-.24,0.01-.69,0.02-2.27m1.17,11.08a3.07006,3.07006,0,1,0-3.09-3.07,3.10277,3.10277,0,0,0,3.09,3.07m-1.49-12.09h0a0.6702,0.6702,0,0,0-.68.66l-0.03,2.61c-0.04.02-.08,0.03-0.09,0.04-0.09.03-.17,0.06-0.25,0.09l-1.82-1.86a0.6761,0.6761,0,0,0-.35-0.19,0.66021,0.66021,0,0,0-.14-0.01,0.69891,0.69891,0,0,0-.44.16,0.23571,0.23571,0,0,0-.05.05l-2.1,2.06a0.676,0.676,0,0,0,0,.95l1.82,1.86a1.55716,1.55716,0,0,1-.06.15c-0.03.06-.05,0.12-0.08,0.18l-2.61-.02h0a0.668,0.668,0,0,0-.67.66l-0.03,2.94a0.59859,0.59859,0,0,0,.14.5,0.70372,0.70372,0,0,0,.5.24l2.61,0.04,0.03,0.09q0.045,0.135.09,0.24l-1.85,1.83a0.676,0.676,0,0,0,0,.95l2.08,2.13a0.67631,0.67631,0,0,0,.94,0l1.87-1.82a0.79308,0.79308,0,0,1,.09.04c0.07,0.03.14,0.07,0.22,0.1l-0.02,2.62a0.68345,0.68345,0,0,0,.66.68l2.96,0.03h0.03a0.62673,0.62673,0,0,0,.45-0.18,0.70207,0.70207,0,0,0,.22-0.49l0.03-2.61a0.46491,0.46491,0,0,0,.09-0.03c0.08-.03.17-0.06,0.24-0.09l1.82,1.86a0.62732,0.62732,0,0,0,.34.18,0.14862,0.14862,0,0,1,.06.01,0.41019,0.41019,0,0,0,.11.01,0.67154,0.67154,0,0,0,.49-0.21l2.09-2.06a0.676,0.676,0,0,0,0-.95l-1.82-1.87a0.4179,0.4179,0,0,0,.04-0.1c0.01-.02.01-0.04,0.02-0.06,0.02-.05.05-0.1,0.07-0.15l2.62,0.02h0.01a0.67,0.67,0,0,0,.67-0.67l0.03-2.91a0.73106,0.73106,0,0,0-.07-0.41l-0.02-.03a0.66459,0.66459,0,0,0-.57-0.34h-0.03l-2.57-.03a0.63932,0.63932,0,0,0-.06-0.16,0.50664,0.50664,0,0,0-.07-0.15c0-.01-0.01-0.01-0.01-0.02l1.87-1.84a0.676,0.676,0,0,0,0-.95l-2.08-2.14a0.67631,0.67631,0,0,0-.94,0l-1.87,1.82a0.7932,0.7932,0,0,1-.09-0.04c-0.07-.03-0.15-0.07-0.22-0.1v-2.6a0.67663,0.67663,0,0,0-.66-0.68l-2.96-.03h0Zm1.49,11.09a2.0701,2.0701,0,1,1,2.09-2.07,2.09136,2.09136,0,0,1-2.09,2.07h0Z"
          transform="translate(-303.89868 -471.64054)"
        />
      </g>
    </svg>
  );
};

export const SettingsIcon = () => (
  <Icon component={() => <SettingsSvg height="22px" width="22px" />} />
);

const AboutSvg = ({ height = '22px', width = '22px' }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      width={width}
      height={height}
      viewBox="0 0 30 30"
    >
      <image
        id="image0"
        width="30"
        height="30"
        x="0"
        y="0"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAsVBMVEUAAAAQEA0RDw0RDw0S
DgwQEBASDgyPjY2goJ9TUlERDw0QEAvZ2Nh8enkRDw4SEA7l5eUQEA7o6OgQEBAQEA0SDg0RDw0f
Hhzg4OChn58RDw0QEAwRDg0QEA0RDw2zsrLZ2dh7enoSDg0RDw0RDw1ramimpqUTEQ8sKik4NzV/
fn24uLjb29oaGBYQEA5BPz5YVVTBwcGysbHT09OysrFUU1FnZmXl5eURDw3p6en///9RruijAAAA
OHRSTlMAUK+/jyCQwb/Q7zDQxM+A42/xEF+f4PDZwPBAsGDQwNDDoMDfwc/iycTE2fHYcNnDxMDE
wc/I5G+3FL8AAAABYktHRDpOCcT6AAAAB3RJTUUH4wkaFzsMQt0A4AAAASVJREFUKM91ku1awjAM
hTtGh7SyitOBLZ1ahvjFJip6ev835jZwDsnOr+R5254kDWO0gkE45KxPEUZnYyF7qMS5934S92A1
rqi/APW8nIZo8OUJTq6uBdJIzeYVvtFHzAxj6IWtr2Sz27t7BFXEByI0jE8HAllkDgfhUizrJMlX
/mGdQzvbOknh2v4fK5dV1m0xibM2tk8Vfo66NSzSpI35+sW/bky3ad19yugNVCe3sMfN8qX7S6RQ
7J8sWrMkX5zOURe/0TJLTnGUHwKnqU/kMAcXwyjti5MoSMqC+u+4cKxHOhZhTJW1nzLKtxJxD3bY
VpN/h6IvY1Qvj58IEht8NHgLSeNtgz9Bb77eNbhM6dIKfH37+a7ZPUoKtSzrEy9UQRj/ALSLIpTR
GFxvAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE5LTA5LTI3VDA2OjU5OjEyLTA3OjAwHoh6JgAAACV0
RVh0ZGF0ZTptb2RpZnkAMjAxOS0wOS0yN1QwNjo1OToxMi0wNzowMG/VwpoAAAAASUVORK5CYII="
      />
    </svg>
  );
};
export const AboutIcon = () => <Icon component={() => <AboutSvg />} />;
export const AboutSearchIcon = ({ width, height }) => (
  <Icon component={() => <AboutSvg width={width} height={height} />} />
);

const ProSvg = ({ width = '24px', height = '24px' }) => {
  return (
    <svg viewBox="0 0 16.19043 20.20923" width={width} height={height}>
      <g>
        <path
          className="cls-1"
          style={{ fill: '#e5e6e6' }}
          d="M313.924,151.63473a0.07649,0.07649,0,0,0-.07764-0.01465l-7.1416,3.752a0.1539,0.1539,0,0,0-.06787.12207c0,6.98828,2.62451,12.27979,7.19971,14.51758a0.09108,0.09108,0,0,0,.07959.00049c4.583-2.22705,7.21094-7.51514,7.21094-14.5083a0.13069,0.13069,0,0,0-.061-0.11816Zm0.34375,17.16748a0.81458,0.81458,0,0,1-.38574.08936,0.85751,0.85751,0,0,1-.38672-0.09033c-3.88574-1.896-6.11426-6.31982-6.11426-12.13623a1.01339,1.01339,0,0,1,.519-0.90234l5.56152-2.92383a0.88305,0.88305,0,0,1,.83154,0l5.56885,2.92285a1.04157,1.04157,0,0,1,.521.90332C320.383,162.49167,318.154,166.915,314.26773,168.80221Z"
          transform="translate(-305.78678 -150.70968)"
        />
        <path
          className="cls-2"
          style={{ fill: '#333' }}
          d="M321.43961,154.563l-7.14014-3.75a0.89647,0.89647,0,0,0-.83545,0l-7.14111,3.751a1.07232,1.07232,0,0,0-.53613.93018c0,7.36426,2.81055,12.95264,7.71289,15.3335a0.912,0.912,0,0,0,.38232.09131,0.96551,0.96551,0,0,0,.39453-0.09277c4.894-2.38086,7.70068-7.96924,7.70068-15.332A1.046,1.046,0,0,0,321.43961,154.563Zm-7.52344,15.44922a0.09108,0.09108,0,0,1-.07959-0.00049c-4.5752-2.23779-7.19971-7.5293-7.19971-14.51758a0.1539,0.1539,0,0,1,.06787-0.12207l7.1416-3.752a0.07649,0.07649,0,0,1,.07764.01465l7.14209,3.751a0.13069,0.13069,0,0,1,.061.11816C321.12711,162.497,318.49918,167.78512,313.91617,170.01218Z"
          transform="translate(-305.78678 -150.70968)"
        />
        <path
          className="cls-2"
          style={{ fill: '#333' }}
          d="M314.0607,153.28122a0.382,0.382,0,0,0-.3667,0l-5.55957,2.92285a0.52129,0.52129,0,0,0-.25342.46094c0,5.61865,2.12646,9.87842,5.83447,11.6875l0.002,0.001a0.3841,0.3841,0,0,0,.31934.00537c3.71973-1.80664,5.84619-6.06641,5.84619-11.69385a0.53944,0.53944,0,0,0-.25928-0.46387Zm5.77832,3.39307c0,5.57178-2.11133,9.79053-5.793,11.57471a0.3765,0.3765,0,0,1-.1665.03857,0.34457,0.34457,0,0,1-.19043-0.05518c-3.65283-1.78223-5.76416-6.00391-5.76416-11.56738a0.42956,0.42956,0,0,1,.2251-0.35449l5.61523-2.94727,0.1167-.01855a0.36935,0.36935,0,0,1,.13135.02686l5.61816,2.94336A0.41427,0.41427,0,0,1,319.839,156.67428Z"
          transform="translate(-305.78678 -150.70968)"
        />
        <path
          className="cls-2"
          style={{ fill: '#333' }}
          d="M319.862,155.76169l-5.56885-2.92285a0.88305,0.88305,0,0,0-.83154,0l-5.56152,2.92383a1.01339,1.01339,0,0,0-.519.90234c0,5.81641,2.22852,10.24023,6.11426,12.13623a0.85751,0.85751,0,0,0,.38672.09033,0.81458,0.81458,0,0,0,.38574-0.08936c3.88623-1.88721,6.11523-6.31055,6.11523-12.13721A1.04157,1.04157,0,0,0,319.862,155.76169Zm-5.8252,12.59717a0.3841,0.3841,0,0,1-.31934-0.00537l-0.002-.001c-3.708-1.80908-5.83447-6.06885-5.83447-11.6875a0.52129,0.52129,0,0,1,.25342-0.46094l5.55957-2.92285a0.382,0.382,0,0,1,.3667,0l5.563,2.91992a0.53944,0.53944,0,0,1,.25928.46387C319.883,162.29245,317.7565,166.55221,314.03678,168.35885Z"
          transform="translate(-305.78678 -150.70968)"
        />
        <path
          className="cls-2"
          style={{ fill: '#333' }}
          d="M313.882,153.34469l-0.1167.01855-5.61523,2.94727a0.42956,0.42956,0,0,0-.2251.35449c0,5.56348,2.11133,9.78516,5.76416,11.56738a0.34457,0.34457,0,0,0,.19043.05518,0.3765,0.3765,0,0,0,.1665-0.03857c3.68164-1.78418,5.793-6.00293,5.793-11.57471a0.41427,0.41427,0,0,0-.20752-0.35937l-5.61816-2.94336A0.36935,0.36935,0,0,0,313.882,153.34469Zm5.712,3.32947c0,5.46735-2.056,9.60706-5.65173,11.34961h-0.005a0.11674,0.11674,0,0,1-.10559,0c-3.58649-1.75177-5.65173-5.88226-5.65173-11.35883a0.1631,0.1631,0,0,1,.08295-0.129l5.56879-2.92267a0.13112,0.13112,0,0,1,.0553-0.01849,0.23583,0.23583,0,0,1,.06458.01849l5.56873,2.92267A0.1625,0.1625,0,0,1,319.594,156.67416Z"
          transform="translate(-305.78678 -150.70968)"
        />
        <path
          className="cls-3"
          style={{ fill: '#fff' }}
          d="M312.82651,162.75882a0.79517,0.79517,0,0,0-.79694.797l0.0011,0.00537a0.79588,0.79588,0,0,1,1.59174,0l0.0011-.00537A0.79519,0.79519,0,0,0,312.82651,162.75882Z"
          transform="translate(-305.78678 -150.70968)"
        />
        <path
          className="cls-3"
          style={{ fill: '#fff' }}
          d="M317.19913,158.48312a0.64369,0.64369,0,0,1-.63544-0.63544A0.63658,0.63658,0,0,0,317.19913,158.48312Z"
          transform="translate(-305.78678 -150.70968)"
        />
        <path
          className="cls-3"
          style={{ fill: '#fff' }}
          d="M312.58957,162.188a1.76567,1.76567,0,0,1,.23694-0.02155,1.32948,1.32948,0,0,1,.45233.07538l2.99408-3.67255a1.4543,1.4543,0,0,1-.16156-0.28l-3.96332,1.10931a0.43753,0.43753,0,0,1,0,.11847,0.91347,0.91347,0,0,1-.35541.73236Z"
          transform="translate(-305.78678 -150.70968)"
        />
        <path
          className="cls-3"
          style={{ fill: '#fff' }}
          d="M313.887,153.59476a0.13112,0.13112,0,0,0-.0553.01849l-5.56879,2.92267a0.1631,0.1631,0,0,0-.08295.129c0,5.47656,2.06525,9.60706,5.65173,11.35883a0.11674,0.11674,0,0,0,.10559,0h0.005c3.59576-1.74255,5.65173-5.88226,5.65173-11.34961a0.1625,0.1625,0,0,0-.07373-0.13824l-5.56873-2.92267A0.23583,0.23583,0,0,0,313.887,153.59476Zm3.31213,3.079a1.17392,1.17392,0,1,1,0,2.34784,1.14159,1.14159,0,0,1-.49542-0.10773l-2.94019,3.608a1.39405,1.39405,0,1,1-1.68011-.14l-0.797-1.9386h-0.05383a0.937,0.937,0,1,1,.7-1.5509L316.036,157.74A1.16265,1.16265,0,0,1,317.19913,156.6738Z"
          transform="translate(-305.78678 -150.70968)"
        />
        <path
          className="cls-4"
          style={{ fill: '#e6e6e6' }}
          d="M311.22178,159.03238a0.47388,0.47388,0,1,0,.43616.657,0.46389,0.46389,0,0,0,.03772-0.18311A0.47812,0.47812,0,0,0,311.22178,159.03238Z"
          transform="translate(-305.78678 -150.70968)"
        />
        <circle
          className="cls-4"
          style={{ fill: '#e6e6e6' }}
          cx="11.41235"
          cy="7.138"
          r="0.63544"
        />
        <ellipse
          className="cls-4"
          style={{ fill: '#e6e6e6' }}
          cx="7.03975"
          cy="12.85152"
          rx="0.79587"
          ry="0.7916"
        />
        <path
          className="cls-2"
          style={{ fill: '#333' }}
          d="M311.23258,158.5693a0.937,0.937,0,1,0,0,1.874h0.05383l0.797,1.9386a1.40758,1.40758,0,1,0,1.68011.14l2.94019-3.608a1.14159,1.14159,0,0,0,.49542.10773,1.17392,1.17392,0,1,0,0-2.34784A1.16265,1.16265,0,0,0,316.036,157.74l-4.10339,1.15234A0.93453,0.93453,0,0,0,311.23258,158.5693Zm5.96655-1.35706a0.63544,0.63544,0,1,1,0,1.27087,0.63658,0.63658,0,0,1-.63544-0.63544A0.64373,0.64373,0,0,1,317.19913,157.21225Zm-5.5412,2.47711a0.47207,0.47207,0,1,1,.03772-0.18311A0.46389,0.46389,0,0,1,311.65793,159.68936Zm1.96448,3.87183a0.79588,0.79588,0,0,1-1.59174,0l-0.0011-.00537a0.797,0.797,0,1,1,1.59393,0Zm-1.47437-4.1626,3.96332-1.10931a1.4543,1.4543,0,0,0,.16156.28l-2.99408,3.67255a1.32948,1.32948,0,0,0-.45233-0.07538,1.76567,1.76567,0,0,0-.23694.02155l-0.79694-1.9386a0.91347,0.91347,0,0,0,.35541-0.73236A0.43753,0.43753,0,0,0,312.148,159.39859Z"
          transform="translate(-305.78678 -150.70968)"
        />
      </g>
    </svg>
  );
};

export const ProIcon = ({ width = '22px', height = '22px' }) => (
  <Icon component={() => <ProSvg width={width} height={height} />} />
);

export const SeeListSvg = () => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      viewBox="0 0 60.123 60.123"
      width="22px"
      height="22px"
    >
      <g>
        <path d="M57.124,51.893H16.92c-1.657,0-3-1.343-3-3s1.343-3,3-3h40.203c1.657,0,3,1.343,3,3S58.781,51.893,57.124,51.893z" />
        <path
          d="M57.124,33.062H16.92c-1.657,0-3-1.343-3-3s1.343-3,3-3h40.203c1.657,0,3,1.343,3,3
		C60.124,31.719,58.781,33.062,57.124,33.062z"
        />
        <path d="M57.124,14.231H16.92c-1.657,0-3-1.343-3-3s1.343-3,3-3h40.203c1.657,0,3,1.343,3,3S58.781,14.231,57.124,14.231z" />
        <circle cx="4.029" cy="11.463" r="4.029" />
        <circle cx="4.029" cy="30.062" r="4.029" />
        <circle cx="4.029" cy="48.661" r="4.029" />
      </g>
    </svg>
  );
};
export const SeeListIcon = () => <Icon component={SeeListSvg} />;

export const SeeMapSvg = () => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      viewBox="0 0 55 55"
      width="22px"
      height="22px"
    >
      <path
        d="M54.584,2.189c-0.261-0.188-0.597-0.241-0.901-0.137l-17.73,5.91L19.229,4.027c-0.042-0.01-0.083,0.004-0.125,0
    c-0.107-0.011-0.214-0.025-0.321-0.002l-18,4C0.326,8.127,0,8.532,0,9.001v43c0,0.304,0.138,0.59,0.375,0.78
    c0.179,0.144,0.4,0.22,0.625,0.22c0.072,0,0.145-0.008,0.217-0.023l17.807-3.957l16.802,2.965c0.058,0.011,0.116,0.016,0.174,0.016
    c0.121,0,0.24-0.024,0.352-0.066c0.003-0.001,0.007,0,0.01-0.002l18-7C54.747,44.783,55,44.413,55,44.001v-41
    C55,2.679,54.846,2.378,54.584,2.189z M2,9.802l16-3.555v40.951L2,50.754V9.802z M20,6.263l15,3.529v40.016l-15-2.646V6.263z
    M53,43.317l-16,6.222V9.721l16-5.333V43.317z"
      />
    </svg>
  );
};
export const SeeMapIcon = () => <Icon component={SeeMapSvg} />;

export const TourstartTranferMobileTab = () => {
  return (
    <svg width="50px" height="28px" viewBox="-8 -5 85 35">
      <defs>
        <path id="sjywa" d="M15.17 53.73V27.31h39v26.42z" />
        <path id="sjywb" d="M68.69 38.23V27.31H85.9v10.92z" />
        <path
          id="sjywc"
          d="M54.9 25.526H14.398c-.887 0-1.606.72-1.606 1.607v26.4c0 .887.719 1.607 1.606 1.607H54.9c.887 0 1.607-.72 1.607-1.607v-26.4c0-.887-.72-1.607-1.607-1.607zM15.98 52.16V28.52h37.34v23.64z"
        />
        <path id="sjywd" d="M31.12 59.37v-5.64h7.05v5.64z" />
        <path
          id="sjywe"
          d="M41.922 57.607H27.375c-1.429 0-2.598.793-2.598 1.763H44.52c0-.97-1.169-1.763-2.598-1.763z"
        />
        <path
          id="sjywf"
          d="M85.557 26.677H69.303c-.912 0-1.652.74-1.652 1.652v8.961c0 .912.74 1.652 1.652 1.652h16.254c.912 0 1.651-.74 1.651-1.652v-8.961c0-.912-.739-1.652-1.651-1.652zM69.58 37.52v-9.51h15.63v9.51z"
        />
        <path
          id="sjywg"
          d="M77.401 36.787c-1.28 0-2.32.866-2.32 1.934h4.64c0-1.068-1.039-1.934-2.32-1.934z"
        />
        <path id="sjywh" d="M76.926 41.379l-3.475 2.324 6.27.782z" />
        <path id="sjywi" d="M60.48 54.541l2.084-5.01 2.577 7.787z" />
        <path id="sjywj" d="M63.002 53.73s8.676.557 13.697-10.541" />
        <path
          id="sjywk"
          d="M72.564 38.226l5.625-3.667h4.583l.624-2.458 2.5-.75v-3.708l-5.291-.334-.626 4.25-3.28-.666-1.177-2.084-1.007 1.32-.993 1.305-2.168 2.167-2.665-1.07"
        />
        <path id="sjywl" d="M76.992 35.393l-2.863-4.757" />
        <path
          id="sjywm"
          d="M26.91 47.37a3.27 3.27 0 1 0 6.54 0 3.27 3.27 0 0 0-6.54 0z"
        />
        <path
          id="sjywn"
          d="M23.572 36.81a1.77 1.77 0 1 0 3.543 0 1.77 1.77 0 1 0-3.543 0z"
        />
        <path
          id="sjywo"
          d="M39.654 32.723a2.313 2.313 0 1 0 4.626 0 2.313 2.313 0 0 0-4.626 0z"
        />
        <path
          id="sjywp"
          d="M30.12 47.86l-5.144-11.227 17.675-4.345zm-4.41-10.872l4.531 9.892 11.041-13.72z"
        />
      </defs>
      <g>
        <g transform="translate(-12 -25)">
          <g opacity=".6">
            <g opacity=".6">
              <use fill="#fff" xlinkHref="#sjywa" />
            </g>
          </g>
          <g opacity=".6">
            <g opacity=".6">
              <use fill="#fff" xlinkHref="#sjywb" />
            </g>
          </g>
          <g>
            <use xlinkHref="#sjywc" />
          </g>
          <g>
            <use xlinkHref="#sjywd" />
          </g>
          <g>
            <use xlinkHref="#sjywe" />
          </g>
          <g>
            <use xlinkHref="#sjywf" />
          </g>
          <g>
            <use xlinkHref="#sjywg" />
          </g>
          <g>
            <use xlinkHref="#sjywh" />
          </g>
          <g>
            <use xlinkHref="#sjywi" />
          </g>
          <g>
            <use
              fill="#fff"
              fillOpacity="0"
              strokeMiterlimit="50"
              strokeWidth="2"
              xlinkHref="#sjywj"
            />
          </g>
          <g>
            <use
              fill="#fff"
              fillOpacity="0"
              strokeMiterlimit="50"
              strokeWidth=".5"
              xlinkHref="#sjywk"
            />
          </g>
          <g>
            <use
              fill="#fff"
              fillOpacity="0"
              strokeMiterlimit="50"
              strokeWidth=".5"
              xlinkHref="#sjywl"
            />
          </g>
          <g>
            <use xlinkHref="#sjywm" />
          </g>
          <g>
            <use xlinkHref="#sjywn" />
          </g>
          <g>
            <use xlinkHref="#sjywo" />
          </g>
          <g>
            <use xlinkHref="#sjywp" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const TourstartTranferDropDown = () => {
  return (
    <svg width="50px" height="50px" viewBox="0 0 75 35">
      <defs>
        <path id="sjywa" d="M15.17 53.73V27.31h39v26.42z" />
        <path id="sjywb" d="M68.69 38.23V27.31H85.9v10.92z" />
        <path
          id="sjywc"
          d="M54.9 25.526H14.398c-.887 0-1.606.72-1.606 1.607v26.4c0 .887.719 1.607 1.606 1.607H54.9c.887 0 1.607-.72 1.607-1.607v-26.4c0-.887-.72-1.607-1.607-1.607zM15.98 52.16V28.52h37.34v23.64z"
        />
        <path id="sjywd" d="M31.12 59.37v-5.64h7.05v5.64z" />
        <path
          id="sjywe"
          d="M41.922 57.607H27.375c-1.429 0-2.598.793-2.598 1.763H44.52c0-.97-1.169-1.763-2.598-1.763z"
        />
        <path
          id="sjywf"
          d="M85.557 26.677H69.303c-.912 0-1.652.74-1.652 1.652v8.961c0 .912.74 1.652 1.652 1.652h16.254c.912 0 1.651-.74 1.651-1.652v-8.961c0-.912-.739-1.652-1.651-1.652zM69.58 37.52v-9.51h15.63v9.51z"
        />
        <path
          id="sjywg"
          d="M77.401 36.787c-1.28 0-2.32.866-2.32 1.934h4.64c0-1.068-1.039-1.934-2.32-1.934z"
        />
        <path id="sjywh" d="M76.926 41.379l-3.475 2.324 6.27.782z" />
        <path id="sjywi" d="M60.48 54.541l2.084-5.01 2.577 7.787z" />
        <path id="sjywj" d="M63.002 53.73s8.676.557 13.697-10.541" />
        <path
          id="sjywk"
          d="M72.564 38.226l5.625-3.667h4.583l.624-2.458 2.5-.75v-3.708l-5.291-.334-.626 4.25-3.28-.666-1.177-2.084-1.007 1.32-.993 1.305-2.168 2.167-2.665-1.07"
        />
        <path id="sjywl" d="M76.992 35.393l-2.863-4.757" />
        <path
          id="sjywm"
          d="M26.91 47.37a3.27 3.27 0 1 0 6.54 0 3.27 3.27 0 0 0-6.54 0z"
        />
        <path
          id="sjywn"
          d="M23.572 36.81a1.77 1.77 0 1 0 3.543 0 1.77 1.77 0 1 0-3.543 0z"
        />
        <path
          id="sjywo"
          d="M39.654 32.723a2.313 2.313 0 1 0 4.626 0 2.313 2.313 0 0 0-4.626 0z"
        />
        <path
          id="sjywp"
          d="M30.12 47.86l-5.144-11.227 17.675-4.345zm-4.41-10.872l4.531 9.892 11.041-13.72z"
        />
      </defs>
      <g>
        <g transform="translate(-12 -25)">
          <g opacity=".6">
            <g opacity=".6">
              <use fill="#fff" xlinkHref="#sjywa" />
            </g>
          </g>
          <g opacity=".6">
            <g opacity=".6">
              <use fill="#fff" xlinkHref="#sjywb" />
            </g>
          </g>
          <g>
            <use xlinkHref="#sjywc" />
          </g>
          <g>
            <use xlinkHref="#sjywd" />
          </g>
          <g>
            <use xlinkHref="#sjywe" />
          </g>
          <g>
            <use xlinkHref="#sjywf" />
          </g>
          <g>
            <use xlinkHref="#sjywg" />
          </g>
          <g>
            <use xlinkHref="#sjywh" />
          </g>
          <g>
            <use xlinkHref="#sjywi" />
          </g>
          <g>
            <use
              fill="#fff"
              fillOpacity="0"
              strokeMiterlimit="50"
              strokeWidth="2"
              xlinkHref="#sjywj"
            />
          </g>
          <g>
            <use
              fill="#fff"
              fillOpacity="0"
              strokeMiterlimit="50"
              strokeWidth=".5"
              xlinkHref="#sjywk"
            />
          </g>
          <g>
            <use
              fill="#fff"
              fillOpacity="0"
              strokeMiterlimit="50"
              strokeWidth=".5"
              xlinkHref="#sjywl"
            />
          </g>
          <g>
            <use xlinkHref="#sjywm" />
          </g>
          <g>
            <use xlinkHref="#sjywn" />
          </g>
          <g>
            <use xlinkHref="#sjywo" />
          </g>
          <g>
            <use xlinkHref="#sjywp" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const ScenicSvg = ({ width = '25', height = '25' }) => {
  return (
    <svg viewBox="0 0 18 12.53294" width={width} height={height}>
      <g>
        <path
          className="cls-1"
          style={{ fill: '#e5e6e6' }}
          d="M1070.42983,2376.45213l-2.54972-2.97749a0.23245,0.23245,0,0,1,.18011-0.38274h1.45216l-1.96435-2.27955a0.23124,0.23124,0,0,1-.03377-0.25328,0.23516,0.23516,0,0,1,.21388-0.13508h0.93433l-2.606-3.02814-1.29456,1.54784-1.31707,1.53659,0.97936-.02814a0.23516,0.23516,0,0,1,.21388.13508,0.244,0.244,0,0,1-.03377.25328l-1.99812,2.33021,1.50282-.01689a0.23516,0.23516,0,0,1,.21388.13508,0.22207,0.22207,0,0,1-.03377.24765l-0.37711.45028-2.18949,2.49343,3.56285-.02814a0.23782,0.23782,0,0,1,.2364.2364v2.02627a0.30051,0.30051,0,0,0,.09006.20826,0.28089,0.28089,0,0,0,.18574.06191h0.62477a0.31076,0.31076,0,0,0,.20825-0.09006,0.28088,0.28088,0,0,0,.06191-0.18574v-2.02627a0.23782,0.23782,0,0,1,.2364-0.2364h3.50094v0.00563Z"
          transform="translate(-1061.25535 -2366.93045)"
        />
        <path
          className="cls-2"
          style={{ fill: '#333' }}
          d="M1070.83509,2376.20448l-2.212-2.57786-0.05066-.06191h1.01876a0.41672,0.41672,0,0,0,.28143-0.09568,0.43528,0.43528,0,0,0,.1576-0.29831,0.43046,0.43046,0,0,0-.10131-0.32645l-1.6773-1.94184h0.48968a0.41672,0.41672,0,0,0,.28143-0.09569,0.4355,0.4355,0,0,0,.05628-0.61914l-2.66229-3.09568-0.05628-.05628a0.45358,0.45358,0,0,0-.34334-0.10131,0.4129,0.4129,0,0,0-.2758.1576l-2.63977,3.07317a0.41574,0.41574,0,0,0-.12383.30957,0.45529,0.45529,0,0,0,.45028.45028h0.48968l-1.65478,1.93058a0.41574,0.41574,0,0,0-.12383.30957,0.45529,0.45529,0,0,0,.45028.45028h1.01876l-2.22326,2.53846a0.42058,0.42058,0,0,0-.12946.30957,0.45909,0.45909,0,0,0,.45028.45028h3.34334v1.7955a0.78921,0.78921,0,0,0,.21388.52908,0.7275,0.7275,0,0,0,.52345.21951h0.62477a0.78921,0.78921,0,0,0,.52908-0.21388,0.74913,0.74913,0,0,0,.21388-0.52908v-1.78987h3.34334a0.41672,0.41672,0,0,0,.28142-0.09569,0.44579,0.44579,0,0,0,.05629-0.62477h0Zm-4.15385.48405v2.02627a0.30524,0.30524,0,0,1-.06191.18574,0.31076,0.31076,0,0,1-.20826.09006h-0.62477a0.30523,0.30523,0,0,1-.18574-0.06191,0.31076,0.31076,0,0,1-.09006-0.20826v-2.02627a0.23783,0.23783,0,0,0-.2364-0.2364l-3.56285.02814,2.18949-2.49343,0.37711-.45028a0.23767,0.23767,0,0,0-.16886-0.38837l-1.50281.02814,1.99812-2.33021a0.23124,0.23124,0,0,0,.03377-0.25328,0.23516,0.23516,0,0,0-.21388-0.13508l-0.97936.02814,1.31707-1.53658,1.29456-1.54784,2.606,3.02814h-0.93433a0.23516,0.23516,0,0,0-.21388.13508,0.244,0.244,0,0,0,.03377.25328l1.96435,2.27955h-1.45216a0.23516,0.23516,0,0,0-.21388.13508,0.22207,0.22207,0,0,0,.03377.24766l2.54972,2.97749h-3.5122A0.22166,0.22166,0,0,0,1066.68124,2376.68853Z"
          transform="translate(-1061.25535 -2366.93045)"
        />
        <path
          className="cls-1"
          style={{ fill: '#e5e6e6' }}
          d="M1076.71689,2374.49341a0.23516,0.23516,0,0,1,.21388-0.13508h1.03l-1.47467-1.70544a0.23124,0.23124,0,0,1-.03377-0.25328,0.23516,0.23516,0,0,1,.21388-0.13508h0.62477l-1.91932-2.23452-1.94184,2.257h0.64165a0.23516,0.23516,0,0,1,.21388.13508,0.244,0.244,0,0,1-.03377.25328l-1.4803,1.728h1.05253a0.23516,0.23516,0,0,1,.21388.13508,0.22207,0.22207,0,0,1-.03377.24766l-0.29831.3546-1.62664,1.85741h2.66792a0.23783,0.23783,0,0,1,.2364.2364v1.59287a0.17657,0.17657,0,0,0,.05628.12946,0.17178,0.17178,0,0,0,.10694.03377h0.48968a0.19535,0.19535,0,0,0,.13508-0.05629,0.22326,0.22326,0,0,0,.02814-0.10694v-1.59287a0.23782,0.23782,0,0,1,.2364-0.2364h2.6454l-1.93058-2.25141A0.23265,0.23265,0,0,1,1076.71689,2374.49341Z"
          transform="translate(-1061.25535 -2366.93045)"
        />
        <path
          className="cls-2"
          style={{ fill: '#333' }}
          d="M1079.14278,2376.82361h0l-1.71107-1.9925h0.69231a0.36422,0.36422,0,0,0,.25328-0.09006,0.41059,0.41059,0,0,0,.14071-0.26454,0.39685,0.39685,0,0,0-.09006-0.29268l-1.24953-1.4409h0.2758a0.37215,0.37215,0,0,0,.25328-0.09006,0.40028,0.40028,0,0,0,.05066-0.56285l-2.09381-2.43715a0.191,0.191,0,0,1-.03377-0.03377,0.38444,0.38444,0,0,0-.30394-0.09006,0.34587,0.34587,0,0,0-.24766.14071l-2.0713,2.409a0.37338,0.37338,0,0,0-.11257.28143,0.41089,0.41089,0,0,0,.40525.40525h0.2758l-1.22139,1.42964a0.37338,0.37338,0,0,0-.11257.28143,0.41089,0.41089,0,0,0,.40525.40525h0.69231l-1.67167,1.90807a0.36517,0.36517,0,0,0-.11257.28143,0.41089,0.41089,0,0,0,.40525.40525h2.57223v1.35647a0.65906,0.65906,0,0,0,.18574.45028,0.63392,0.63392,0,0,0,.45028.18011h0.48968a0.67845,0.67845,0,0,0,.45028-0.18011,0.63391,0.63391,0,0,0,.18011-0.45028v-1.35647h2.57223a0.392,0.392,0,0,0,.394-0.36022A0.51871,0.51871,0,0,0,1079.14278,2376.82361Zm-3.11257.17448a0.23782,0.23782,0,0,0-.2364.2364v1.59287a0.22326,0.22326,0,0,1-.02814.10694,0.19535,0.19535,0,0,1-.13508.05629h-0.48968a0.17178,0.17178,0,0,1-.10694-0.03377,0.18467,0.18467,0,0,1-.05628-0.12946v-1.59287a0.23782,0.23782,0,0,0-.2364-0.2364h-2.66792l1.62664-1.85741,0.29831-.3546a0.23245,0.23245,0,0,0-.18011-0.38274h-1.05253l1.4803-1.728a0.23124,0.23124,0,0,0,.03377-0.25328,0.23516,0.23516,0,0,0-.21388-0.13508h-0.64165l1.94184-2.257,1.91932,2.23452h-0.62477a0.23516,0.23516,0,0,0-.21388.13508,0.244,0.244,0,0,0,.03377.25328l1.47467,1.70544h-1.03a0.23516,0.23516,0,0,0-.21388.13508,0.22207,0.22207,0,0,0,.03377.24766l1.93058,2.25141h-2.64541v0.00563Z"
          transform="translate(-1061.25535 -2366.93045)"
        />
      </g>
    </svg>
  );
};

export const SeasideSvg = ({ width = '25', height = '25' }) => {
  return (
    <svg viewBox="0 0 18 13.946" width={width} height={height}>
      <g>
        <path
          className="cls-1"
          style={{ fill: '#333' }}
          d="M946.40822,2376.74422a4.70116,4.70116,0,0,1,2.217.53186,3.32629,3.32629,0,0,0,1.77474.51507c0.15116,0,.24634-0.0112.25193-0.0112a8.05536,8.05536,0,0,0,1.9315-.48148l0.07838-.03359a4.77521,4.77521,0,0,1,2.18344-.52067,4.51185,4.51185,0,0,1,2.03227.45908l0.24074,0.09517a4.41066,4.41066,0,0,0,3.91339-.0056c1.67957-.72781,2.17784-0.64383,2.83287-0.52067a0.2341,0.2341,0,0,0,.27433-0.20715,0.27443,0.27443,0,0,0-.21834-0.29672c-0.683-.12317-1.27647-0.22954-3.0904.55986a4.42582,4.42582,0,0,1-1.69076.41429l-0.10077.31352a0.24516,0.24516,0,0,1-.23514.17355h-0.0168a5.40831,5.40831,0,0,1-1.67957-.44788l-0.23514-.09518a4.69506,4.69506,0,0,0-1.84192-.45348h-0.0112c-0.06158,0-.11757-0.0056-0.17915-0.0056a4.84319,4.84319,0,0,0-2.18344.51507l-0.07838.03359a7.04155,7.04155,0,0,1-1.36045.3919,0.24667,0.24667,0,0,1-.28553-0.17356l-0.07838-.25753c-0.15676.028-.26313,0.03919-0.26873,0.03919a2.7811,2.7811,0,0,1-1.69636-.43109,5.176,5.176,0,0,0-2.497-.61024,0.251,0.251,0,0,0-.24634.25753A0.26829,0.26829,0,0,0,946.40822,2376.74422Z"
          transform="translate(-946.14508 -2366.70041)"
        />
        <path
          className="cls-1"
          style={{ fill: '#333' }}
          d="M963.92609,2377.6064c-0.683-.12317-1.27087-0.22954-3.0904.55986a3.9346,3.9346,0,0,1-3.53829-.0056l-0.22954-.08958a5.0491,5.0491,0,0,0-2.217-.49267,5.28256,5.28256,0,0,0-2.37379.55426l-0.07838.03359a7.58036,7.58036,0,0,1-1.80273.44788,2.822,2.822,0,0,1-1.69636-.43109,5.24734,5.24734,0,0,0-2.497-.61024,0.252,0.252,0,0,0,.0056.50387,4.77678,4.77678,0,0,1,2.217.53186,3.32629,3.32629,0,0,0,1.77474.51507c0.15116,0,.24074-0.0112.25193-0.0112a8.05547,8.05547,0,0,0,1.9315-.48148l0.07838-.03359a4.77124,4.77124,0,0,1,2.18344-.51507,4.51186,4.51186,0,0,1,2.03228.45908l0.24074,0.09518a4.39214,4.39214,0,0,0,3.91339-.0056c1.67957-.72781,2.17784-0.64383,2.83287-0.52067a0.2341,0.2341,0,0,0,.27433-0.20715A0.25132,0.25132,0,0,0,963.92609,2377.6064Z"
          transform="translate(-946.14508 -2366.70041)"
        />
        <path
          className="cls-1"
          style={{ fill: '#333' }}
          d="M963.92609,2379.1348c-0.683-.12317-1.27087-0.22954-3.0904.55986a3.9346,3.9346,0,0,1-3.53829-.0056l-0.22954-.08958a5.0491,5.0491,0,0,0-2.217-.49267,5.28256,5.28256,0,0,0-2.37379.55426l-0.07838.03359a7.58036,7.58036,0,0,1-1.80273.44788,2.822,2.822,0,0,1-1.69636-.43109,5.18775,5.18775,0,0,0-2.497-.61024,0.2461,0.2461,0,0,0-.24634.25194,0.25731,0.25731,0,0,0,.25193.24634,4.77678,4.77678,0,0,1,2.217.53186,3.32629,3.32629,0,0,0,1.77474.51507c0.15116,0,.24074-0.0112.25193-0.0112a8.05542,8.05542,0,0,0,1.9315-.48148l0.07838-.03359a4.77125,4.77125,0,0,1,2.18344-.51507,4.51186,4.51186,0,0,1,2.03228.45908l0.24074,0.09518a4.39214,4.39214,0,0,0,3.91339-.0056c1.67957-.72781,2.17784-0.64383,2.83287-0.52067a0.2341,0.2341,0,0,0,.27433-0.20715A0.24876,0.24876,0,0,0,963.92609,2379.1348Z"
          transform="translate(-946.14508 -2366.70041)"
        />
        <polygon
          className="cls-2"
          style={{ fill: '#e5e6e6' }}
          points="5.828 3.936 5.375 3.936 5.375 5.481 5.834 5.212 7.984 3.936 5.828 3.936"
        />
        <polygon
          className="cls-2"
          style={{ fill: '#e5e6e6' }}
          points="9.792 3.936 12.434 5.509 12.434 3.936 11.919 3.936 9.792 3.936"
        />
        <path
          className="cls-2"
          style={{ fill: '#e5e6e6' }}
          d="M952.39867,2376.8226l0.07838-.03359a5.41388,5.41388,0,0,1,2.3122-.55426v-5.4082l-4.52363,2.68171,1.08612,3.63346A7.05668,7.05668,0,0,0,952.39867,2376.8226Z"
          transform="translate(-946.14508 -2366.70041)"
        />
        <path
          className="cls-2"
          style={{ fill: '#e5e6e6' }}
          d="M955.28752,2370.82655v5.425a5.264,5.264,0,0,1,1.78034.48148l0.22954,0.08958a5.6571,5.6571,0,0,0,1.33805.3975l1.1645-3.68945Z"
          transform="translate(-946.14508 -2366.70041)"
        />
        <path
          className="cls-1"
          style={{ fill: '#333' }}
          d="M951.223,2377.67358a7.46235,7.46235,0,0,0,1.36045-.3919l0.07838-.03359a4.77125,4.77125,0,0,1,2.18344-.51507c0.06718,0,.12317,0,0.17915.0056h0.0112a4.69509,4.69509,0,0,1,1.84192.45348l0.23514,0.09518a5.366,5.366,0,0,0,1.67957.44788h0.0168a0.247,0.247,0,0,0,.23514-0.17355l0.10077-.31352,1.18689-3.76223a0.25291,0.25291,0,0,0-.112-0.29113l-1.1477-.68862v-2.12185a0.24491,0.24491,0,0,0-.24634-0.24634h-0.51507v-1.30446a0.24491,0.24491,0,0,0-.24634-0.24634h-2.07147v-1.64038a0.24491,0.24491,0,0,0-.24634-0.24634h-1.41643a0.24491,0.24491,0,0,0-.24634.24634v1.63478h-2.10506a0.24491,0.24491,0,0,0-.24634.24634v1.30446h-0.46468a0.24491,0.24491,0,0,0-.24634.24634v2.09386l-1.1757.69982a0.24273,0.24273,0,0,0-.112.28553l1.13091,3.779,0.07838,0.25753A0.24256,0.24256,0,0,0,951.223,2377.67358Zm0.29672-5.49218v-1.5508h2.61452l-2.14984,1.27647Zm3.06241-4.98831h0.91816v1.38844h-0.91816v-1.38844Zm-2.357,1.88671h5.593v1.05813h-5.58736v-1.05813h-0.0056Zm5.07229,7.7372-0.22954-.08958a5.39646,5.39646,0,0,0-1.78034-.48148v-5.425l4.51243,2.6985-1.1645,3.68945A5.40413,5.40413,0,0,1,957.29741,2376.817Zm1.28207-4.60761-2.63692-1.57879h2.64252v1.57879h-0.0056Zm-3.79022-1.38844v5.4082a5.33358,5.33358,0,0,0-2.3122.55426l-0.07838.03359a6.44759,6.44759,0,0,1-1.04693.31912l-1.08612-3.63346Z"
          transform="translate(-946.14508 -2366.70041)"
        />
        <polygon
          className="cls-2"
          style={{ fill: '#e5e6e6' }}
          points="8.891 3.438 11.673 3.438 11.673 2.379 9.602 2.379 8.185 2.379 6.08 2.379 6.08 3.438 8.891 3.438"
        />
        <rect
          className="cls-2"
          style={{ fill: '#e5e6e6' }}
          x="8.43702"
          y="0.49267"
          width="0.91816"
          height="1.38844"
        />
      </g>
    </svg>
  );
};

export const StraightSvg = ({ width = '25', height = '25' }) => {
  return (
    <svg viewBox="0 0 18 13.62526" width={width} height={height}>
      <g>
        <polygon
          className="cls-1"
          style={{ fill: '#fff' }}
          points="2.927 13.098 7.674 0.521 6.666 0.521 0.678 13.098 2.927 13.098"
        />
        <path
          className="cls-2"
          style={{ fill: '#e5e6e6' }}
          d="M1000.04326,2379.93262l-4.74193-12.57716h-0.50422v0.22095a0.25991,0.25991,0,0,1-.26061.26061,0.26858,0.26858,0,0,1-.26627-0.26061v-0.22095h-0.50988l-4.74193,12.57716h5.25181v-2.2095a0.25991,0.25991,0,0,1,.26061-0.26061,0.2636,0.2636,0,0,1,.26061.26061v2.2095h5.25181Zm-5.773-11.38743a0.25991,0.25991,0,0,1,.26061-0.26061,0.2636,0.2636,0,0,1,.26061.26061v0.68551a0.25991,0.25991,0,0,1-.26061.26061,0.2636,0.2636,0,0,1-.26061-0.26061v-0.68551Zm0,2.06787a0.25991,0.25991,0,0,1,.26061-0.26061,0.2636,0.2636,0,0,1,.26061.26061v1.50133a0.25991,0.25991,0,0,1-.26061.26061,0.2636,0.2636,0,0,1-.26061-0.26061v-1.50133Zm0.26061,5.45577a0.25991,0.25991,0,0,1-.26061-0.26061V2373.644a0.25991,0.25991,0,0,1,.26061-0.26061,0.2636,0.2636,0,0,1,.26061.26061v2.16418A0.2636,0.2636,0,0,1,994.53084,2376.06883Z"
          transform="translate(-985.53084 -2366.83425)"
        />
        <polygon
          className="cls-1"
          style={{ fill: '#fff' }}
          points="10.326 0.521 15.068 13.098 17.322 13.098 11.294 0.521 10.326 0.521"
        />
        <path
          className="cls-3"
          style={{ fill: '#333' }}
          d="M1003.50482,2380.07992l-6.27725-13.09838a0.26426,0.26426,0,0,0-.23795-0.1473H992.0324a0.26426,0.26426,0,0,0-.23795.1473l-6.23759,13.09838a0.26782,0.26782,0,0,0,.23795.37958h17.47206a0.252,0.252,0,0,0,.22095-0.12464A0.2575,0.2575,0,0,0,1003.50482,2380.07992Zm-8.974-2.61741a0.25991,0.25991,0,0,0-.26061.26061v2.2095h-5.25181l4.74193-12.57716h0.50422v0.22095a0.25991,0.25991,0,0,0,.26061.26061,0.2636,0.2636,0,0,0,.26061-0.26061v-0.22095H995.29l4.74193,12.57716h-5.24615v-2.2095A0.25175,0.25175,0,0,0,994.53084,2377.46251Zm-1.3257-10.10705-4.74193,12.57716h-2.25482l5.98831-12.57716h1.00844Zm7.39333,12.57716-4.74193-12.57716h0.96878l6.028,12.57716h-2.25482Z"
          transform="translate(-985.53084 -2366.83425)"
        />
        <path
          className="cls-3"
          style={{ fill: '#333' }}
          d="M994.53084,2369.49131a0.25991,0.25991,0,0,0,.26061-0.26061v-0.68551a0.25991,0.25991,0,0,0-.26061-0.26061,0.2636,0.2636,0,0,0-.26061.26061v0.68551A0.25991,0.25991,0,0,0,994.53084,2369.49131Z"
          transform="translate(-985.53084 -2366.83425)"
        />
        <path
          className="cls-3"
          style={{ fill: '#333' }}
          d="M994.53084,2372.38066a0.25991,0.25991,0,0,0,.26061-0.26061v-1.50133a0.25991,0.25991,0,0,0-.26061-0.26061,0.2636,0.2636,0,0,0-.26061.26061v1.50133A0.25991,0.25991,0,0,0,994.53084,2372.38066Z"
          transform="translate(-985.53084 -2366.83425)"
        />
        <path
          className="cls-3"
          style={{ fill: '#333' }}
          d="M994.79145,2373.644a0.25991,0.25991,0,0,0-.26061-0.26061,0.2636,0.2636,0,0,0-.26061.26061v2.16418a0.25991,0.25991,0,0,0,.26061.26061,0.2636,0.2636,0,0,0,.26061-0.26061V2373.644Z"
          transform="translate(-985.53084 -2366.83425)"
        />
      </g>
    </svg>
  );
};

export const MountainSvg = ({ width = '25', height = '25' }) => {
  return (
    <svg viewBox="0 0 18 15.06088" width={width} height={height}>
      <g>
        <path
          className="cls-1"
          style={{ fill: '#fff' }}
          d="M917.71342,2371.96265a0.43541,0.43541,0,0,1,.33026-0.16513h0.01708a0.39987,0.39987,0,0,1,.2847.13666,0.24765,0.24765,0,0,1,.03416.03986l2.2207,2.90968,1.28117-1.67407-3.06912-6.44-2.71608,5.63146-0.07972.16513,0.558,0.80856Z"
          transform="translate(-907.94227 -2366.07496)"
        />
        <polygon
          className="cls-2"
          style={{ fill: '#d3dfcb' }}
          points="6.537 11.365 6.531 11.371 6.531 11.371 6.537 11.365"
        />
        <path
          className="cls-1"
          style={{ fill: '#fff' }}
          d="M912.45207,2375.51577a0.4203,0.4203,0,0,1,.31318-0.16513,0.40918,0.40918,0,0,1,.32456.14235l1.71962,1.90752a0.28524,0.28524,0,0,1,.04555.03986l0.689,0.75732,0.75162-.7687-3.11467-6.53682-2.4086,4.99372,0.79148,0.73454Z"
          transform="translate(-907.94227 -2366.07496)"
        />
        <path
          className="cls-3"
          style={{ fill: '#e5e6e6' }}
          d="M922.15481,2373.80185l-1.22423,1.54879h0v0.00569a0.41784,0.41784,0,0,1-.33026.16513h-0.00569a0.4076,0.4076,0,0,1-.33026-0.17082l-2.2207-2.91538-1.14451,1.42352a0.42565,0.42565,0,0,1-.34734.16513,0.41648,0.41648,0,0,1-.33026-0.1936l-0.47261-.689-0.45553.93953s3.04634,6.42863,3.05773,6.47419h7.01513l-1.99863-4.20794Z"
          transform="translate(-907.94227 -2366.07496)"
        />
        <path
          className="cls-3"
          style={{ fill: '#e5e6e6' }}
          d="M915.83436,2378.68738a0.42617,0.42617,0,0,1-.29609.131,0.40179,0.40179,0,0,1-.30748-0.14235l-0.60927-.6719c0,0.00569-.00569.00569-0.02278-0.01139l-1.81642-2.01-0.88258,1.099a0.41784,0.41784,0,0,1-.33026.16513,0.43124,0.43124,0,0,1-.2847-0.11388l-0.7687-.71746-1.99293,4.13961h9.24721l-1.22992-2.59081Z"
          transform="translate(-907.94227 -2366.07496)"
        />
        <path
          className="cls-4"
          style={{ fill: '#333' }}
          d="M923.82887,2376.0681l-4.6293-9.73121a0.43831,0.43831,0,0,0-.3872-0.26193h0a0.4264,0.4264,0,0,0-.3872.25624l-1.97016,4.08836-0.97938,2.03279h0l-0.4783.99077-1.42352-2.99509a0.469,0.469,0,0,0-.26762-0.24485,0.43343,0.43343,0,0,0-.11958-0.01708h-0.05694a0.02092,0.02092,0,0,0-.01708.00569H913.1012a0.45328,0.45328,0,0,0-.30179.25054l-0.9623,1.99863-1.62282,3.36521h0l-2.215,4.59513a0.54224,0.54224,0,0,0,.0057.49539,0.43232,0.43232,0,0,0,.37581.23915h17.12214a0.43232,0.43232,0,0,0,.37581-0.23915,0.53672,0.53672,0,0,0,.01139-0.484Zm-7.73258-3.667,2.71608-5.63146,3.06342,6.44572-1.28117,1.67406-2.2207-2.90968c-0.01139-.01139-0.02278-0.02847-0.03416-0.03986a0.44812,0.44812,0,0,0-.2847-0.13666H918.038a0.41784,0.41784,0,0,0-.33026.16513l-1.13882,1.41783-0.558-.80856Zm-2.91538-1.50893,3.109,6.53682-0.75162.7687-0.689-.75732a0.1535,0.1535,0,0,0-.04555-0.03986l-1.71962-1.90752a0.40918,0.40918,0,0,0-.32456-0.14235,0.4203,0.4203,0,0,0-.31318.16513l-0.88258,1.10465-0.79148-.73454Zm1.29825,6.54821c0,0.0057-.00569.0057,0,0h0Zm-5.956,3.109,1.99293-4.13961,0.7687,0.71746a0.40468,0.40468,0,0,0,.2847.11388,0.43475,0.43475,0,0,0,.33026-0.16513l0.88258-1.099,1.81642,2.01c0.01708,0.01708.02278,0.01708,0.02278,0.01139l0.60927,0.6719a0.40176,0.40176,0,0,0,.60357.01139l0.70607-.72315,1.22992,2.59081h-9.24721Zm9.82231,0c-0.00569-.04555-3.05773-6.47419-3.05773-6.47419l0.45553-.93952,0.47261,0.689a0.43185,0.43185,0,0,0,.33026.1936,0.41724,0.41724,0,0,0,.34734-0.16513l1.14451-1.42352,2.2207,2.91538a0.424,0.424,0,0,0,.33026.17082h0.00569a0.43541,0.43541,0,0,0,.33026-0.16513v-0.00569h0l1.22993-1.5431,1.20715,2.53957,1.99863,4.20794h-7.01513Z"
          transform="translate(-907.94227 -2366.07496)"
        />
      </g>
    </svg>
  );
};

export const TwistedSvg = ({ width = '25', height = '25' }) => {
  return (
    <svg viewBox="0 0 18 15.41619" width={width} height={height}>
      <g>
        <path
          className="cls-1"
          style={{ fill: '#e5e6e6' }}
          d="M1039.45037,2376.79494a2.65777,2.65777,0,0,1-5.31553.0057V2372.044c-0.0057-.1768-0.12547-4.46573-4.46573-4.46573s-4.46573,4.28893-4.47144,4.47144v3.35928h2.61784v-3.787a1.78575,1.78575,0,0,1,.43916-1.1863,1.80012,1.80012,0,0,1,2.39541,0,1.75935,1.75935,0,0,1,.43916,1.19771v4.73949c0,0.22243.09125,5.48664,5.48663,5.48664s5.48663-5.2642,5.48663-5.48664v-1.5285l-2.61784-.0057v1.95625h0.0057Zm-12.42763-2.77754a0.286,0.286,0,0,1-.28517.28517,0.2824,0.2824,0,0,1-.28517-0.28517V2372.198a0.286,0.286,0,0,1,.28517-0.28517,0.2824,0.2824,0,0,1,.28517.28517v1.81937Zm2.08173-4.80794a1.95533,1.95533,0,0,0-1.81367,1.17489,0.2792,0.2792,0,0,1-.26235.1711,0.24716,0.24716,0,0,1-.10836-0.02281,0.29017,0.29017,0,0,1-.154-0.37072,2.50292,2.50292,0,0,1,2.3669-1.51709,0.28105,0.28105,0,0,1,.26806.29657A0.27151,0.27151,0,0,1,1029.10447,2369.20946Zm2.18439,0.46768a0.28233,0.28233,0,1,1,.22243-0.519,2.567,2.567,0,0,1,1.3631,2.50378,0.28486,0.28486,0,0,1-.28517.27947h-0.0057a0.28991,0.28991,0,0,1-.27947-0.29087A2.0115,2.0115,0,0,0,1031.28886,2369.67714Zm1.37451,7.50563h-0.03992a0.27824,0.27824,0,0,1-.27946-0.24525c-0.03422-.25095-0.03422-2.10454-0.03422-2.46956a0.28517,0.28517,0,1,1,.57034,0c0,0.83839.0057,2.23,0.02852,2.39541A0.28456,0.28456,0,0,1,1032.66337,2377.18277Zm3.16537,3.62163a3.11393,3.11393,0,0,1-2.5437-1.36881,0.28436,0.28436,0,0,1,.09125-0.38783,0.27784,0.27784,0,0,1,.38783.08555,2.54128,2.54128,0,0,0,2.06462,1.10645,0.286,0.286,0,0,1,.28517.28517A0.27765,0.27765,0,0,1,1035.82873,2380.8044Zm4.66535-4.87637a0.286,0.286,0,0,1,.28517-0.28517,0.2824,0.2824,0,0,1,.28517.28517v1.21482a0.286,0.286,0,0,1-.28517.28517,0.2824,0.2824,0,0,1-.28517-0.28517V2375.928Zm-0.79847,3.09692a0.28474,0.28474,0,1,1,.49619.27947,3.5904,3.5904,0,0,1-2.09313,1.49428,0.294,0.294,0,0,1-.3422-0.211,0.28248,0.28248,0,0,1,.20532-0.3422A3.07592,3.07592,0,0,0,1039.69561,2379.025Z"
          transform="translate(-1024.62733 -2367.01367)"
        />
        <path
          className="cls-2"
          style={{ fill: '#333' }}
          d="M1042.35338,2374.27975l-3.18248-.0057h0a0.26753,0.26753,0,0,0-.19962.08555,0.29045,0.29045,0,0,0-.08555.19962v2.23a2.09315,2.09315,0,1,1-4.18627.01141V2372.044c0-.05133-0.13118-5.03037-5.03607-5.03037s-5.03607,4.979-5.03607,5.03607v3.65015a0.286,0.286,0,0,0,.28517.28517h3.18248a0.286,0.286,0,0,0,.28517-0.28517v-4.08361a1.20024,1.20024,0,0,1,.28517-0.78136,1.01781,1.01781,0,0,1,.78706-0.28517,1.03649,1.03649,0,0,1,.78706.27947,1.21833,1.21833,0,0,1,.28517.79847v4.7509c0,0.06274.09125,6.05127,6.05127,6.05127s6.05127-5.98853,6.05127-6.05127v-1.81367A0.273,0.273,0,0,0,1042.35338,2374.27975Zm-0.28517,2.09313c0,0.22243-.09125,5.48664-5.48663,5.48664s-5.48664-5.2642-5.48664-5.48664v-4.73949a1.79231,1.79231,0,0,0-.43916-1.19771,1.80012,1.80012,0,0,0-2.39541,0,1.77243,1.77243,0,0,0-.44486,1.1863v3.787h-2.61784v-3.35928c0.0057-.18251.12547-4.47144,4.47144-4.47144s4.46573,4.28893,4.46573,4.46573v4.75661a2.65777,2.65777,0,0,0,5.31553-.0057v-1.95625l2.61784,0.0057v1.5285Z"
          transform="translate(-1024.62733 -2367.01367)"
        />
        <path
          className="cls-2"
          style={{ fill: '#333' }}
          d="M1026.73757,2371.91856a0.286,0.286,0,0,0-.28517.28517v1.81937a0.286,0.286,0,0,0,.28517.28517,0.2824,0.2824,0,0,0,.28517-0.28517v-1.81937A0.2824,0.2824,0,0,0,1026.73757,2371.91856Z"
          transform="translate(-1024.62733 -2367.01367)"
        />
        <path
          className="cls-2"
          style={{ fill: '#333' }}
          d="M1029.133,2368.64483a2.484,2.484,0,0,0-2.36119,1.51709,0.28063,0.28063,0,0,0,.14829.37072,0.26453,0.26453,0,0,0,.10836.02281,0.28492,0.28492,0,0,0,.26235-0.1711,1.9624,1.9624,0,0,1,1.81367-1.16919,0.26854,0.26854,0,0,0,.29657-0.26806A0.28277,0.28277,0,0,0,1029.133,2368.64483Z"
          transform="translate(-1024.62733 -2367.01367)"
        />
        <path
          className="cls-2"
          style={{ fill: '#333' }}
          d="M1032.30976,2371.6505a0.28975,0.28975,0,0,0,.27946.29087h0.0057a0.28866,0.28866,0,0,0,.28517-0.27946,2.55857,2.55857,0,0,0-1.3631-2.50378,0.28233,0.28233,0,0,0-.22243.519A2.03155,2.03155,0,0,1,1032.30976,2371.6505Z"
          transform="translate(-1024.62733 -2367.01367)"
        />
        <path
          className="cls-2"
          style={{ fill: '#333' }}
          d="M1032.59493,2374.1885a0.286,0.286,0,0,0-.28517.28517c0,0.37072,0,2.21861.03422,2.46956a0.28242,0.28242,0,0,0,.27946.24524h0.03992a0.28779,0.28779,0,0,0,.24525-0.31939c-0.02281-.1654-0.02852-1.557-0.02852-2.39541A0.28974,0.28974,0,0,0,1032.59493,2374.1885Z"
          transform="translate(-1024.62733 -2367.01367)"
        />
        <path
          className="cls-2"
          style={{ fill: '#333' }}
          d="M1035.82873,2380.23977a2.54128,2.54128,0,0,1-2.06462-1.10645,0.27892,0.27892,0,0,0-.38783-0.08555,0.28559,0.28559,0,0,0-.09125.38783,3.11393,3.11393,0,0,0,2.5437,1.36881,0.286,0.286,0,0,0,.28517-0.28517A0.27765,0.27765,0,0,0,1035.82873,2380.23977Z"
          transform="translate(-1024.62733 -2367.01367)"
        />
        <path
          className="cls-2"
          style={{ fill: '#333' }}
          d="M1037.75077,2380.59338a0.28462,0.28462,0,0,0,.27376.21673,0.27764,0.27764,0,0,0,.06844-0.0057,3.62013,3.62013,0,0,0,2.09313-1.49428,0.28474,0.28474,0,0,0-.49619-0.27947,3.03224,3.03224,0,0,1-1.73382,1.22622A0.27559,0.27559,0,0,0,1037.75077,2380.59338Z"
          transform="translate(-1024.62733 -2367.01367)"
        />
        <path
          className="cls-2"
          style={{ fill: '#333' }}
          d="M1040.77355,2377.428a0.286,0.286,0,0,0,.28517-0.28517V2375.928a0.286,0.286,0,0,0-.28517-0.28517,0.2824,0.2824,0,0,0-.28517.28517v1.21482A0.28974,0.28974,0,0,0,1040.77355,2377.428Z"
          transform="translate(-1024.62733 -2367.01367)"
        />
      </g>
    </svg>
  );
};

export const ListSvg = () => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      width="25px"
      height="25px"
      x="0px"
      y="0px"
      viewBox="0 0 60.123 60.123"
    >
      <g>
        <path d="M57.124,51.893H16.92c-1.657,0-3-1.343-3-3s1.343-3,3-3h40.203c1.657,0,3,1.343,3,3S58.781,51.893,57.124,51.893z" />
        <path
          d="M57.124,33.062H16.92c-1.657,0-3-1.343-3-3s1.343-3,3-3h40.203c1.657,0,3,1.343,3,3
          C60.124,31.719,58.781,33.062,57.124,33.062z"
        />
        <path d="M57.124,14.231H16.92c-1.657,0-3-1.343-3-3s1.343-3,3-3h40.203c1.657,0,3,1.343,3,3S58.781,14.231,57.124,14.231z" />
        <circle cx="4.029" cy="11.463" r="4.029" />
        <circle cx="4.029" cy="30.062" r="4.029" />
        <circle cx="4.029" cy="48.661" r="4.029" />
      </g>
    </svg>
  );
};
export const NotificationSvg = () => {
  return (
    <svg
      width="25"
      height="25"
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
    >
      <path d="M1 20v-2.946c1.993-.656 2.575-2.158 3.668-6.077.897-3.218 1.891-6.784 4.873-8.023-.027-.147-.041-.299-.041-.454 0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5c0 .156-.014.309-.042.458 2.987 1.244 3.984 4.813 4.884 8.033 1.103 3.95 1.697 5.423 3.658 6.062v2.947h-7c0 2.208-1.792 4-4 4s-4-1.792-4-4h-7zm14 0h-6c0 1.656 1.344 3 3 3s3-1.344 3-3zm-13-1h20v-1.241c-2.062-.918-2.82-3.633-3.621-6.498-1.066-3.814-2.167-7.758-6.379-7.761-4.21 0-5.308 3.937-6.369 7.745-.8 2.872-1.559 5.593-3.631 6.514v1.241zm11.492-16.345l.008-.155c0-.828-.672-1.5-1.5-1.5s-1.5.672-1.5 1.5l.008.152c.455-.099.949-.152 1.487-.152.542 0 1.039.054 1.497.155z" />
    </svg>
  );
};

export const SixDotsSvg = () => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      viewBox="0 0 535.5 535.5"
      style={{ width: 14, fill: '#c2c4c3', marginLeft: '2px' }}
    >
      <g>
        <g>
          <path
            d="M439.721,66.708c0,8.976-1.731,17.442-5.199,25.398c-3.471,7.956-8.061,14.994-13.771,21.114
            c-5.712,6.12-12.546,10.914-20.502,14.382c-7.956,3.468-16.422,5.202-25.396,5.202c-8.979,0-17.442-1.734-25.398-5.202
            c-7.956-3.468-14.892-8.262-20.808-14.382c-5.916-6.12-10.608-13.158-14.076-21.114s-5.202-16.422-5.202-25.398
            s1.734-17.544,5.202-25.704s8.16-15.3,14.076-21.42S341.499,8.67,349.455,5.202C357.411,1.734,365.877,0,374.853,0
            s17.439,1.734,25.396,5.202c7.956,3.468,14.79,8.262,20.502,14.382s10.302,13.26,13.771,21.42
            C437.988,49.164,439.721,57.732,439.721,66.708z M439.721,268.057c0,9.383-1.731,18.053-5.199,26.01
            c-3.471,7.955-8.061,14.891-13.771,20.807s-12.546,10.609-20.502,14.076c-7.956,3.469-16.422,5.203-25.396,5.203
            c-8.979,0-17.442-1.734-25.398-5.203c-7.956-3.467-14.892-8.16-20.808-14.076s-10.608-12.852-14.076-20.807
            c-3.468-7.957-5.202-16.627-5.202-26.01c0-8.977,1.734-17.545,5.202-25.705c3.468-8.16,8.16-15.198,14.076-21.114
            s12.852-10.608,20.808-14.076c7.956-3.468,16.422-5.202,25.398-5.202s17.439,1.734,25.396,5.202
            c7.956,3.468,14.79,8.16,20.502,14.076s10.302,12.954,13.771,21.114C437.988,250.512,439.721,259.08,439.721,268.057z
            M437.885,469.404c0,8.979-1.632,17.34-4.896,25.092s-7.752,14.484-13.464,20.195c-5.712,5.713-12.444,10.201-20.196,13.465
            s-15.912,4.896-24.479,4.896c-8.568,0-16.729-1.635-24.48-4.896c-7.752-3.264-14.484-7.752-20.196-13.465
            c-5.712-5.711-10.198-12.443-13.464-20.195c-3.264-7.752-4.896-16.113-4.896-25.092c0-8.568,1.632-16.729,4.896-24.479
            c3.266-7.752,7.752-14.586,13.464-20.502s12.444-10.51,20.196-13.771c7.752-3.264,15.912-4.896,24.48-4.896
            c8.565,0,16.728,1.633,24.479,4.896s14.484,7.854,20.196,13.771c5.712,5.916,10.2,12.75,13.464,20.502
            S437.885,460.836,437.885,469.404z M226.134,66.708c0,8.976-1.734,17.442-5.202,25.398s-8.058,14.994-13.77,21.114
            s-12.546,10.914-20.502,14.382c-7.956,3.468-16.422,5.202-25.398,5.202s-17.442-1.734-25.398-5.202
            c-7.956-3.468-14.892-8.262-20.808-14.382c-5.916-6.12-10.608-13.158-14.076-21.114s-5.202-16.422-5.202-25.398
            s1.734-17.544,5.202-25.704c3.468-8.16,8.16-15.3,14.076-21.42S127.908,8.67,135.864,5.202S152.286,0,161.262,0
            s17.442,1.734,25.398,5.202s14.79,8.262,20.502,14.382s10.302,13.26,13.77,21.42C224.4,49.164,226.134,57.732,226.134,66.708z
            M226.134,268.057c0,9.383-1.734,18.053-5.202,26.01c-3.468,7.955-8.058,14.891-13.77,20.807s-12.546,10.609-20.502,14.076
            c-7.956,3.469-16.422,5.203-25.398,5.203s-17.442-1.734-25.398-5.203c-7.956-3.467-14.892-8.16-20.808-14.076
            s-10.608-12.852-14.076-20.807c-3.468-7.957-5.202-16.627-5.202-26.01c0-8.977,1.734-17.545,5.202-25.705
            c3.468-8.16,8.16-15.198,14.076-21.114s12.852-10.608,20.808-14.076s16.422-5.202,25.398-5.202s17.442,1.734,25.398,5.202
            s14.79,8.16,20.502,14.076s10.302,12.954,13.77,21.114C224.4,250.512,226.134,259.08,226.134,268.057z M226.134,469.404
            c0,9.383-1.734,18.053-5.202,26.01c-3.468,7.955-8.058,14.895-13.77,20.811s-12.546,10.605-20.502,14.076
            c-7.956,3.467-16.422,5.199-25.398,5.199s-17.442-1.732-25.398-5.199c-7.956-3.471-14.892-8.16-20.808-14.076
            s-10.608-12.855-14.076-20.811c-3.468-7.957-5.202-16.627-5.202-26.01c0-8.977,1.734-17.545,5.202-25.705
            c3.468-8.16,8.16-15.197,14.076-21.113s12.852-10.605,20.808-14.074c7.956-3.471,16.422-5.201,25.398-5.201
            s17.442,1.73,25.398,5.201c7.956,3.469,14.79,8.158,20.502,14.074s10.302,12.953,13.77,21.113
            C224.4,451.859,226.134,460.428,226.134,469.404z"
          />
        </g>
      </g>
    </svg>
  );
};

export const WarningSvg = () => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      width="16px"
      height="25px"
      viewBox="50 25 300 371"
    >
      <g>
        <g>
          <path
            d="M237.543,301.499h-73.091c-4.95,0-9.233,1.811-12.851,5.425c-3.615,3.617-5.424,7.897-5.424,12.847v63.953
			c0,4.948,1.809,9.232,5.424,12.854c3.621,3.61,7.9,5.421,12.851,5.421h73.097c4.942,0,9.227-1.811,12.848-5.421
			c3.61-3.621,5.42-7.905,5.42-12.854v-63.953c0-4.949-1.813-9.229-5.427-12.847C246.773,303.307,242.488,301.499,237.543,301.499z"
          />
          <path
            d="M259.383,5.424C255.862,1.812,251.628,0,246.676,0h-91.359c-4.948,0-9.18,1.812-12.703,5.424
			c-3.521,3.617-5.186,7.902-4.996,12.85l7.992,219.265c0.19,4.948,2.139,9.236,5.852,12.847c3.711,3.621,8.041,5.431,12.991,5.431
			h73.097c4.942,0,9.271-1.81,12.991-5.431c3.71-3.61,5.653-7.898,5.852-12.847l7.987-219.265
			C264.578,13.326,262.905,9.045,259.383,5.424z"
          />
        </g>
      </g>
    </svg>
  );
};

const AppStoreSvg = () => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
    >
      <g>
        <g>
          <path
            d="M407,0H105C47.103,0,0,47.103,0,105v302c0,57.897,47.103,105,105,105h302c57.897,0,105-47.103,105-105V105
			C512,47.103,464.897,0,407,0z M482,407c0,41.355-33.645,75-75,75H105c-41.355,0-75-33.645-75-75V105c0-41.355,33.645-75,75-75h302
			c41.355,0,75,33.645,75,75V407z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M305.646,123.531c-1.729-6.45-5.865-11.842-11.648-15.18c-11.936-6.892-27.256-2.789-34.15,9.151L256,124.166
			l-3.848-6.665c-6.893-11.937-22.212-16.042-34.15-9.151h-0.001c-11.938,6.893-16.042,22.212-9.15,34.151l18.281,31.664
			L159.678,291H110.5c-13.785,0-25,11.215-25,25c0,13.785,11.215,25,25,25h189.86l-28.868-50h-54.079l85.735-148.498
			C306.487,136.719,307.375,129.981,305.646,123.531z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M401.5,291h-49.178l-55.907-96.834l-28.867,50l86.804,150.348c3.339,5.784,8.729,9.921,15.181,11.65
			c2.154,0.577,4.339,0.863,6.511,0.863c4.332,0,8.608-1.136,12.461-3.361c11.938-6.893,16.042-22.213,9.149-34.15L381.189,341
			H401.5c13.785,0,25-11.215,25-25C426.5,302.215,415.285,291,401.5,291z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M119.264,361l-4.917,8.516c-6.892,11.938-2.787,27.258,9.151,34.15c3.927,2.267,8.219,3.345,12.458,3.344
			c8.646,0,17.067-4.484,21.693-12.495L176.999,361H119.264z"
          />
        </g>
      </g>
    </svg>
  );
};

export const AppStoreIcon = () => <Icon component={AppStoreSvg} />;

const GooglePlaySvg = () => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      viewBox="0 0 512.029 512.029"
    >
      <g>
        <g>
          <path d="M111.758,8.189C91.726-2.883,68.206-2.627,48.302,8.349l233.28,215.2l78.368-78.368L111.758,8.189z" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M24.974,30.365c-5.696,9.312-8.96,19.968-8.96,31.264v388.672c0,10.944,2.976,21.376,8.352,30.496l234.592-234.592
			L24.974,30.365z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M463.854,202.525l-74.752-41.248l-84,83.968l102.944,94.944l55.84-30.816c20.096-11.136,32.128-31.104,32.128-53.44
			C495.982,233.597,483.982,213.629,463.854,202.525z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M282.478,267.901L47.246,503.133c10.208,5.824,21.408,8.896,32.672,8.896c10.88,0,21.824-2.752,31.84-8.288
			l266.784-147.232L282.478,267.901z"
          />
        </g>
      </g>
    </svg>
  );
};

export const GooglePlayIcon = () => <Icon component={GooglePlaySvg} />;

const HomeStartSvg = () => (
  <svg id="Icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
    <g
      id="Home_as_Start_point_-_Opacity"
      data-name="Home as Start point - Opacity"
    >
      <path
        className="cls-1"
        d="M921.29169,471.66667q-6.94464.05768-13.88928,0.11539l-1.98572-.032q-0.04166,8.0625-.08337,16.125l16.125,0.08331Z"
        transform="translate(-904.34885 -470.7616)"
      />
      <path
        className="cls-2"
        d="M919.36737,478.96515l-0.00087-.00087-5.17265-5.17246a1.16711,1.16711,0,0,0-1.65095-.0001l-5.16994,5.16985-0.00522.00532a1.16686,1.16686,0,0,0,.77686,1.98888q0.01785,0.00174.036,0.00174h0.20616v3.80662a1.36776,1.36776,0,0,0,1.36633,1.36613h2.02371a0.37153,0.37153,0,0,0,.3715-0.3715v-2.98438a0.624,0.624,0,0,1,.62333-0.62333h1.19364a0.624,0.624,0,0,1,.62333.62333v2.98438a0.37147,0.37147,0,0,0,.3715.3715h2.02371a1.36776,1.36776,0,0,0,1.36633-1.36613v-3.80662h0.19117A1.16747,1.16747,0,0,0,919.36737,478.96515Z"
        transform="translate(-904.34885 -470.7616)"
      />
      <path
        className="cls-3"
        d="M920.93887,470.7616H905.75882a1.40836,1.40836,0,0,0-1.41,1.41v15.18a1.40837,1.40837,0,0,0,1.41,1.41h15.18005a1.40837,1.40837,0,0,0,1.41-1.41v-15.18A1.40836,1.40836,0,0,0,920.93887,470.7616Zm0.21,16.59a0.20505,0.20505,0,0,1-.21.21H905.75882a0.20505,0.20505,0,0,1-.21-0.21v-15.18a0.205,0.205,0,0,1,.21-0.21h15.18005a0.20505,0.20505,0,0,1,.21.21v15.18Z"
        transform="translate(-904.34885 -470.7616)"
      />
    </g>
  </svg>
);

export const HomeStartIcon = () => <Icon component={HomeStartSvg} />;

const HomeEndSvg = () => (
  <svg
    id="Icons"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    width="26"
    height="34"
  >
    <g id="Home_as_End_point" data-name="Home as End point">
      <path
        className="cls-1"
        d="M947.25,514.29167q-6.94464.05768-13.88928,0.11539l-1.98572-.032q-0.04166,8.0625-.08337,16.125l16.125,0.08331Z"
        transform="translate(-930.30718 -513.3866)"
      />
      <path
        className="cls-2"
        d="M945.28672,521.58652l-0.00086-.00086-5.13011-5.12992a1.15751,1.15751,0,0,0-1.63737-.0001L933.391,521.583l-0.00518.00528a1.15726,1.15726,0,0,0,.77047,1.97252q0.0177,0.00173.03569,0.00173h0.20447v3.77531a1.35651,1.35651,0,0,0,1.35509,1.3549h2.00706a0.36848,0.36848,0,0,0,.36844-0.36844v-2.95984a0.61886,0.61886,0,0,1,.6182-0.6182H939.929a0.61886,0.61886,0,0,1,.6182.6182v2.95984a0.36842,0.36842,0,0,0,.36844.36844h2.00706a1.35651,1.35651,0,0,0,1.35509-1.3549v-3.77531h0.1896A1.15787,1.15787,0,0,0,945.28672,521.58652Z"
        transform="translate(-930.30718 -513.3866)"
      />
      <path
        className="cls-3"
        d="M946.89721,513.3866H931.71715a1.40836,1.40836,0,0,0-1.41,1.41v15.18a1.40837,1.40837,0,0,0,1.41,1.41h15.18005a1.40837,1.40837,0,0,0,1.41-1.41v-15.18A1.40836,1.40836,0,0,0,946.89721,513.3866Zm0.21,16.59a0.20505,0.20505,0,0,1-.21.21H931.71715a0.20505,0.20505,0,0,1-.21-0.21v-15.18a0.205,0.205,0,0,1,.21-0.21h15.18005a0.20505,0.20505,0,0,1,.21.21v15.18Z"
        transform="translate(-930.30718 -513.3866)"
      />
    </g>
  </svg>
);

export const HomeEndIcon = () => <Icon component={HomeEndSvg} />;

const TTSvg = () => (
  <svg
    id="Icons"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40.92677 18.2485"
    width="55px"
    height="30px"
  >
    <g>
      <g>
        <path
          className="cls-1"
          style={{ fill: '#e6e7e7' }}
          d="M305.25992,684.65775a0.158,0.158,0,0,1-.16-0.16v-11.93a0.158,0.158,0,0,1,.16-0.16h14.72a0.158,0.158,0,0,1,.16.16v11.93a0.158,0.158,0,0,1-.16.16h-14.72Z"
          transform="translate(-304.59992 -671.90775)"
        />
        <path
          className="cls-2"
          style={{ fill: '#010101' }}
          d="M319.64992,672.90775v11.26h-14.05v-11.26h14.05m0.33-1h-14.72a0.65936,0.65936,0,0,0-.66.66v11.93a0.65936,0.65936,0,0,0,.66.66h14.72a0.65936,0.65936,0,0,0,.66-0.66v-11.93a0.647,0.647,0,0,0-.66-0.66h0Z"
          transform="translate(-304.59992 -671.90775)"
        />
        <path
          d="M317.34381,677.69239a1.69911,1.69911,0,1,1,1.334-1.334A1.70063,1.70063,0,0,1,317.34381,677.69239Zm-0.33231-2.60409a0.93779,0.93779,0,1,0,.93779.93779A0.93779,0.93779,0,0,0,317.0115,675.0883Z"
          transform="translate(-304.59992 -671.90775)"
        />
        <path
          d="M308.66,682.31523a1.69911,1.69911,0,1,1,1.334-1.334A1.70063,1.70063,0,0,1,308.66,682.31523Zm-0.33231-2.60409a0.93779,0.93779,0,1,0,.93779.93779A0.93779,0.93779,0,0,0,308.32768,679.71114Z"
          transform="translate(-304.59992 -671.90775)"
        />
        <path
          id="_Path_"
          style={{
            strokeWidth: 0.75,
            fill: 'none',
            stroke: '#020202',
            strokeMiterlimit: 10,
          }}
          data-name="&lt;Path&gt;"
          className="cls-3"
          d="M309.81886,680.75669c3.41446-.10411,4.11915-0.29152,4.24684-1.16321,0.16507-1.12686-1.39155-1.57021-1.1468-2.474,0.133-.491.94766-0.6639,2.61053-0.94845"
          transform="translate(-304.59992 -671.90775)"
        />
      </g>
      <g id="GPS">
        <g>
          <path
            d="M331.51014,677.07614v4.43336a1.64171,1.64171,0,0,0,1.64244,1.64244h10.42272a1.64171,1.64171,0,0,0,1.64244-1.64244v-4.40866a1.64439,1.64439,0,0,0-1.64244-1.65479H333.15259A1.62346,1.62346,0,0,0,331.51014,677.07614Zm12.53443,1.64244v1.14848h-0.43222v-1.14848h0.43222Zm-1.593-2.85267v6.8538h-8.99021v-6.8538h8.99021Z"
            transform="translate(-304.59992 -671.90775)"
          />
          <path
            className="cls-2"
            style={{ fill: '#010101' }}
            d="M345.52669,677.10073v4.409a1.95322,1.95322,0,0,1-1.95127,1.95067H333.15277a1.95322,1.95322,0,0,1-1.95127-1.95067V677.076a1.93258,1.93258,0,0,1,.57827-1.38567,1.91006,1.91006,0,0,1,1.37722-.55294h10.41843A1.95982,1.95982,0,0,1,345.52669,677.10073Zm-2.76651,5.74225h0.81524a1.335,1.335,0,0,0,1.33381-1.33321v-4.409a1.34118,1.34118,0,0,0-1.33381-1.34587h-0.81524V682.843Zm-0.61746-.43174v-6.2367h-8.37249v6.2367h8.37249Zm-8.98995.43174v-7.08812a1.30013,1.30013,0,0,0-.93946.37506,1.31882,1.31882,0,0,0-.39435.94609v4.43377A1.335,1.335,0,0,0,333.15277,682.843Zm11.2005-4.43317V680.176h-1.0498v-1.76615h1.0498Z"
            transform="translate(-304.59992 -671.90775)"
          />
        </g>
        <rect
          className="cls-1"
          style={{ fill: '#e6e7e7' }}
          x="28.26399"
          y="4.10072"
          width="11.07167"
          height="6.55521"
        />
        <path
          d="M340.52124,678.98592a0.93426,0.93426,0,1,1,.7335-0.7335A0.9351,0.9351,0,0,1,340.52124,678.98592Zm-0.18272-1.43187a0.51565,0.51565,0,1,0,.51565.51565A0.51565,0.51565,0,0,0,340.33851,677.55405Z"
          transform="translate(-304.59992 -671.90775)"
        />
        <path
          d="M335.74639,681.52782a0.93426,0.93426,0,1,1,.7335-0.7335A0.9351,0.9351,0,0,1,335.74639,681.52782Zm-0.18272-1.43187a0.51565,0.51565,0,1,0,.51565.51565A0.51565,0.51565,0,0,0,335.56366,680.09595Z"
          transform="translate(-304.59992 -671.90775)"
        />
        <path
          id="_Path_2"
          style={{
            strokeWidth: 0.5,
            fill: 'none',
            stroke: '#020202',
            strokeMiterlimit: 10,
          }}
          data-name="&lt;Path&gt;"
          className="cls-4"
          d="M336.3836,680.67085c1.87746-.05725,2.26494-0.16029,2.33515-0.6396,0.09076-.61961-0.76515-0.86339-0.63057-1.36035,0.07311-.27.52108-0.365,1.43542-0.52151"
          transform="translate(-304.59992 -671.90775)"
        />
      </g>
      <path
        className="cls-2"
        style={{ fill: '#010101' }}
        d="M314.93749,690.15625h-4.66991a0.5,0.5,0,0,1,0-1h4.66991A0.5,0.5,0,0,1,314.93749,690.15625Z"
        transform="translate(-304.59992 -671.90775)"
      />
      <rect
        className="cls-2"
        style={{ fill: '#010101' }}
        x="7.50018"
        y="13.15015"
        width="1"
        height="4.47998"
      />
      <polygon points="22.664 6.036 23.088 6.56 19.255 6.56 19.255 7.21 23.074 7.21 22.657 7.741 23.166 8.137 24.177 6.871 23.159 5.626 22.664 6.036" />
    </g>
  </svg>
);

export const TTSvgIcon = () => <Icon component={TTSvg} />;

const WorkStartSvg = () => (
  <svg id="Icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
    <title>Work start - Opacity</title>
    <g id="Home_as_Start_point" data-name="Home as Start point">
      <path
        className="cls-1"
        d="M979.83335,472.70833q-6.94464.05768-13.88928,0.11539l-1.98572-.032q-0.04166,8.0625-.08337,16.125L980,489Z"
        transform="translate(-962.89051 -471.80326)"
      />
      <path
        className="cls-5"
        d="M979.48054,471.80326H964.30049a1.40836,1.40836,0,0,0-1.41,1.41v15.18a1.40837,1.40837,0,0,0,1.41,1.41h15.18005a1.40837,1.40837,0,0,0,1.41-1.41v-15.18A1.40836,1.40836,0,0,0,979.48054,471.80326Zm0.21,16.59a0.20505,0.20505,0,0,1-.21.21H964.30049a0.20505,0.20505,0,0,1-.21-0.21v-15.18a0.205,0.205,0,0,1,.21-0.21h15.18005a0.20505,0.20505,0,0,1,.21.21v15.18Z"
        transform="translate(-962.89051 -471.80326)"
      />
      <g>
        <path
          className="cls-2"
          d="M973.94272,476.395a0.3759,0.3759,0,0,0-.39184-0.35666H970.416a0.37585,0.37585,0,0,0-.39168.35666v0.35666h3.91839V476.395Z"
          transform="translate(-962.89051 -471.80326)"
        />
        <rect
          className="cls-3"
          x="7.91749"
          y="9.22837"
          width="2.35104"
          height="0.71331"
        />
        <path
          className="cls-4"
          d="M967.81994,481.03164h2.20439V480.675a0.37532,0.37532,0,0,1,.39168-0.35666h3.13487a0.37537,0.37537,0,0,1,.39184.35666v0.35666h2.20439a0.38962,0.38962,0,0,0,.37145-0.24386l1.21708-3.32278H966.23141l1.21708,3.32278A0.38962,0.38962,0,0,0,967.81994,481.03164Z"
          transform="translate(-962.89051 -471.80326)"
        />
        <path
          className="cls-4"
          d="M976.14711,481.745h-2.20439v0.35666a0.37542,0.37542,0,0,1-.39184.35673H970.416a0.37538,0.37538,0,0,1-.39168-0.35673V481.745h-2.20439a1.16971,1.16971,0,0,1-1.115-.73159l-0.6252-1.70719v5.64877a0.37581,0.37581,0,0,0,.39168.35673h11.02412a0.37591,0.37591,0,0,0,.39168-0.35673v-5.64877l-0.6252,1.70719A1.16971,1.16971,0,0,1,976.14711,481.745Z"
          transform="translate(-962.89051 -471.80326)"
        />
        <path
          className="cls-6"
          d="M978.28175,476.75175l-0.00171-.00007H974.7264V476.395a1.12774,1.12774,0,0,0-1.17552-1.07H970.416a1.1277,1.1277,0,0,0-1.17536,1.07v0.35666h-3.55286a0.37643,0.37643,0,0,0-.39184.35666v7.8466a1.12774,1.12774,0,0,0,1.17552,1.07h11.02412a1.1277,1.1277,0,0,0,1.17536-1.07v-7.84051A0.36434,0.36434,0,0,0,978.28175,476.75175Zm-8.25743-.35673a0.37585,0.37585,0,0,1,.39168-0.35666h3.13487a0.3759,0.3759,0,0,1,.39184.35666v0.35666h-3.91839V476.395Zm7.71131,1.07-1.21708,3.32278a0.38962,0.38962,0,0,1-.37145.24386h-2.20439V480.675a0.37537,0.37537,0,0,0-.39184-0.35666H970.416a0.37532,0.37532,0,0,0-.39168.35666v0.35666h-2.20439a0.38962,0.38962,0,0,1-.37145-0.24386l-1.21708-3.32278h11.50423Zm-4.5766,3.56664V481.745h-2.351v-0.71331h2.351Zm4.72823,3.9233a0.37591,0.37591,0,0,1-.39168.35673H966.47146a0.37581,0.37581,0,0,1-.39168-0.35673v-5.64877l0.6252,1.70719a1.16971,1.16971,0,0,0,1.115.73159h2.20439v0.35666a0.37538,0.37538,0,0,0,.39168.35673h3.13487a0.37542,0.37542,0,0,0,.39184-0.35673V481.745h2.20439a1.16971,1.16971,0,0,0,1.115-.73159l0.6252-1.70719v5.64877Z"
          transform="translate(-962.89051 -471.80326)"
        />
      </g>
    </g>
  </svg>
);

export const WorkStartIcon = () => <Icon component={WorkStartSvg} />;

const WorkEndSvg = () => (
  <svg id="Icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
    <g id="Home_as_End_point_-_Opacity" data-name="Home as End point - Opacity">
      <path
        className="cls-1"
        d="M982.04169,512.25q-6.94464.05768-13.88928,0.11539l-1.98572-.032q-0.04166,8.0625-.08337,16.125l16.125,0.08331Z"
        transform="translate(-965.09885 -511.34493)"
      />
      <path
        className="cls-5"
        d="M981.68887,511.34493H966.50882a1.40836,1.40836,0,0,0-1.41,1.41v15.18a1.40837,1.40837,0,0,0,1.41,1.41h15.18005a1.40837,1.40837,0,0,0,1.41-1.41v-15.18A1.40836,1.40836,0,0,0,981.68887,511.34493Zm0.21,16.59a0.20505,0.20505,0,0,1-.21.21H966.50882a0.20505,0.20505,0,0,1-.21-0.21v-15.18a0.205,0.205,0,0,1,.21-0.21h15.18005a0.20505,0.20505,0,0,1,.21.21v15.18Z"
        transform="translate(-965.09885 -511.34493)"
      />
      <g>
        <path
          className="cls-2"
          d="M976.06772,516.02a0.3759,0.3759,0,0,0-.39184-0.35666H972.541a0.37585,0.37585,0,0,0-.39168.35666v0.35666h3.91839V516.02Z"
          transform="translate(-965.09885 -511.34493)"
        />
        <rect
          className="cls-3"
          x="7.83416"
          y="9.3117"
          width="2.35104"
          height="0.71331"
        />
        <path
          className="cls-4"
          d="M969.94494,520.65664h2.20439V520.3a0.37532,0.37532,0,0,1,.39168-0.35666h3.13487a0.37537,0.37537,0,0,1,.39184.35666v0.35666h2.20439a0.38962,0.38962,0,0,0,.37145-0.24386l1.21708-3.32278H968.35641l1.21708,3.32278A0.38962,0.38962,0,0,0,969.94494,520.65664Z"
          transform="translate(-965.09885 -511.34493)"
        />
        <path
          className="cls-4"
          d="M978.27211,521.37h-2.20439v0.35666a0.37542,0.37542,0,0,1-.39184.35673H972.541a0.37538,0.37538,0,0,1-.39168-0.35673V521.37h-2.20439a1.16971,1.16971,0,0,1-1.115-.73159l-0.6252-1.70719v5.64877a0.37581,0.37581,0,0,0,.39168.35673h11.02412a0.37591,0.37591,0,0,0,.39168-0.35673v-5.64877l-0.6252,1.70719A1.16971,1.16971,0,0,1,978.27211,521.37Z"
          transform="translate(-965.09885 -511.34493)"
        />
        <path
          className="cls-6"
          d="M980.40675,516.37675l-0.00171-.00007H976.8514V516.02a1.12774,1.12774,0,0,0-1.17552-1.07H972.541a1.1277,1.1277,0,0,0-1.17536,1.07v0.35666h-3.55286a0.37643,0.37643,0,0,0-.39184.35666v7.8466a1.12774,1.12774,0,0,0,1.17552,1.07h11.02412a1.1277,1.1277,0,0,0,1.17536-1.07v-7.84051A0.36434,0.36434,0,0,0,980.40675,516.37675Zm-8.25743-.35673a0.37585,0.37585,0,0,1,.39168-0.35666h3.13487a0.3759,0.3759,0,0,1,.39184.35666v0.35666h-3.91839V516.02Zm7.71131,1.07-1.21708,3.32278a0.38962,0.38962,0,0,1-.37145.24386h-2.20439V520.3a0.37537,0.37537,0,0,0-.39184-0.35666H972.541a0.37532,0.37532,0,0,0-.39168.35666v0.35666h-2.20439a0.38962,0.38962,0,0,1-.37145-0.24386L968.35641,517.09h11.50423Zm-4.5766,3.56664V521.37h-2.351v-0.71331h2.351Zm4.72823,3.9233a0.37591,0.37591,0,0,1-.39168.35673H968.59646a0.37581,0.37581,0,0,1-.39168-0.35673v-5.64877l0.6252,1.70719a1.16971,1.16971,0,0,0,1.115.73159h2.20439v0.35666a0.37538,0.37538,0,0,0,.39168.35673h3.13487a0.37542,0.37542,0,0,0,.39184-0.35673V521.37h2.20439a1.16971,1.16971,0,0,0,1.115-.73159l0.6252-1.70719v5.64877Z"
          transform="translate(-965.09885 -511.34493)"
        />
      </g>
    </g>
  </svg>
);

export const WorkEndIcon = () => <Icon component={WorkEndSvg} />;

const TimeAndDistAccumSvg = () => (
  <svg id="Icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
    <path
      className="cls-1"
      d="M947.332,392.27629h-15.18a1.40837,1.40837,0,0,0-1.41,1.41v15.18a1.40837,1.40837,0,0,0,1.41,1.41h15.18a1.40837,1.40837,0,0,0,1.41-1.41v-15.18A1.40837,1.40837,0,0,0,947.332,392.27629Zm0.21,16.59h0a0.20506,0.20506,0,0,1-.21.21h-15.18a0.20506,0.20506,0,0,1-.21-0.21v-15.18a0.20506,0.20506,0,0,1,.21-0.21h15.18a0.20506,0.20506,0,0,1,.21.21v15.18Z"
      transform="translate(-930.742 -392.27629)"
    />
    <path
      className="cls-2"
      d="M1.41,1.2H16.59a0.21,0.21,0,0,1,.21.21V16.59a0.21,0.21,0,0,1-.21.21H1.41a0.21,0.21,0,0,1-.21-0.21V1.41A0.21,0.21,0,0,1,1.41,1.2Z"
    />
    <g>
      <path
        className="cls-4"
        d="M940.17656,396.45946v-0.65119h0.4228a0.43469,0.43469,0,1,0,0-.86938H938.8848a0.43469,0.43469,0,0,0,0,.86938h0.42238v0.65124A5.33769,5.33769,0,1,0,940.17656,396.45946Zm1.22894,7.411a0.43453,0.43453,0,0,1-.61468,0l-1.48364-1.48321v-2.65909a0.43469,0.43469,0,1,1,.86938,0v2.29911l1.22894,1.22851A0.43453,0.43453,0,0,1,941.4055,403.87043Z"
        transform="translate(-930.742 -392.27629)"
      />
      <path
        className="cls-3"
        d="M940.17656,402.02724v-2.29911a0.43469,0.43469,0,1,0-.86938,0v2.65909l1.48364,1.48321a0.43464,0.43464,0,1,0,.61468-0.61468Z"
        transform="translate(-930.742 -392.27629)"
      />
    </g>
  </svg>
);

export const TimeAndDistAccumIcon = () => (
  <Icon component={TimeAndDistAccumSvg} />
);

const TimeAndDistSvg = () => (
  <svg id="Icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 17.99994">
    <g>
      <path
        className="cls-2"
        d="M946.56112,353.4493H931.383a0.2112,0.2112,0,0,0-.21094.211v15.178a0.21115,0.21115,0,0,0,.21094.21094h15.1781a0.21114,0.21114,0,0,0,.21088-0.21094h0.00006v-15.178A0.21124,0.21124,0,0,0,946.56112,353.4493Zm-1.42792,13.25262h-1.44788a1.07436,1.07436,0,0,1-1.92755,0h-5.02258a1.07475,1.07475,0,0,1-1.928,0h-1.97961a0.5,0.5,0,0,1,0-1h1.98a1.09111,1.09111,0,0,1,.46387-0.46338v-3.70691a2.87939,2.87939,0,1,1,1-.00006v3.70721a1.09076,1.09076,0,0,1,.46338.46313h5.02344a1.089,1.089,0,0,1,.43457-0.44379v-3.02472c-0.60046-.70215-2.13965-2.61255-2.13965-3.77014a2.63983,2.63983,0,1,1,5.27966,0c0,1.15778-1.53979,3.06879-2.14,3.77057v2.9856a1.09372,1.09372,0,0,1,.49219.48248h1.44824A0.5,0.5,0,0,1,945.1332,366.70192Z"
        transform="translate(-929.97207 -352.24935)"
      />
      <path
        className="cls-1"
        d="M946.56112,352.24935H931.383a1.41085,1.41085,0,0,0-1.41095,1.41095v15.178a1.41085,1.41085,0,0,0,1.41095,1.41095h15.1781a1.41085,1.41085,0,0,0,1.41095-1.41095v-15.178A1.41088,1.41088,0,0,0,946.56112,352.24935Zm0.21094,16.589H946.772a0.21114,0.21114,0,0,1-.21088.21094H931.383a0.21115,0.21115,0,0,1-.21094-0.21094v-15.178a0.2112,0.2112,0,0,1,.21094-0.211h15.1781a0.21124,0.21124,0,0,1,.21094.211v15.178Z"
        transform="translate(-929.97207 -352.24935)"
      />
      <path
        className="cls-4"
        d="M945.1332,365.70192H943.685a1.09372,1.09372,0,0,0-.49219-0.48248v-2.9856c0.60022-.70178,2.14-2.61279,2.14-3.77057a2.63983,2.63983,0,1,0-5.27966,0c0,1.15759,1.53918,3.068,2.13965,3.77014v3.02472a1.089,1.089,0,0,0-.43457.44379h-5.02344a1.09076,1.09076,0,0,0-.46338-0.46313v-3.70721a2.87917,2.87917,0,1,0-1,.00006v3.70691a1.09111,1.09111,0,0,0-.46387.46338h-1.98a0.5,0.5,0,0,0,0,1h1.97961a1.07475,1.07475,0,0,0,1.928,0h5.02258a1.07436,1.07436,0,0,0,1.92755,0h1.44788A0.5,0.5,0,0,0,945.1332,365.70192Zm-3.29468-7.25555a0.85443,0.85443,0,1,1,.85443.85443A0.85444,0.85444,0,0,1,941.83853,358.44637Zm-6.28931-.8421a0.25,0.25,0,1,1,.5,0v1.28125l0.45605,0.45654a0.25,0.25,0,1,1-.35352.35352l-0.60254-.603v-1.48828Z"
        transform="translate(-929.97207 -352.24935)"
      />
      <circle className="cls-3" cx="12.72089" cy="6.19701" r="0.85445" />
      <path
        className="cls-3"
        d="M936.32852,359.76882a0.25,0.25,0,0,0,.17676-0.42676l-0.45605-.45654v-1.28125a0.25,0.25,0,1,0-.5,0v1.48828l0.60254,0.603A0.24919,0.24919,0,0,0,936.32852,359.76882Z"
        transform="translate(-929.97207 -352.24935)"
      />
    </g>
  </svg>
);

export const TimeAndDistIcon = () => <Icon component={TimeAndDistSvg} />;

const DownloadPdfTourSvg = () => (
  <svg viewBox="0 0 18 18">
    <g>
      <g id="Backward">
        <path
          className="cls-5"
          d="M974.53274,790.35608h-15.18a0.20506,0.20506,0,0,0-.21.21v15.18a0.20506,0.20506,0,0,0,.21.21h15.18a0.20506,0.20506,0,0,0,.21-0.21h0v-15.18A0.20506,0.20506,0,0,0,974.53274,790.35608Z"
          transform="translate(-957.94274 -789.15608)"
        />
        <path
          className="cls-4"
          d="M974.53274,789.15608h-15.18a1.40837,1.40837,0,0,0-1.41,1.41v15.18a1.40837,1.40837,0,0,0,1.41,1.41h15.18a1.40837,1.40837,0,0,0,1.41-1.41v-15.18A1.40837,1.40837,0,0,0,974.53274,789.15608Zm0.21,16.59h0a0.20506,0.20506,0,0,1-.21.21h-15.18a0.20506,0.20506,0,0,1-.21-0.21v-15.18a0.20506,0.20506,0,0,1,.21-0.21h15.18a0.20506,0.20506,0,0,1,.21.21v15.18Z"
          transform="translate(-957.94274 -789.15608)"
        />
      </g>
      <polygon
        className="cls-1"
        points="10.582 9.344 5.397 9.344 5.397 14.043 11.286 14.043 11.338 13.991 11.381 11.556 13.781 11.548 13.823 11.506 13.823 3.673 5.397 3.673 5.397 5.941 10.582 5.941 10.582 9.344"
      />
      <path
        className="cls-2"
        d="M962.69188,792.18085v2.91667H963.34V792.829H971.766v7.83336l-0.04221.04221-2.3997.00791-0.04284,2.43463-0.05226.05226H963.34v-4.69907h-0.64815v5.34722h6.80556l2.91667-2.91667v-8.75h-9.72222Zm7.269,9.17768,0.88321-.00293-0.899.899Z"
        transform="translate(-957.94274 -789.15608)"
      />
      <polygon
        className="cls-1"
        points="12.018 12.202 12.002 13.099 12.901 12.2 12.018 12.202"
      />
      <path
        className="cls-2"
        d="M962.68507,796.15285a0.27687,0.27687,0,0,0-.22458-0.08165h-0.175v0.63339h0.18668a0.27656,0.27656,0,0,0,.2027-0.07631,0.3186,0.3186,0,0,0,.0773-0.23625A0.36933,0.36933,0,0,0,962.68507,796.15285Z"
        transform="translate(-957.94274 -789.15608)"
      />
      <path
        className="cls-2"
        d="M964.58236,797.372a0.70823,0.70823,0,0,0,.0525-0.23091q0.01311-.14218.01313-0.35537c0-.1186-0.00439-0.22264-0.01167-0.31256a0.76975,0.76975,0,0,0-.04814-0.22312,0.27451,0.27451,0,0,0-.10839-0.13367,0.35369,0.35369,0,0,0-.191-0.04569h-0.17743v1.46462H964.298a0.36077,0.36077,0,0,0,.1779-0.0379A0.26033,0.26033,0,0,0,964.58236,797.372Z"
        transform="translate(-957.94274 -789.15608)"
      />
      <path
        className="cls-2"
        d="M968.52521,798.50029v-3.40278h-7.77778v3.40278h7.77778Zm-2.88846-2.73877h1.16373v0.34417h-0.74372v0.49h0.7v0.34417h-0.7V797.844h-0.42v-2.08251Zm-1.94543-.00047h0.68834a0.75268,0.75268,0,0,1,.35339.072,0.50536,0.50536,0,0,1,.20856.20417,0.8939,0.8939,0,0,1,.1006.31937,3.00653,3.00653,0,0,1,.02627.4166,2.96065,2.96065,0,0,1-.03307.47685,0.91407,0.91407,0,0,1-.1152.334,0.5025,0.5025,0,0,1-.21873.19543,0.82,0.82,0,0,1-.3471.06417h-0.66306v-2.08251Zm-0.56729.90465a0.50274,0.50274,0,0,1-.13415.195,0.55538,0.55538,0,0,1-.20856.11373,0.92984,0.92984,0,0,1-.27126.03841h-0.22458V797.844h-0.42v-2.08251h0.735a0.60815,0.60815,0,0,1,.2698.054,0.48853,0.48853,0,0,1,.17644.14147,0.55234,0.55234,0,0,1,.09625.19982,0.927,0.927,0,0,1,.0292.22893A0.747,0.747,0,0,1,963.124,796.66571Z"
        transform="translate(-957.94274 -789.15608)"
      />
      <path
        className="cls-3"
        d="M963.04673,795.957a0.48853,0.48853,0,0,0-.17644-0.14147,0.60815,0.60815,0,0,0-.2698-0.054h-0.735V797.844h0.42V797.0128h0.22458a0.92984,0.92984,0,0,0,.27126-0.03841,0.55538,0.55538,0,0,0,.20856-0.11373,0.50274,0.50274,0,0,0,.13415-0.195,0.747,0.747,0,0,0,.04814-0.28,0.927,0.927,0,0,0-.0292-0.22893A0.55234,0.55234,0,0,0,963.04673,795.957Zm-0.37186.67133a0.27656,0.27656,0,0,1-.2027.07631h-0.18668V796.0712h0.175a0.27687,0.27687,0,0,1,.22458.08165,0.36933,0.36933,0,0,1,.06709.23918A0.3186,0.3186,0,0,1,962.67487,796.62828Z"
        transform="translate(-957.94274 -789.15608)"
      />
      <path
        className="cls-3"
        d="M964.70148,797.7794a0.5025,0.5025,0,0,0,.21873-0.19543,0.91407,0.91407,0,0,0,.1152-0.334,2.96065,2.96065,0,0,0,.03307-0.47685,3.00653,3.00653,0,0,0-.02627-0.4166,0.8939,0.8939,0,0,0-.1006-0.31937,0.50536,0.50536,0,0,0-.20856-0.20417,0.75268,0.75268,0,0,0-.35339-0.072h-0.68834v2.08251h0.66306A0.82,0.82,0,0,0,964.70148,797.7794Zm-0.59015-.244v-1.46462h0.17743a0.35369,0.35369,0,0,1,.191.04569,0.27451,0.27451,0,0,1,.10839.13367,0.76975,0.76975,0,0,1,.04814.22312c0.00728,0.08992.01167,0.194,0.01167,0.31256q0,0.21291-.01313.35537a0.70823,0.70823,0,0,1-.0525.23091,0.26033,0.26033,0,0,1-.10646.1254,0.36077,0.36077,0,0,1-.1779.0379h-0.18668Z"
        transform="translate(-957.94274 -789.15608)"
      />
      <polygon
        className="cls-3"
        points="8.114 7.784 8.814 7.784 8.814 7.44 8.114 7.44 8.114 6.95 8.858 6.95 8.858 6.605 7.694 6.605 7.694 8.688 8.114 8.688 8.114 7.784"
      />
    </g>
  </svg>
);

export const DownloadPdfTourIcon = () => (
  <Icon component={DownloadPdfTourSvg} />
);

const EmbedTourSvg = () => (
  <svg viewBox="0 0 512 512">
    <path
      className="cls-1"
      d="M77.641,261.667l107.507-107.508c10.739-10.739,10.739-28.151,0-38.891c-10.739-10.74-28.151-10.739-38.891,0
      L19.686,241.841c-5.469,5.468-8.146,12.667-8.045,19.833c-0.097,7.162,2.581,14.354,8.045,19.819l126.572,126.571
      c10.738,10.739,28.151,10.739,38.891,0s10.739-28.151,0-38.891L77.641,261.667z"
    />
    <path
      className="cls-1"
      d="M492.316,236.174L365.743,109.602c-10.739-10.739-28.151-10.74-38.891,0c-10.739,10.739-10.739,28.152,0,38.891L434.361,256
      L326.853,363.508c-10.739,10.738-10.739,28.15,0,38.891c10.739,10.738,28.152,10.738,38.891,0l126.572-126.572
      c5.467-5.467,8.144-12.662,8.045-19.826C500.459,248.836,497.782,241.64,492.316,236.174z"
    />
  </svg>
);

export const EmbedTourIcon = () => <Icon component={EmbedTourSvg} />;

const RevertTourSvg = () => (
  <svg viewBox="0 0 18 18">
    <g id="Reverse_tour" data-name="Reverse tour">
      <g id="Backward">
        <path
          className="cls-1"
          d="M1086.92341,795.35608h-15.18a0.20506,0.20506,0,0,0-.21.21v15.18a0.20506,0.20506,0,0,0,.21.21h15.18a0.20506,0.20506,0,0,0,.21-0.21h0v-15.18A0.20506,0.20506,0,0,0,1086.92341,795.35608Z"
          transform="translate(-1070.33341 -794.15608)"
        />
        <path
          className="cls-2"
          d="M1086.92341,794.15608h-15.18a1.40837,1.40837,0,0,0-1.41,1.41v15.18a1.40837,1.40837,0,0,0,1.41,1.41h15.18a1.40837,1.40837,0,0,0,1.41-1.41v-15.18A1.40837,1.40837,0,0,0,1086.92341,794.15608Zm0.21,16.59h0a0.20506,0.20506,0,0,1-.21.21h-15.18a0.20506,0.20506,0,0,1-.21-0.21v-15.18a0.20506,0.20506,0,0,1,.21-0.21h15.18a0.20506,0.20506,0,0,1,.21.21v15.18Z"
          transform="translate(-1070.33341 -794.15608)"
        />
      </g>
      <polygon
        className="cls-1"
        points="11.468 14.213 13.858 11.853 12.049 11.853 12.048 11.853 12.048 8.182 10.887 8.182 10.887 11.854 9.077 11.854 11.468 14.213"
      />
      <path
        className="cls-3"
        d="M1081.34155,808.96429a0.65485,0.65485,0,0,0,.91866,0l2.59372-2.56a0.65385,0.65385,0,0,0-.43869-1.14052h-1.28806v-3.01805a0.655,0.655,0,0,0-.65444-0.65408h-1.34622a0.65467,0.65467,0,0,0-.65408.65408v3.01805h-1.28663a0.65384,0.65384,0,0,0-.45951,1.119Zm-0.12134-2.95415v-3.67249h1.16134v3.67178h1.80968l-2.39017,2.35966-2.39053-2.35894h1.80968Z"
        transform="translate(-1070.33341 -794.15608)"
      />
      <polygon
        className="cls-1"
        points="6.532 3.687 4.142 6.046 5.951 6.046 5.952 6.046 5.952 9.718 7.113 9.718 7.113 6.046 8.923 6.046 6.532 3.687"
      />
      <path
        className="cls-3"
        d="M1077.32511,797.24752a0.65485,0.65485,0,0,0-.91866,0l-2.59372,2.56a0.65385,0.65385,0,0,0,.43869,1.14052h1.28806v3.01805a0.655,0.655,0,0,0,.65444.65408h1.34622a0.65467,0.65467,0,0,0,.65408-0.65408V800.948h1.28663a0.65384,0.65384,0,0,0,.45951-1.119Zm0.12134,2.95415v3.67249h-1.16134v-3.67178h-1.80968l2.39017-2.35966,2.39053,2.35894h-1.80968Z"
        transform="translate(-1070.33341 -794.15608)"
      />
    </g>
  </svg>
);

export const RevertTourIcon = () => <Icon component={RevertTourSvg} />;

const FullScreenTourSvg = () => (
  <svg viewBox="0 0 18 18">
    <g>
      <path
        className="cls-1"
        d="M946.58913,273.39537h-15.18a0.20506,0.20506,0,0,0-.21.21v15.18a0.20506,0.20506,0,0,0,.21.21h15.18a0.20506,0.20506,0,0,0,.21-0.21h0v-15.18A0.20506,0.20506,0,0,0,946.58913,273.39537Zm-1,4.82a0.25265,0.25265,0,0,1-.15.23,0.24576,0.24576,0,0,1-.27-0.05l-1.29-1.29-2.13,2.13-6.81,6.86,1.29,1.29a0.24576,0.24576,0,0,1,.05.27,0.25265,0.25265,0,0,1-.23.15h-3.43a0.24757,0.24757,0,0,1-.25-0.25v-3.42a0.25265,0.25265,0,0,1,.15-0.23,0.24576,0.24576,0,0,1,.27.05l1.29,1.29,8.95-8.99-1.29-1.29a0.28482,0.28482,0,0,1-.05-0.27,0.25265,0.25265,0,0,1,.23-0.15h3.43a0.24757,0.24757,0,0,1,.25.25Z"
        transform="translate(-929.99913 -272.19537)"
      />
      <path
        className="cls-2"
        d="M946.58913,273.39537h-15.18a0.20506,0.20506,0,0,0-.21.21v15.18a0.20506,0.20506,0,0,0,.21.21h15.18a0.20506,0.20506,0,0,0,.21-0.21h0v-15.18A0.20506,0.20506,0,0,0,946.58913,273.39537Z"
        transform="translate(-929.99913 -272.19537)"
      />
      <path
        className="cls-3"
        d="M945.34913,274.54537h-3.43a0.25265,0.25265,0,0,0-.23.15,0.24576,0.24576,0,0,0,.05.27l1.29,1.29-8.95,8.99-1.28-1.28a0.24576,0.24576,0,0,0-.27-0.05,0.25265,0.25265,0,0,0-.15.23v3.42a0.24757,0.24757,0,0,0,.25.25h3.43a0.25265,0.25265,0,0,0,.23-0.15,0.24576,0.24576,0,0,0-.05-0.27l-1.3-1.3,6.82-6.87,2.13-2.13,1.29,1.29a0.24576,0.24576,0,0,0,.27.05,0.25265,0.25265,0,0,0,.15-0.23v-3.42A0.25948,0.25948,0,0,0,945.34913,274.54537Z"
        transform="translate(-929.99913 -272.19537)"
      />
      <path
        className="cls-4"
        d="M946.58913,272.19537h-15.18a1.40837,1.40837,0,0,0-1.41,1.41v15.18a1.40837,1.40837,0,0,0,1.41,1.41h15.18a1.40837,1.40837,0,0,0,1.41-1.41v-15.18A1.40837,1.40837,0,0,0,946.58913,272.19537Zm0.21,16.59h0a0.20506,0.20506,0,0,1-.21.21h-15.18a0.20506,0.20506,0,0,1-.21-0.21v-15.18a0.20506,0.20506,0,0,1,.21-0.21h15.18a0.20506,0.20506,0,0,1,.21.21v15.18Z"
        transform="translate(-929.99913 -272.19537)"
      />
    </g>
  </svg>
);

export const FullScreenTourIcon = () => <Icon component={FullScreenTourSvg} />;

const DnDPointSvg = ({ width = '15px', height = '15px' }) => (
  <svg viewBox="0 0 28.34012 25.8249" width={width} height={height}>
    <g id="Move_up-down" data-name="Move up-down">
      <path
        className="cls-1"
        style={{
          fill: '#e6e7e7',
          stroke: '#333',
          strokeWidth: 2,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
        d="M972.62888,2176.70158c0.20779-.263-0.5511-1.18215-0.73243-1.40266-1.25377-1.52438-3.064-3.89212-5.83459-7.73364a1.74132,1.74132,0,0,1,2.44893-2.40725q2.12615,2.83885,4.25239,5.67793a1.72862,1.72862,0,0,1,3.20414-1.13842,1.50207,1.50207,0,1,1,2.73778-1.20672,2.60655,2.60655,0,0,1,1.52188-1.44449c2.08522-.5268,4.37337,3.32045,4.48731,3.51625a12.84385,12.84385,0,0,1,1.47764,6.172,16.80046,16.80046,0,0,1-.02932,1.77489q-3.50643,2.61645-7.01267,5.23307a41.94051,41.94051,0,0,1-4.79121-1.47215c-0.48068-.18-1.76728-0.77023-4.34027-1.95055a7.72442,7.72442,0,0,1-3.04884-2.05479,2.24587,2.24587,0,0,1-.74341-1.8361,1.78026,1.78026,0,0,1,1.30437-1.17849,1.05477,1.05477,0,0,1,.11219-0.022,3.94054,3.94054,0,0,1,2.23541.66373C970.909,2176.4655,972.39352,2176.99973,972.62888,2176.70158Z"
        transform="translate(-958.1129 -2158.16763)"
      />
      <path
        className="cls-2"
        style={{
          fill: '#333',
          stroke: '#333',
          strokeWidth: 0.5,
          strokeMiterlimit: 10,
        }}
        d="M960.90574,2158.48653l-2.43864,2.412a0.25265,0.25265,0,0,0-.058.26839,0.24576,0.24576,0,0,0,.22542.1568l1.82431,0.01-0.04129,12.68546-1.81017-.00993a0.24576,0.24576,0,0,0-.22712.15432,0.25265,0.25265,0,0,0,.05509.269l2.405,2.43153a0.24757,0.24757,0,0,0,.35355.00194l2.43864-2.412a0.25265,0.25265,0,0,0,.058-0.26839,0.24576,0.24576,0,0,0-.22542-0.1568l-1.83845-.01008,0.01774-9.68034,0.01652-3.01223,1.82431,0.01a0.24577,0.24577,0,0,0,.22712-0.15432,0.25265,0.25265,0,0,0-.05509-0.269l-2.405-2.43153A0.25948,0.25948,0,0,0,960.90574,2158.48653Z"
        transform="translate(-958.1129 -2158.16763)"
      />
    </g>
  </svg>
);

export const DnDPointIcon = (props) => (
  <Icon {...props} component={() => <DnDPointSvg {...props} />} />
);

const DnDTabSvg = ({ width = '15px', height = '15px' }) => (
  <svg viewBox="0 0 20.9316 25.8249" width={width} height={height}>
    <g id="Move_up-down" data-name="Move up-down">
      <path
        className="cls-1"
        style={{
          fill: '#e6e7e7',
          stroke: '#333',
          strokeWidth: 2,
          strokeLinecap: 'round',
          strokeLinecap: 'round',
        }}
        d="M945.48864,2176.81474c0.20779-.263-0.5511-1.18215-0.73243-1.40266-1.25377-1.52438-3.064-3.89212-5.83459-7.73364a1.74132,1.74132,0,0,1,2.44893-2.40725q2.12615,2.83885,4.25239,5.67793a1.72862,1.72862,0,0,1,3.20414-1.13842,1.50207,1.50207,0,1,1,2.73778-1.20672,2.60655,2.60655,0,0,1,1.52188-1.44449c2.08522-.5268,4.37337,3.32045,4.48731,3.51625a12.84385,12.84385,0,0,1,1.47764,6.172,16.80046,16.80046,0,0,1-.02932,1.77489q-3.50643,2.61645-7.01267,5.23307a41.94074,41.94074,0,0,1-4.79121-1.47215c-0.48068-.18-1.76728-0.77023-4.34027-1.95055a7.72441,7.72441,0,0,1-3.04884-2.05479,2.24587,2.24587,0,0,1-.74341-1.8361,1.78026,1.78026,0,0,1,1.30437-1.17849,1.05477,1.05477,0,0,1,.11219-0.022,3.94053,3.94053,0,0,1,2.23541.66373C943.76878,2176.57866,945.25328,2177.11289,945.48864,2176.81474Z"
        transform="translate(-938.38118 -2158.28079)"
      />
      <path
        className="cls-2"
        style={{
          fill: '#333',
          stroke: '#333',
          strokeWidth: 0.5,
          strokeMiterlimit: 10,
        }}
        d="M939.02624,2161.3547l2.412,2.43864a0.25265,0.25265,0,0,0,.26839.058,0.24576,0.24576,0,0,0,.1568-0.22542l0.01-1.82431,12.68546,0.04129-0.00993,1.81016a0.24576,0.24576,0,0,0,.15432.22712,0.25265,0.25265,0,0,0,.269-0.05509l2.43153-2.405a0.24757,0.24757,0,0,0,.00194-0.35355l-2.412-2.43864a0.25265,0.25265,0,0,0-.26839-0.058,0.24576,0.24576,0,0,0-.1568.22542l-0.01008,1.83845-9.68034-.01774-3.01223-.01652,0.01-1.82431a0.24576,0.24576,0,0,0-.15432-0.22712,0.25265,0.25265,0,0,0-.269.05509l-2.43153,2.405A0.25948,0.25948,0,0,0,939.02624,2161.3547Z"
        transform="translate(-938.38118 -2158.28079)"
      />
    </g>
  </svg>
);

export const DnDTabIcon = (props) => (
  <Icon component={() => <DnDTabSvg {...props} />} />
);

const AddTabSvg = ({ width = '15px', height = '15px' }) => (
  <svg viewBox="0 0 19.99891 20" width={width} height={height}>
    <g>
      <path
        className="cls-1"
        style={{ fill: '#333' }}
        d="M353.34418,510.11246H353.342c-0.07531-.00437-0.14843-0.01419-0.22156-0.024a1.45083,1.45083,0,0,0-.20737-0.02074,6.52,6.52,0,0,0-.91132.084l-0.30668.04038a10.03582,10.03582,0,0,0-8.59591,8.0513,9.82766,9.82766,0,0,0-.18663,1.82374A9.99952,9.99952,0,1,0,353.34418,510.11246Zm-0.43329,18.818a8.86494,8.86494,0,1,1,8.86548-8.86548A8.87418,8.87418,0,0,1,352.91089,528.93047Z"
        transform="translate(-342.91253 -510.06771)"
      />
      <path
        className="cls-1"
        style={{ fill: '#333' }}
        d="M358.49263,519.36055h-4.87552v-4.87416a0.704,0.704,0,0,0-1.40809,0v4.87416h-4.87416a0.704,0.704,0,1,0,0,1.40809H352.209v4.87823a0.704,0.704,0,1,0,1.40809,0v-4.87823h4.87552A0.704,0.704,0,0,0,358.49263,519.36055Z"
        transform="translate(-342.91253 -510.06771)"
      />
    </g>
  </svg>
);

export const AddTabIcon = (props) => (
  <Icon component={() => <AddTabSvg {...props} />} />
);

const NotificationBellSvg = ({ width, height }) => (
  <svg viewBox="0 0 17.90974 17.90143" width={width} height={height}>
    <g>
      <path
        className="cls-1"
        style={{ fill: '#e6e7e7' }}
        d="M311.07936,567.272v0.00317a2.39771,2.39771,0,1,0,4.79523-.00293V567.272h-4.79523Z"
        transform="translate(-304.52333 -552.79105)"
      />
      <path
        className="cls-1"
        style={{ fill: '#e6e7e7' }}
        d="M318.86469,559.18161a5.38773,5.38773,0,1,0-10.77545,0,10.53718,10.53718,0,0,1-.31317,3.34338,7.8809,7.8809,0,0,1-2.17169,3.299,0.24656,0.24656,0,0,0-.05792.28906,0.2502,0.2502,0,0,0,.24445.16211h4.68451v-0.00433h6.65942v0.00433h4.0282a0.24689,0.24689,0,0,0,.24664-0.16742,0.2279,0.2279,0,0,0-.05457-0.27271C319.28272,563.76273,318.86469,562.64438,318.86469,559.18161Z"
        transform="translate(-304.52333 -552.79105)"
      />
      <path
        className="cls-2"
        style={{ fill: '#333' }}
        d="M322.05671,565.12253c-1.866-1.866-2.192-2.75409-2.192-5.94092a6.38773,6.38773,0,1,0-12.77545,0,9.53812,9.53812,0,0,1-.26978,3.05194,6.95189,6.95189,0,0,1-1.92224,2.88336,1.26371,1.26371,0,0,0,.89368,2.15826h4.28845V567.292a3.39764,3.39764,0,1,0,6.79523-.01685H321.163a1.24523,1.24523,0,0,0,1.16907-.78125A1.22589,1.22589,0,0,0,322.05671,565.12253Zm-8.577,4.56995a2.40681,2.40681,0,0,1-2.40039-2.4173V567.272h4.79523v0.00024A2.41545,2.41545,0,0,1,313.47975,569.69248Zm7.92993-3.58472a0.24689,0.24689,0,0,1-.24664.16742h-4.0282v-0.00433h-6.65942v0.00433H305.7909a0.2502,0.2502,0,0,1-.24445-0.16211,0.24656,0.24656,0,0,1,.05792-0.28906,7.8809,7.8809,0,0,0,2.17169-3.299,10.53718,10.53718,0,0,0,.31317-3.34338,5.38773,5.38773,0,1,1,10.77545,0c0,3.46277.418,4.58112,2.49042,6.65344A0.2279,0.2279,0,0,1,321.40968,566.10776Z"
        transform="translate(-304.52333 -552.79105)"
      />
    </g>
  </svg>
);

export const NotificationBellIcon = () => (
  <Icon component={NotificationBellSvg} />
);

const HelpSvg = ({ width, height }) => (
  <svg viewBox="0 0 16.57581 17.30656" width={width} height={height}>
    <g id="Help">
      <text
        className="cls-2"
        style={{ fontSize: 15.41523, fill: '#333' }}
        transform="translate(5.15855 13.45255)"
      >
        ?
      </text>
    </g>
  </svg>
);

export const HelpIcon = () => <Icon component={HelpSvg} />;

const ShowEntireTourSvg = ({ width, height }) => (
  <svg viewBox="0 0 18.00382 18.00382" width={width} height={height}>
    <g id="Show_entire_tour" data-name="Show entire tour">
      <g id="Backward">
        <path
          className="cls-1"
          d="M935.71013,2321.69507l-15.18.00382a0.20506,0.20506,0,0,0-.20995.21005l0.00382,15.18a0.20506,0.20506,0,0,0,.21005.20995l15.18-.00382a0.20506,0.20506,0,0,0,.20995-0.21005h0l-0.00382-15.18A0.20506,0.20506,0,0,0,935.71013,2321.69507Z"
          transform="translate(-919.12019 -2320.49507)"
        />
        <path
          className="cls-2"
          d="M935.70983,2320.49507l-15.18.00382a1.40837,1.40837,0,0,0-1.40965,1.41035l0.00382,15.18a1.40837,1.40837,0,0,0,1.41035,1.40965l15.18-.00382a1.40837,1.40837,0,0,0,1.40965-1.41035l-0.00382-15.18A1.40836,1.40836,0,0,0,935.70983,2320.49507ZM935.924,2337.085h0a0.20506,0.20506,0,0,1-.20995.21005l-15.18.00382a0.20506,0.20506,0,0,1-.21005-0.20995l-0.00382-15.18a0.20506,0.20506,0,0,1,.20995-0.21005l15.18-.00382a0.20506,0.20506,0,0,1,.21005.20995Z"
          transform="translate(-919.12019 -2320.49507)"
        />
      </g>
      <polygon
        className="cls-4"
        points="6.717 4.986 11.743 3.982 11.877 4.688 6.852 5.691 6.717 4.986"
      />
      <polygon
        className="cls-4"
        points="5.63 7.43 6.267 7.004 8.606 10.909 7.969 11.335 5.63 7.43"
      />
      <circle className="cls-3" cx="9.41947" cy="12.84572" r="2.375" />
      <circle className="cls-3" cx="5.16771" cy="5.84679" r="1.875" />
    </g>
    <circle className="cls-3" cx="13.25064" cy="4.26143" r="1.33333" />
  </svg>
);

export const ShowEntireTourIcon = () => <Icon component={ShowEntireTourSvg} />;

const HomeSetPositionSvg = () => (
  <svg viewBox="0 0 18 18">
    <path
      className="cls-1"
      d="M1063.242,512.86752h-15.18a0.20506,0.20506,0,0,0-.21.21v15.18a0.20506,0.20506,0,0,0,.21.21h15.18a0.20506,0.20506,0,0,0,.21-0.21h0v-15.18A0.20506,0.20506,0,0,0,1063.242,512.86752Z"
      transform="translate(-1046.6601 -511.66752)"
    />
    <path
      className="cls-2"
      d="M1063.2501,511.66752h-15.18a1.40837,1.40837,0,0,0-1.41,1.41v15.18a1.40837,1.40837,0,0,0,1.41,1.41h15.18a1.40837,1.40837,0,0,0,1.41-1.41v-15.18A1.40837,1.40837,0,0,0,1063.2501,511.66752Zm0.21,16.59h0a0.20506,0.20506,0,0,1-.21.21h-15.18a0.20506,0.20506,0,0,1-.21-0.21v-15.18a0.20506,0.20506,0,0,1,.21-0.21h15.18a0.20506,0.20506,0,0,1,.21.21v15.18Z"
      transform="translate(-1046.6601 -511.66752)"
    />
    <path
      className="cls-3"
      d="M1060.61375,519.71361l-0.00072-.00072-4.27825-4.27809a0.96531,0.96531,0,0,0-1.36548-.00008l-4.276,4.27593-0.00432.0044a0.9651,0.9651,0,0,0,.64253,1.645l0.02977,0.00144h0.17052v3.14842a1.13126,1.13126,0,0,0,1.13008,1.12992h1.67379a0.30729,0.30729,0,0,0,.30726-0.30726v-2.46835a0.5161,0.5161,0,0,1,.51555-0.51555h0.98725a0.5161,0.5161,0,0,1,.51555.51555v2.46835a0.30724,0.30724,0,0,0,.30726.30726h1.67379a1.13126,1.13126,0,0,0,1.13008-1.12992v-3.14842h0.15811A0.9656,0.9656,0,0,0,1060.61375,519.71361Z"
      transform="translate(-1046.6601 -511.66752)"
    />
  </svg>
);

export const HomeSetPositionIcon = () => (
  <Icon component={HomeSetPositionSvg} />
);

const AreaFilterSvg = ({ width, height }) => (
  <svg
    id="Tourstart_Tour_Finder"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17.74 18.635"
    width={22}
    height={22}
  >
    <g id="TTF_-_Icon_form_search_field">
      <path
        d="M1153.1,326.977l2.44-5.46,1.865-.809,4.245,3.86,4.4-3.86,1.786,0.809,2.5,5.46-3.115-1.071-5.505,2.381-5.532-2.361Z"
        transform="translate(-1152.854 -309.901)"
        style={{
          fill: 'none',
          stroke: '#5f378f',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '0.5px',
        }}
      />
      <path
        id="Search_result"
        d="M1166.7,311.023a1.175,1.175,0,0,0-1.222-1.122h-7.5a1.175,1.175,0,0,0-1.222,1.122v6.443a1.055,1.055,0,0,0,.22.64h0l0.033,0.037a1.183,1.183,0,0,0,.286.254l4.432,3.933,4.432-3.933c0.1-.1.191-0.159,0.289-0.257l0.031-.035h0a1.052,1.052,0,0,0,.22-0.64v-6.443Z"
        transform="translate(-1152.854 -309.901)"
        style={{ fill: '#5f378f' }}
      />
      <g id="Tour">
        <path
          d="M1160.516,313.812H1159.2a0.152,0.152,0,0,0-.16.142v1.131a0.13,0.13,0,0,0,.028.079,0.172,0.172,0,0,0,.041.038l0.749,0.664,0.742-.658c0.008-.008.017-0.016,0.027-0.024l0.021-.019a0.13,0.13,0,0,0,.028-0.08v-1.131A0.152,0.152,0,0,0,1160.516,313.812Z"
          transform="translate(-1152.854 -309.901)"
          style={{ fill: '#fff' }}
        />
        <path
          d="M1160.516,313.7H1159.2a0.261,0.261,0,0,0-.269.252v1.131a0.239,0.239,0,0,0,.05.145l0.007,0.008a0.228,0.228,0,0,0,.056.051l0.814,0.722,0.816-.725,0.022-.019a0.389,0.389,0,0,0,.031-0.028l0.008-.009a0.238,0.238,0,0,0,.05-0.145v-1.131A0.261,0.261,0,0,0,1160.516,313.7Zm0.16,1.382a0.13,0.13,0,0,1-.028.08l-0.021.019c-0.01.008-.019,0.016-0.027,0.024l-0.742.658-0.749-.664a0.172,0.172,0,0,1-.041-0.038,0.13,0.13,0,0,1-.028-0.079v-1.131a0.152,0.152,0,0,1,.16-0.142h1.317a0.152,0.152,0,0,1,.16.142v1.131Z"
          transform="translate(-1152.854 -309.901)"
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: 10,
            strokeWidth: '0.5px',
          }}
        />
        <path
          d="M1164.661,311.63h-1.317a0.152,0.152,0,0,0-.16.142V312.9a0.13,0.13,0,0,0,.028.079,0.172,0.172,0,0,0,.041.038l0.749,0.664,0.742-.658c0.008-.008.017-0.016,0.027-0.024l0.021-.019a0.13,0.13,0,0,0,.028-0.08v-1.131A0.152,0.152,0,0,0,1164.661,311.63Z"
          transform="translate(-1152.854 -309.901)"
          style={{ fill: '#fff' }}
        />
        <path
          d="M1164.661,311.521h-1.317a0.261,0.261,0,0,0-.269.252V312.9a0.239,0.239,0,0,0,.05.145l0.007,0.008a0.228,0.228,0,0,0,.056.051L1164,313.83l0.816-.725,0.022-.019a0.389,0.389,0,0,0,.031-0.028l0.008-.009a0.238,0.238,0,0,0,.05-0.145v-1.131A0.261,0.261,0,0,0,1164.661,311.521Zm0.16,1.382a0.13,0.13,0,0,1-.028.08l-0.021.019c-0.01.008-.019,0.016-0.027,0.024l-0.742.658-0.749-.664a0.172,0.172,0,0,1-.041-0.038,0.13,0.13,0,0,1-.028-0.079v-1.131a0.152,0.152,0,0,1,.16-0.142h1.317a0.152,0.152,0,0,1,.16.142V312.9Z"
          transform="translate(-1152.854 -309.901)"
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: 10,
            strokeWidth: '0.5px',
          }}
        />
        <path
          d="M1164,315.37a0.651,0.651,0,1,1,.651-0.651A0.651,0.651,0,0,1,1164,315.37Zm0-1.011a0.36,0.36,0,1,0,.36.36A0.36,0.36,0,0,0,1164,314.359Z"
          transform="translate(-1152.854 -309.901)"
          style={{ fill: '#fff' }}
        />
        <path
          d="M1164.006,314.157a0.57,0.57,0,1,0,.57.57A0.57,0.57,0,0,0,1164.006,314.157Z"
          transform="translate(-1152.854 -309.901)"
          style={{ fill: '#fff' }}
        />
        <path
          d="M1159.855,317.578a0.651,0.651,0,1,1,.651-0.651A0.651,0.651,0,0,1,1159.855,317.578Zm0-1.01a0.36,0.36,0,1,0,.36.36A0.36,0.36,0,0,0,1159.855,316.567Z"
          transform="translate(-1152.854 -309.901)"
          style={{ fill: '#fff' }}
        />
        <path
          d="M1159.857,316.386a0.549,0.549,0,1,0,.549.549A0.549,0.549,0,0,0,1159.857,316.386Z"
          transform="translate(-1152.854 -309.901)"
          style={{ fill: '#fff' }}
        />
        <path
          id="_Path_"
          d="M1160.33,316.978c1.843-.05,2.223-0.139,2.292-0.556,0.089-.538-0.751-0.75-0.619-1.182,0.072-.235.512-0.317,1.409-0.453"
          transform="translate(-1152.854 -309.901)"
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: 10,
            strokeWidth: '0.5px',
          }}
        />
      </g>
    </g>
  </svg>
);

export const AreaFilterIcon = () => <Icon component={AreaFilterSvg} />;

const NafSvg = ({ width = '22px', height = '22px' }) => (
  <svg viewBox="0 0 505.48 500.25" width="22px" height="22px">
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          className="cls-1"
          style={{ fill: '#1a1a1a' }}
          d="M505.39,302.34c-1.93-29.67-26.65-47.22-45.06-58.63l-65-40.05c-28.27-17.76-39.93-43.61-26.85-67.47,5.58-10.14,14.93-17.76,23.48-19.67a22,22,0,0,1,15.09,1.93c3.27,1.67,6.4,4.74,7.38,7,5.36,12.15-10.2,15.28-12.56,29.86-3.43,21.07,18.32,25.19,18.32,25.19a29.84,29.84,0,0,1,3.8-9.68c26.05-38.78,1.88-56.34-3.22-60.07a40.43,40.43,0,0,0-32-6.37c-8.84,2-23.9,9-33.93,26.24C336.54,162,348.5,193,384.05,217.35L447.45,260c16.16,10.89,36.08,23.68,33.68,46.47-1.27,12.13-5.42,17.55-15.16,22.65-12.08,6.35-33.26,1.55-50.84-7.58-57.13-29.62-110.3-83.71-116.74-129.9,27-70.11,23.09-117.17-8.86-156.09C256.83-4.29,198.35-2.61,192.82,2.92l-9,26.44c-15.89,8.72-28,24.62-28,24.62l-2.42,9.21s-30.54,28.58-26.65,35.37,14.66,14.55,14.66,14.55,5.17-12.57,20.7-12.61c16.9-.06,19.32,17.6,13.58,24.72-5.91,7.33-23.25,8.73-23.25,8.73l15,18.11s4.39-5.92,16.15-16.47c7.08-6.35,15.25,2.09,9.1,9-5.93,6.69-23.74,27.62-36.34,49.9-22.57,39.94-12.43,68.88-3.34,84.11-7.65,17.24-31.57,71.29-32.44,72.87-6.7,12-31.51,20.07-38.77,22.85A84.56,84.56,0,0,0,79.26,394v.24a26.94,26.94,0,0,0,.77,6.32.24.24,0,0,1,0,.09,27,27,0,1,0,51.42-16.22c5.33-5.59,69.64-73,70.7-73.87,1.88-1.61,5.27-6.84,5.53-13.21v-9.92a5.91,5.91,0,1,1,11.81,0v28.51c31.94,2.18,54,7.56,84.29,21.82l12-5.38c6.49,6.48,19,67.53,19,67.53s64.91,32.46,81.81,40.68,6.92,17.74,3.89,22.95-12.55,14.27-12.55,14.27a267.23,267.23,0,0,1-31.87-4.1c-6.85,5.21-10.34,19.08-11.5,24.87h61.37c4.32-7.23,30.92-40.25,30.92-40.25.86-11.23-3.55-29.35-18.08-51.65-11.81-18.14-15.55-35.95-18.34-53.55,30.24,9.35,54.57.71,67.92-10.84C499.2,332.91,506.39,317.82,505.39,302.34Zm-336.57-232-5.19-7.95s12-6.1,21.2-4.67C184.83,57.76,174.63,63.11,168.82,70.38Z"
        />
        <path
          className="cls-1"
          style={{ fill: '#1a1a1a' }}
          d="M324.06,402.1c-2.12-10.22-3.47-16.39-7.05-31.16-4.21-17.33-13.06-21-16.27-22.53-2.48-1.16-4.9-2.25-7.27-3.32-4.13,3.19-17.59,26-5.76,51.72,5.1,11.11,12.56,35.51,14.7,45.91,3.66,17.46.19,20.67-3.87,25.08a63.62,63.62,0,0,1-12.56,10,28.74,28.74,0,0,0-3.66.12c-5.71-.5-17.86-1.62-29-3.76-6.42,5.54-10.17,18.38-11.44,24.41H303l38-42.82c.59-8.06.85-16,3-39l-14-7A10.94,10.94,0,0,1,324.06,402.1Z"
        />
        <path
          className="cls-1"
          style={{ fill: '#1a1a1a' }}
          d="M166.59,364.66a67.1,67.1,0,1,1-60.37-37.8,67.91,67.91,0,0,1,12,1.12c5.36-12.07,16.13-36.41,16.13-36.41A106.24,106.24,0,0,0,45.67,481.31a.8.8,0,0,1,.19.13,110.49,110.49,0,0,0,12.91,7.66c.23.09.44.21.66.3,1,.49,1.94.94,2.91,1.41a7.36,7.36,0,0,1,.86.35c1,.45,2,.88,2.94,1.27a7.71,7.71,0,0,1,.84.33c1,.4,2,.81,3.08,1.18l.49.16a104.6,104.6,0,0,0,14.57,4.07c.24,0,.48.09.73.13.4.08.79.17,1.2.23h.19a105.58,105.58,0,0,0,38,0h.31a106.23,106.23,0,0,0,69.21-163.38S176,354.8,166.59,364.66Z"
        />
        <path
          className="cls-1"
          style={{ fill: '#1a1a1a' }}
          d="M167,114c-22.16-2.41-25.48,22.08-46.82,15.23,0,0,4.41,9.78,15,8.07C147.53,135.29,148.14,118.56,167,114Z"
        />
      </g>
    </g>
  </svg>
);

export const NafIcon = () => <Icon component={NafSvg} />;
